import { auditBlockRo } from './auditLocales'

const ro = {
  iconPicker: {
    title: 'Alege o pictogramă',
    titlePhoto: 'Alege o fotografie',
    searchPlaceholder: 'Caută pictograme...',
    background: 'Fundal',
    customColor: 'Culoare personalizată',
    colors: {
      teal: 'Turcoaz',
      blue: 'Albastru',
      indigo: 'Indigo',
      violet: 'Violet',
      fuchsia: 'Fucsia',
      pink: 'Roz',
      red: 'Roșu',
      amber: 'Chihlimbar',
      emerald: 'Smarald',
      cyan: 'Cyan',
      slate: 'Ardezie',
      deepCyan: 'Cyan închis',
      purple: 'Purpuriu'
    },
    tabIcons: 'Pictograme',
    tabPhoto: 'Imaginea mea',
    photoDrop: 'Trage o imagine aici sau',
    photoReplace: 'Înlocuiește imaginea sau',
    photoDropAction: 'alege un fișier',
    photoRemove: 'Șterge',
    photoHint:
      'PNG, JPG, SVG · până la {{size}} MB · minimum {{pixels}}×{{pixels}}',
    photoTypeError: 'Se acceptă doar imagini PNG, JPG sau SVG.',
    photoSizeError: 'Fișierul depășește {{size}} MB.',
    photoDimensionError: 'Imaginea este mai mică de {{size}}×{{size}}.',
    select: 'Selectează',
    emptyTitle: 'Nicio pictogramă găsită',
    emptyDescription: 'Încearcă alt termen de căutare.'
  },
  agents: {
    scopes: {
      app: {
        core: 'Core',
        crm: 'CRM',
        hrm: 'HRM',
        notification: 'Notificări',
        squad: 'Squad'
      },
      action: {
        read: 'Citire',
        write: 'Scriere',
        manage: 'Administrare',
        provision: 'Provizionare',
        invoke: 'Apelare'
      },
      gatedHint: 'Conectați instrumentele {{app}} pentru a acorda acest acces.',
      gatedConnect: 'Conectează instrumente'
    }
  },
  tickets: {
    create: 'Creează tichet',
    submitTab: 'Trimite tichet',
    myTicketsTab: 'Tichetele mele',
    cancel: 'Anulează',
    submit: 'Trimite',
    successCreate: 'Tichetul a fost creat cu succes',
    ticket: 'Tichet',
    example: 'Eroare de autentificare în sistem.',
    description: 'Descriere',
    example_description:
      'La autentificare apare un mesaj de eroare. Este necesară o verificare urgentă.',
    attachments: 'Atașamente',
    dragAndDrop: 'Trage și plasează fișiere aici sau',
    selectFile: 'selectează',
    uploadHint: 'Acceptă încărcare individuală sau în masă.',
    status: 'Stare',
    statuses: {
      open: 'Deschis',
      inProgress: 'În lucru',
      pending: 'În așteptare',
      solved: 'Rezolvat',
      completed: 'Finalizat'
    },
    statusFilter: 'Filtru',
    open: 'Deschise',
    closed: 'Închise',
    createdOn: 'Creat',
    startDate: 'Data început',
    dueDate: 'Termen',
    noComments: 'Niciun comentariu încă',
    commentPlaceholder: 'Adaugă un răspuns...',
    commentAdded: 'Comentariul a fost adăugat cu succes',
    closedChatReadOnly:
      'Acest tichet este închis. Conversația este doar pentru citire.',
    commentFromClickup: 'Suport',
    commentsLoadError: 'Comentariile nu au putut fi încărcate',
    noTickets: 'Niciun tichet încă. Trimite un tichet din prima filă.',
    listError: 'Tichetele nu au putut fi încărcate',
    retry: 'Reîncearcă',
    originalRequest: 'Solicitarea inițială',
    detailsLoadError: 'Detaliile tichetului nu au putut fi încărcate',
    priority: {
      label: 'Prioritate',
      urgent: 'Urgent',
      high: 'Ridicată',
      normal: 'Normală',
      low: 'Scăzută'
    },
    opened: 'Deschis',
    activity: 'Activitate',
    emoji: 'Emoji',
    hasUpdate: 'Are o actualizare'
  },
  common: {
    retry: 'Reincearca',
    backToLogin: 'Inapoi la autentificare',
    comingSoon: 'În curând',
    cancel: 'Anulează',
    edit: 'Editează',
    delete: 'Șterge'
  },
  errors: {
    somethingWentWrong: 'Ceva nu a functionat. Va rugam incercati din nou.'
  },
  not_found: {
    title: 'Pagina nu a fost gasita',
    back_home: 'Inapoi la pagina principala'
  },
  ui: {
    loading: 'Se încarcă',
    loadError: 'Nu s-a putut încărca conținutul',
    loadErrorDescription: 'Verifică conexiunea și încearcă din nou.',
    retry: 'Încearcă din nou',
    breadcrumb: 'Breadcrumb',
    tableEmpty: 'Nu există date',
    noValue: '—'
  },
  placeholders: {
    name: 'Introduceți numele',
    description: 'Introduceți descrierea',
    email: 'utilizator@exemplu.com',
    fullName: 'Introduceți numele complet',
    appName: 'Introduceți numele aplicației',
    teamName: 'Introduceți numele echipei',
    roleName: 'Introduceți numele rolului',
    functionName: 'Introduceți numele funcției',
    displayName: 'Introduceți numele afișat',
    connectionName: 'Introduceți numele conexiunii',
    credentialName: 'Introduceți numele credențialului',
    webhookName: 'Introduceți numele webhook-ului',
    webhookUrl: 'https://exemplu.com/webhook',
    clientId: 'Introduceți ID-ul clientului',
    clientSecret: 'Introduceți secretul clientului',
    abbreviation: 'ex. ING',
    scope: 'openid profile email',
    issuerUrl: 'https://emitent.exemplu.com/',
    jwksUrl: 'https://exemplu.com/.well-known/jwks.json',
    authorizeUrl: 'https://exemplu.com/authorize',
    tokenUrl: 'https://exemplu.com/token'
  },
  audit: auditBlockRo,
  welcome_back: 'Bine ai revenit',
  sign_in: 'Autentifică-te',
  sign_up: 'Înregistrează-te',
  welcome_to_skalx: 'Bun venit la Skalx',
  sign_up_to_create: 'Înregistrează-te pentru a-ți crea contul',
  auth_hero_title: 'Un singur cont pentru toate aplicațiile Skalx',
  auth_hero_subtitle:
    'Gestionează-ți organizațiile, echipele și accesul dintr-o singură identitate sigură.',
  auth_hero_feature_sso: 'Autentificare unică în toată suita',
  auth_hero_feature_orgs: 'Organizații, echipe și roluri într-un singur loc',
  auth_hero_feature_security: 'Securitate, sesiuni și audit incluse',
  next: 'Următorul',
  have_account: 'Ai deja un cont?',
  have_questions: 'Ai întrebări?',
  contact_us: 'Contactează-ne',
  company_name: 'Numele companiei',
  domain: 'Domeniu',
  email: 'Email',
  phone_number: 'Număr de telefon',
  password: 'Parolă',
  input_placeholder_password: 'Introduceți parola',
  i_agree: 'Sunt de acord cu',
  terms_and_conditions: 'Termenii și condițiile',
  terms_title: 'Termeni și condiții',
  terms_updated: 'Data intrării în vigoare: 29 ianuarie 2026',
  terms_intro:
    'Acești Termeni reglementează accesul la contul EBS și utilizarea serviciului. Prin crearea unui cont sau utilizarea serviciului, accepți acești Termeni.',
  terms_section_acceptance_title: 'Acceptare',
  terms_section_acceptance_body:
    'Trebuie să ai capacitatea de a încheia un acord și să folosești serviciul doar conform legii.',
  terms_section_account_title: 'Securitatea contului',
  terms_section_account_body:
    'Ești responsabil pentru confidențialitatea credențialelor și pentru toate activitățile din contul tău.',
  terms_section_use_title: 'Utilizare acceptabilă',
  terms_section_use_body:
    'Nu abuza de serviciu, nu îi întrerupe funcționarea și nu îl accesa în mod neautorizat.',
  terms_section_privacy_title: 'Confidențialitate',
  terms_section_privacy_body:
    'Prelucrăm datele personale conform legii aplicabile și practicilor noastre de confidențialitate.',
  terms_section_availability_title: 'Disponibilitate',
  terms_section_availability_body:
    'Serviciul este furnizat „ca atare” și poate fi modificat, întrerupt sau oprit fără notificare prealabilă.',
  terms_section_changes_title: 'Modificări și încetare',
  terms_section_changes_body:
    'Putem actualiza acești Termeni sau suspenda accesul în caz de încălcări ori riscuri de securitate.',
  terms_contact: 'Întrebări despre acești Termeni? Contactează-ne la',
  password_repeat: 'Repetă parola',
  passwords_must_match: 'Parolele trebuie să fie identice',
  created_by: 'Creat de',
  brand: {
    visitWebsite: 'Vizitează skalx.ai'
  },
  required_field_error: 'Acest câmp este obligatoriu',
  form_validation_error: 'Vă rugăm să corectați erorile din formular',
  first_name: 'Prenume',
  last_name: 'Nume de familie',
  registration_success: 'Înregistrarea a fost finalizată cu succes',
  back: 'Înapoi',
  continue: 'Continuă',
  registration_check_email:
    'Verificați e-mailul — v-am trimis un link de confirmare',
  registration_email_sent_title: 'Verificați e-mailul',
  registration_email_sent_description:
    'Am trimis un link de confirmare la {{email}}. Deschideți-l pentru a seta parola și a finaliza înregistrarea.',
  registration_confirm_title: 'Setați parola',
  registration_confirm_description:
    'Creați o parolă pentru a finaliza înregistrarea',
  registration_confirm_missing_token_title: 'Link de confirmare nevalid',
  registration_confirm_missing_token_description:
    'Link-ul nu conține un token de confirmare. Deschideți ultimul e-mail primit sau începeți înregistrarea din nou.',
  registration_token: 'Token de confirmare',
  registration_token_placeholder: 'Lipiți tokenul din e-mail',
  invalid_domain_format:
    'Domeniul trebuie să înceapă cu o literă, să se termine cu o literă sau cifră și să conțină doar litere mici, cifre și cratime simple',
  password_min_length: 'Parola trebuie să aibă cel puțin 8 caractere',
  password_policy:
    'Parola trebuie să aibă cel puțin 10 caractere, o literă mare, un număr și un caracter special din această listă (!@#$%^&*()_+)',
  registration: 'Înregistrare',
  sign_in_your_account: 'Autentifică-te în contul tău',
  do_not_have_account: 'Nu ai un cont?',
  forgot_password: 'Ai uitat parola?',
  submit: 'Trimite',
  enter_email_send_new_one:
    'Introdu adresa ta de email și îți vom trimite unul nou',
  check_email_instruction:
    'Verifică emailul pentru linkul de resetare a parolei. Dacă nu îl găsești, verifică dosarul de spam.',
  reset_password_again: 'Încearcă din nou sau folosește alt email',
  reset_password_missing_token_title: 'Link de resetare nevalid',
  reset_password_missing_token_description:
    'Acest link nu conține un token de resetare. Solicitați un nou email de resetare a parolei pentru a continua.',
  reset_password_request_new_link: 'Solicită un nou link',
  invitation_title: 'Alătură-te {{organization}}',
  invitation_subtitle: 'Configurează-ți contul pentru a accepta invitația',
  invitation_email_hint: 'Invitația a fost trimisă la {{email}}',
  invitation_accept: 'Acceptă invitația',
  invitation_accepted: 'Invitație acceptată — autentifică-te pentru a continua',
  invitation_existing_account:
    'Ai deja un cont. Autentifică-te și spațiul de lucru te va aștepta.',
  invitation_sign_in_to_join: 'Autentifică-te pentru a te alătura',
  invitation_missing_token_title: 'Linkul invitației nu este valid',
  invitation_missing_token_description:
    'Linkului îi lipsește tokenul invitației. Deschide cea mai recentă invitație din e-mail.',
  invitation_invalid_title: 'Această invitație nu mai poate fi folosită',
  invitation_invalid_description:
    'Poate a expirat, a fost revocată sau a fost deja acceptată. Cere unui administrator al spațiului de lucru să trimită una nouă.',
  login_success: 'Autentificare reușită',
  auth: {
    signInWithGoogle: 'Autentificare cu Google',
    signUpWithGoogle: 'Înregistrare cu Google',
    signUpWithApple: 'Înregistrare cu Apple',
    signInWithApple: 'Autentificare cu Apple',
    signInWithPasskey: 'Autentificare cu passkey',
    signInWithCustomProvider: 'Autentificare cu {{name}}',
    passkeyRecommendation: {
      title: 'Securizează contul cu un passkey',
      description:
        'Folosește amprenta, recunoașterea facială sau blocarea ecranului pentru autentificare mai rapidă și mai sigură.',
      setup: 'Configurează passkey',
      later: 'Mai târziu',
      dontAsk: 'Nu mai întreba',
      nameLabel: 'Numele passkey',
      namePlaceholder: 'ex. Laptopul meu',
      success: 'Passkey adăugat! Acum te poți autentifica cu el.',
      alreadyRegistered: 'Acest dispozitiv are deja un passkey configurat'
    },
    signInWithEntraid: 'Autentificare cu Microsoft',
    or: 'sau continuă cu',
    resendCooldownHint: 'Așteaptă puțin înainte de a retrimite.',
    resendInSeconds_one: 'Poți retrimite peste {{count}} secundă.',
    resendInSeconds_few: 'Poți retrimite peste {{count}} secunde.',
    resendInSeconds_other: 'Poți retrimite peste {{count}} de secunde.',
    passwordSignInUnavailable:
      'Autentificarea cu parolă nu este disponibilă în acest moment.',
    mfaRequired: 'Este necesară o verificare suplimentară. Verificați emailul.',
    mfa: {
      otpTitle: 'Verificați identitatea',
      otpDescription:
        'Am trimis un cod de verificare pe emailul dumneavoastră. Introduceți-l mai jos pentru a continua.',
      otpLabel: 'Cod de verificare',
      otpRequired: 'Vă rugăm introduceți codul de verificare',
      codeExpired: 'Codul a expirat. Solicitați unul nou.',
      codeExpiresIn: 'Codul expiră în {{time}}',
      keepMeLoggedIn: 'Păstrează-mă autentificat pe acest dispozitiv',
      resendOtp: 'Retrimite codul',
      otpSent: 'Un nou cod a fost trimis pe emailul dumneavoastră',
      moreOptions: 'Mai multe opțiuni',
      useBackupCode: 'Folosește un cod backup',
      backupCodeTitle: 'Cod backup',
      backupCodeDescription:
        'Introduceți unul din codurile de recuperare pentru a vă autentifica.',
      backupCodeLabel: 'Cod backup',
      backupCodeRequired: 'Vă rugăm introduceți codul backup',
      tokenExpired: 'Sesiunea a expirat. Vă rugăm autentificați-vă din nou.'
    },
    emailOtp: {
      title: 'Autentificare cu email',
      subtitle: 'Introduceți adresa de email — vă trimitem un cod unic.',
      emailLabel: 'Adresă de email',
      emailPlaceholder: 'you@example.com',
      emailRequired: 'Vă rugăm introduceți email-ul',
      emailInvalid: 'Introduceți o adresă de email validă',
      submit: 'Continuă',
      codeTitle: 'Introduceți codul de verificare',
      codeSubtitle:
        'Am trimis un cod la <email>{{email}}</email>. Introduceți-l pentru a vă autentifica.',
      codeLabel: 'Cod de verificare',
      codeRequired: 'Vă rugăm introduceți codul',
      codeExpired: 'Codul a expirat. Solicitați unul nou.',
      codeExpiresIn: 'Codul expiră în {{time}}',
      codeSent: 'Un nou cod a fost trimis pe email',
      resend: 'Retrimite codul',
      shortLabel: 'Email',
      useOtpInstead: 'Autentifică-te cu un cod unic',
      usePasswordInstead: 'Autentifică-te cu parolă',
      backToSignIn: 'Înapoi la autentificare',
      tokenExpired: 'Sesiunea de autentificare a expirat. Încercați din nou.',
      linkSentTitle: 'Verifică email-ul',
      linkSentSubtitle:
        'Am trimis un link de autentificare la <email>{{email}}</email>. Apasă butonul din email pentru a te autentifica.',
      linkResend: 'Retrimite email-ul',
      or: 'sau',
      enterCodeInstead: 'Introdu codul manual',
      useLinkInstead: 'Folosește link-ul din email',
      linkCallback: {
        verifying: 'Vă autentificăm…',
        subtitle: 'Așteptați în timp ce verificăm link-ul de autentificare.',
        errorTitle: 'Link-ul de autentificare nu mai este valid',
        errorBody:
          'Acest link nu mai poate fi folosit. Solicită un cod nou sau folosește codul din 6 cifre din email.',
        backToSignIn: 'Înapoi la autentificare'
      }
    },
    qrSignIn: {
      title: 'Autentificare cu cod QR',
      subtitle:
        'Deschide aplicația mobilă Skalx pe un dispozitiv unde ești deja autentificat, apoi scanează acest cod.',
      useQrInstead: 'Autentificare cu cod QR',
      refresh: 'Reîncarcă',
      heroTitle: 'Autentificare cu cod QR',
      heroDescription:
        'Scanează codul cu camera telefonului pentru a te autentifica instant.',
      waiting: 'Așteptăm scanarea. Codul expiră în {{seconds}} s.',
      scanned: 'Cod scanat. Confirmă autentificarea pe telefon.',
      tryAgain: 'Încearcă din nou',
      cancel: 'Anulează autentificarea QR',
      deniedToast: 'Autentificarea QR a fost anulată pe telefon.',
      canceledToast: 'Autentificarea QR a fost anulată.',
      expired: {
        title: 'Cod expirat',
        description:
          'Acest cod QR nu mai este activ. Generează un cod nou pentru a continua.'
      },
      denied: {
        title: 'Autentificare anulată',
        description:
          'Cererea a fost respinsă pe telefon. Începe din nou dacă ai inițiat tu această autentificare.'
      },
      canceled: {
        title: 'Autentificare QR anulată',
        description: 'Începe din nou când ești gata să scanezi un cod nou.'
      },
      error: {
        title: 'Autentificarea QR nu este disponibilă',
        description:
          'Nu am putut începe sau continua autentificarea QR. Încearcă din nou.'
      },
      approved: {
        title: 'Aprobat',
        description: 'Finalizăm autentificarea...'
      }
    },
    noLoginMethodsEnabled:
      'Nu sunt activate metode de autentificare pentru această organizație. Contactați administratorul.',
    googleCallbackMissingParams:
      'Răspuns de autentificare invalid. Încercați din nou.',
    googleNotLinkedToOrg:
      'Conectarea Google nu este asociată acestei organizații. Asociați Google din profil sau autentificați-vă cu altă metodă.',
    register: {
      accountTitle: 'Creează-ți contul',
      accountSubtitle:
        'Începe cu contul personal. Poți adăuga sau te poți alătura workspace-urilor după autentificare.',
      switchToWorkspaceFlow:
        'Înregistrare cu creare workspace într-un singur flux',
      switchToAccountFlow:
        'Înregistrare doar cu cont (workspace opțional mai târziu)',
      accountContinuesToWorkspaceSetup:
        'Continuă prin crearea primului workspace. Când API o va permite, acest pas poate fi omis pentru înregistrarea doar cu cont.',
      accountLinkShort: 'Înregistrare (doar cont)'
    },
    onboarding: {
      title: 'Finalizați configurarea',
      description: 'Creați prima organizație pentru a începe.',
      tokenReady: 'Puteți continua în pasul următor.',
      createOrganization: 'Creați organizația',
      missingToken:
        'Link invalid sau lipsă. Vă rugăm să vă autentificați din nou.'
    }
  },
  email_sent_success: 'Email trimis cu succes',
  password_reset_success: 'Resetarea parolei a fost realizată cu succes',
  reset_password: 'Resetează parola',
  enter_new_password: 'Introduceți o parolă nouă',
  logout: 'Ieșire',
  menu: {
    organizations: 'Organizații',
    home: 'Acasă',
    account: 'Cont',
    workspaces: 'Spații de lucru',
    billing: 'Facturare'
  },
  shell: {
    menu: {
      home: 'Acasă',
      overview: 'Sumar',
      users: 'Utilizatori',
      roles: 'Roluri',
      organization: 'Organizație',
      ssoSaml: 'SSO & SAML',
      authentication: 'Autentificare',
      apps: 'Aplicații',
      agents: 'Agenți',
      domains: 'Domenii',
      publicAccess: 'Acces public',
      aiConnectors: 'Conectori AI',
      auditLog: 'Jurnal audit',
      companyGraph: 'Graficul companiei',
      workspaceSettings: 'Setări spațiu',
      billing: 'Facturare',
      createWorkspace: 'Creează spațiu',
      comingSoon: 'În curând',
      groups: {
        gettingStarted: 'Primii pași',
        workspace: 'Spațiu de lucru',
        identity: 'Identitate',
        applications: 'Aplicații',
        developers: 'Dezvoltatori',
        compliance: 'Conformitate',
        settings: 'Setări'
      },
      tags: {
        ai: 'AI',
        preview: 'Previzualizare'
      }
    },
    welcome: {
      greeting: 'Bine ai venit în'
    },
    switcher: {
      switchWorkspace: 'Schimbă spațiul',
      accountSettings: 'Setări cont',
      createWorkspace: 'Creează spațiu nou',
      signOut: 'Ieșire',
      ariaLabel: 'Spațiu activ',
      noWorkspace: 'Niciun spațiu',
      noWorkspaceMeta: 'Creează unul pentru a începe'
    },
    user: {
      accountSettings: 'Setări cont',
      signOut: 'Ieșire',
      fallback: 'Utilizator'
    },
    topbar: {
      searchPlaceholder: 'Caută…',
      docs: 'Documentație',
      openWorkspace: 'Deschide workspace — {{url}}',
      language: 'Limbă',
      theme: 'Temă',
      themeMode: {
        light: 'Luminos',
        dark: 'Întunecat',
        system: 'Sistem'
      }
    },
    sidebar: {
      expand: 'Extinde',
      collapse: 'Restrânge'
    },
    gettingStarted: {
      title: 'Primii pași',
      progress: '{{done}}/{{total}}',
      encouragement: 'Continuă așa!',
      more: 'Acțiuni pentru listă',
      learnMore: 'Află mai multe',
      hideForDays: 'Ascunde {{days}} zile',
      dismiss: 'Ascunde definitiv',
      errors: {
        generic:
          'Pasul nu a putut fi finalizat. Deschide pagina lui și încearcă din nou.',
        code_expired: 'Codul de verificare a expirat. Cere unul nou.',
        code_invalid: 'Codul de verificare nu a fost acceptat.',
        m365_admin_consent_required:
          'Un administrator Microsoft 365 trebuie să aprobe această conexiune.',
        domain_not_verified: 'Domeniul nu a fost încă verificat.',
        import_parse_failed: 'Fișierul importat nu a putut fi citit.',
        provisioning_failed:
          'Pregătirea spațiului de lucru a eșuat. Reîncearcă din setările spațiului.'
      },
      dismissModal: {
        title: 'Ascunzi lista?',
        subtitle: 'Spune-ne de ce și nu mai apare.',
        reasons: {
          already_set_up: 'Am configurat deja în felul meu',
          not_relevant: 'Nu e relevant pentru rolul meu',
          later: 'O fac mai târziu',
          not_interested: 'Nu mă interesează'
        }
      },
      items: {
        invite_users: {
          title: 'Invită echipa',
          description:
            'Trimite invitații colegilor — un spațiu de lucru prinde viață când are și alte persoane în el.',
          cta: 'Invită'
        },
        roles: {
          title: 'Roluri și permisiuni',
          description:
            'Descrie cine are dreptul la ce: construiește roluri din permisiuni, în loc să le acorzi persoană cu persoană.',
          cta: 'Configurează'
        },
        authentication: {
          title: 'Configurează autentificarea',
          description:
            'Conectează SSO sau propriul provider, ca echipa să intre cu contul de lucru.',
          cta: 'Configurează'
        },
        workspace_settings: {
          title: 'Verifică setările',
          description:
            'Nume, logo, domenii și fus orar — detaliile pe care le vede fiecare membru al spațiului de lucru.',
          cta: 'Verifică'
        },
        profile: {
          title: 'Completează profilul',
          description:
            'Numele și fotografia sunt felul în care colegii te recunosc în liste, mențiuni și jurnalul de activitate.',
          cta: 'Completează'
        },
        security: {
          title: 'Protejează contul',
          description:
            'Adaugă o passkey sau activează autentificarea în doi pași, ca o parolă singură să nu fie de ajuns.',
          cta: 'Protejează'
        },
        apps: {
          title: 'Vezi aplicațiile',
          description:
            'Aplicațiile acestui spațiu de lucru sunt cele în care vei lucra zi de zi. Aruncă o privire.',
          cta: 'Aruncă o privire'
        }
      }
    },
    footer: {
      ariaLabel: 'Subsolul site-ului',
      brand: 'Skalx',
      poweredBy: 'Powered by',
      versionTooltip: 'Versiunea build a aplicației',
      status: {
        operational: 'Toate sistemele funcționează normal',
        tooltip: 'Status în timp real — status.skalx.ai'
      },
      links: {
        docs: 'Documentație',
        status: 'Status',
        changelog: 'Noutăți',
        privacy: 'Confidențialitate',
        support: 'Suport'
      }
    },
    account: {
      profile: 'Profil de bază',
      authentication: 'Autentificare',
      security: 'Securitate',
      notifications: 'Notificări',
      activity: 'Activitate',
      audit: 'Audit',
      sessions: 'Sesiuni și dispozitive'
    }
  },
  organization: {
    pageTitle: 'Organizație',
    pageSubtitle:
      'Divizii, departamente și echipe — vizualizări chart, arbore și tabel.',
    types: {
      division: 'Divizie',
      department: 'Departament',
      team: 'Echipă'
    },
    views: {
      chart: 'Schemă',
      tree: 'Arbore',
      browse: 'Tabel'
    },
    toolbar: {
      searchPlaceholder: 'Caută o echipă sau persoană…',
      types: {
        all: 'Tip',
        divisions: 'Divizii',
        departments: 'Departamente',
        teams: 'Echipe'
      }
    },
    kpis: {
      divisions: 'Divizii',
      departments: 'Departamente',
      teams: 'Echipe',
      membersAssigned: 'Membri alocați',
      openPositions: 'Poziții deschise',
      of: 'din {{total}}'
    },
    actions: {
      export: 'Export',
      newDivision: 'Divizie nouă',
      viewDetails: 'Vezi detalii',
      edit: 'Editează',
      delete: 'Șterge',
      more: 'Mai multe acțiuni',
      addShort: 'Adaugă',
      add: {
        division: 'Adaugă divizie',
        department: 'Adaugă departament',
        team: 'Adaugă echipă'
      }
    },
    tree: {
      columns: {
        name: 'Nume',
        lead: 'Lider',
        headcount: 'Efectiv',
        subUnits: 'Sub-unități'
      },
      empty: 'Nicio divizie, departament sau echipă încă.',
      expand: 'Extinde',
      collapse: 'Restrânge',
      leadVacant: 'Lider vacant',
      subUnitsCount_one: '{{count}} sub-unitate',
      subUnitsCount_other: '{{count}} sub-unități'
    },
    browse: {
      columns: {
        name: 'Nume',
        type: 'Tip',
        parent: 'Părinte',
        lead: 'Lider',
        headcount: 'Efectiv',
        openPositions: 'Poziții deschise',
        created: 'Creată'
      },
      workspaceRoot: 'Spațiu de lucru',
      total_one: '{{count}} unitate în total',
      total_other: '{{count}} unități în total'
    },
    detail: {
      inParent: 'în {{parent}}',
      stats: {
        headcount: 'Efectiv',
        budgeted: 'Bugetat',
        open: 'Deschise',
        subUnits: 'Sub-unități'
      },
      lead: {
        title: 'Lider',
        none: 'Nu este alocat un lider',
        change: 'Schimbă lider',
        assign: 'Alocă lider'
      },
      subUnits: {
        departmentPlural: 'Departamente',
        teamPlural: 'Echipe',
        divisionPlural: 'Divizii'
      },
      members: {
        title: 'Membri',
        empty: 'Niciun membru direct încă.',
        showAll: 'Vezi toți {{count}} membri →',
        add: 'Adaugă membru',
        remove: 'Elimină din echipă',
        addModal: {
          title: 'Adaugă membru în {{team}}',
          userLabel: 'Utilizator',
          userPlaceholder: 'Caută un coleg',
          userRequired: 'Alege un utilizator de adăugat',
          submit: 'Adaugă membru',
          cancel: 'Anulează',
          noCandidates: 'Toți sunt deja membri ai acestei echipe.'
        },
        removeConfirm: {
          title: 'Elimini membrul?',
          content:
            'Elimini {{name}} din "{{team}}"? Își păstrează contul și orice alte alocări de echipă.',
          confirm: 'Elimină',
          cancel: 'Anulează'
        }
      },
      metadata: {
        title: 'Metadata',
        unitId: 'ID unitate',
        type: 'Tip',
        parent: 'Părinte',
        created: 'Creată'
      }
    },
    form: {
      createTitle: 'Creează {{type}}',
      editTitle: 'Editează {{type}}',
      cancel: 'Anulează',
      create: 'Creează',
      saveChanges: 'Salvează modificările',
      fields: {
        name: 'Nume',
        type: 'Tip',
        parent: 'Părinte',
        abbreviation: 'Abreviere',
        description: 'Descriere',
        lead: 'Lider'
      },
      placeholders: {
        name: 'ex. Inginerie, Vânzări EMEA',
        parent: 'Selectează unitatea părinte',
        description: 'Descriere opțională — ce gestionează această unitate?',
        lead: 'Alege un membru pentru a conduce această unitate'
      },
      required: {
        name: 'Numele este obligatoriu',
        parent: 'Unitatea părinte este obligatorie'
      },
      noParents:
        'Niciun {{type}} încă — creează unul mai întâi pentru a putea adăuga sub el.',
      notApiBackedFields: {
        title: 'Unele câmpuri sunt doar vizuale momentan',
        description:
          'Culoarea, efectivul bugetat și pozițiile deschise din mockup-uri nu sunt salvate încă în API. Vor avea badge-ul "API în așteptare" până la implementare.',
        examples: 'Culoare · efectiv bugetat · poziții deschise'
      }
    },
    delete: {
      title: 'Ștergi această unitate?',
      content:
        'Aceasta va șterge definitiv "{{name}}". Membrii își păstrează conturile, dar pierd această alocare.',
      confirm: 'Șterge unitatea',
      cancel: 'Anulează'
    },
    toasts: {
      created: 'Unitate creată',
      createFailed: 'Crearea unității a eșuat',
      updated: 'Unitate actualizată',
      updateFailed: 'Actualizarea a eșuat',
      deleted: 'Unitate ștearsă',
      deleteFailed: 'Ștergerea a eșuat',
      memberAdded: 'Membru adăugat',
      memberAddFailed: 'Adăugarea membrului a eșuat',
      memberRemoved: 'Membru eliminat',
      memberRemoveFailed: 'Eliminarea membrului a eșuat',
      teamRoleGranted: 'Rol acordat echipei',
      teamRoleRevoked: 'Rol retras de la echipă'
    },
    notApiBacked: {
      short: 'API în așteptare',
      tooltip:
        'Acest câmp este afișat pentru paritate cu mockup-urile, dar nu este salvat încă în API.',
      budget:
        'Efectivul bugetat și pozițiile deschise nu sunt salvate încă în API.',
      exportTooltip:
        'Exportul CSV nu este încă conectat la API — butonul este pentru paritate vizuală.',
      exportToast: 'Exportul nu este încă implementat (fără endpoint API).'
    }
  },
  users: {
    title: 'Utilizatori',
    tabs: {
      people: 'Utilizatori',
      groups: 'Grupuri',
      joinRequests: 'Cereri de acces'
    },
    joinRequests: {
      searchPlaceholder: 'Caută după nume sau e-mail',
      approveAs: 'Aprobă drept',
      approve: 'Aprobă',
      reject: 'Refuză',
      approveConfirm: 'Îl primești pe {{email}} în acest spațiu de lucru?',
      rejectConfirm: 'Refuzi cererea de la {{email}}?',
      approved: '{{email}} a fost adăugat în spațiul de lucru.',
      rejected: 'Cererea de la {{email}} a fost refuzată.',
      columns: {
        person: 'Persoană',
        requested: 'Cerut',
        status: 'Status',
        reviewed: 'Analizat',
        actions: 'Acțiuni'
      },
      status: {
        pending: 'În așteptare',
        approved: 'Aprobate',
        rejected: 'Refuzate'
      }
    },
    groups: {
      searchPlaceholder: 'Caută grupuri…',
      organizationScope: 'Spațiu de lucru',
      memberCount_one: '{{count}} membru',
      memberCount_few: '{{count}} membri',
      memberCount_other: '{{count}} de membri',
      columns: {
        name: 'Grup',
        members: 'Membri',
        roles: 'Roluri acordate',
        created: 'Creat',
        updated: 'Actualizat'
      },
      actions: {
        create: 'Grup nou',
        edit: 'Editează',
        delete: 'Șterge',
        more: 'Mai multe acțiuni'
      },
      form: {
        createTitle: 'Grup nou',
        editTitle: 'Editează grupul',
        name: 'Nume',
        namePlaceholder: 'ex. Echipa de suport',
        nameRequired: 'Dă un nume grupului.',
        members: 'Membri',
        addMember: 'Adaugă membru',
        removeMember: 'Elimină din grup',
        membersEmpty: 'Încă niciun membru.',
        membersPlaceholder: 'Caută colegi',
        membersHint: 'Modificările se salvează odată cu grupul.',
        roles: 'Roluri acordate',
        rolesPlaceholder: 'Caută roluri',
        rolesTruncated:
          'Se afișează primele 200 de roluri. Restrânge lista de roluri dacă lipsește vreunul.',
        rolesHint:
          'Membrii primesc aceste roluri — și accesul la aplicațiile cărora le aparțin rolurile.',
        save: 'Salvează',
        cancel: 'Anulează',
        created: 'Grup creat',
        updated: 'Grup actualizat'
      },
      detail: {
        metadata: 'Detalii',
        rolesEmpty: 'Acest grup nu acordă încă niciun rol.',
        showAllMembers: 'Vezi toți {{count}} membri →',
        removeSuccess: 'Membru eliminat din grup',
        removeConfirm: {
          title: 'Elimină din grup',
          content:
            'Elimini {{name}} din „{{group}}”? Păstrează orice rol pe care îl are personal sau printr-un alt grup.',
          confirm: 'Elimină'
        }
      },
      delete: {
        title: 'Șterge grupul',
        description:
          'Ștergi „{{name}}”? Membrii își păstrează conturile — se elimină doar grupul.',
        submit: 'Șterge grupul',
        success: 'Grup șters'
      }
    },
    statuses: {
      all: 'Toți',
      active: 'Activi',
      invited: 'Invitați',
      suspended: 'Suspendați',
      inactive: 'Inactivi'
    },
    roles: {
      owner: 'Proprietar',
      admin: 'Admin',
      employee: 'Membru'
    },
    invite: {
      drawerTitle: 'Invită membri',
      description:
        'Adaugă una sau mai multe adrese de email, alege rolul și (opțional) atribuie un manager. Trimitem fiecăruia un email de invitație.',
      submit: 'Trimite invitațiile',
      cancel: 'Anulează',
      success_one: 'Invitație trimisă',
      success_other: '{{count}} invitații trimise',
      fields: {
        emails: 'Adrese de email',
        emailsPlaceholder: 'nume@exemplu.com, altcineva@exemplu.com',
        emailsTooltip:
          'Apasă Enter, virgulă sau spațiu după fiecare adresă pentru a o adăuga.',
        role: 'Rol',
        manager: 'Manager',
        managerPlaceholder: 'Caută un coleg',
        managerHint: 'Opțional — persoana care va coordona membrii invitați.'
      },
      error: {
        noEmails: 'Adaugă cel puțin o adresă de email.',
        invalidEmails: 'Email invalid: {{emails}}',
        workspaceNotReady:
          'Detaliile spațiului de lucru se încarcă — încearcă din nou peste o clipă.'
      }
    },
    filters: {
      searchPlaceholder: 'Caută după nume sau email…',
      allStatuses: 'Status',
      allRoles: 'Toate rolurile',
      allTeams: 'Toate echipele',
      teamChip: 'Echipă',
      joinedChip: 'Înscris',
      joinedFromPlaceholder: 'Înscris din',
      joinedToPlaceholder: 'Înscris până',
      mfaValues: {
        all: 'MFA · oricare',
        on: 'MFA activat',
        off: 'MFA dezactivat',
        required: 'Necesar, neînrolat'
      },
      moreFilters: 'Mai multe filtre',
      chipsLabel: 'Filtre',
      statusChip: 'Status',
      roleChip: 'Rol',
      mfaChip: 'MFA',
      is: 'este',
      clearAll: 'Șterge toate'
    },
    columns: {
      user: 'Utilizator',
      email: 'Email',
      role: 'Rol',
      status: 'Status',
      jobTitle: 'Funcție',
      manager: 'Manager',
      teams: 'Echipe',
      mfa: 'MFA',
      mfaEnabled: 'Activat',
      mfaDisabled: 'Dezactivat',
      lastSignIn: 'Ultima conectare',
      joined: 'Membru din',
      source: 'Sursă'
    },
    export: {
      empty: 'Nimic de exportat — filtrele curente nu returnează rânduri.',
      success_one: 'Exportat {{count}} utilizator',
      success_other: 'Exportați {{count}} utilizatori'
    },
    lastSignIn: { never: 'Niciodată' },
    toolbar: {
      selected_one: '{{count}} selectat',
      selected_other: '{{count}} selectați',
      clear: 'Anulează',
      showing: 'Se afișează {{shown}} din {{total}} utilizatori',
      total_one: '{{count}} în total',
      total_other: '{{count}} în total'
    },
    actions: {
      view: 'Vezi profilul',
      edit: 'Editează',
      changeRole: 'Schimbă rolul',
      resendInvite: 'Retrimite invitația',
      invitation: 'Invitație',
      reactivate: 'Reactivează',
      suspend: 'Suspendă',
      archive: 'Arhivează utilizatorul',
      unarchive: 'Dezarhivează utilizatorul',
      delete: 'Șterge',
      requireMfa: 'Solicită MFA',
      disableMfa: 'Nu mai solicita MFA',
      resetMfa: 'Resetează MFA',
      resetPassword: 'Resetează parola',
      impersonate: 'Impersonează',
      export: 'Export',
      invite: 'Invită utilizatori',
      more: 'Mai multe acțiuni',
      apiPending: {
        changeRole: 'Schimbarea rolului — endpoint API neconectat.',
        resendInvite: 'Retrimitere invitație — endpoint API neconectat.',
        reactivate: 'Reactivare — endpoint API neconectat.',
        suspend: 'Suspendare — endpoint API neconectat.',
        delete: 'Ștergere — endpoint API neconectat.',
        bulkSuspend: 'Suspendare în masă — endpoint API neconectat.',
        bulkDelete: 'Ștergere în masă — endpoint API neconectat.',
        invite:
          'Invitare — UI afișat; endpoint existent este în pagina users veche.',
        export: 'Export — endpoint API neconectat.',
        edit: 'Editare — endpoint API neconectat.',
        resetPassword: 'Resetare parolă — endpoint API neconectat.',
        impersonate: 'Impersonare — endpoint API neconectat.',
        requireMfa: 'Solicitare MFA — endpoint API neconectat.'
      }
    },
    lifecycle: {
      inviteState: {
        pending: 'Invitație în așteptare',
        expired: 'Invitație expirată',
        accepted: 'Activ',
        revoked: 'Invitație revocată'
      },
      inviteExpires: 'Invitația expiră {{when}}',
      inviteExpired: 'Invitația a expirat {{when}}',
      requiresAcceptance: 'Disponibil după ce membrul acceptă invitația',
      joinLink: {
        action: 'Link de înscriere',
        copied: 'Link de înscriere copiat',
        disabledHint:
          'Activați înscrierea self-service în setările spațiului pentru a partaja un link.'
      },
      revokeInvite: {
        action: 'Revocă invitația',
        title: 'Revocați invitația?',
        description:
          'Aceasta anulează invitația în așteptare pentru {{name}}. Linkul de invitație nu va mai funcționa imediat.',
        submit: 'Revocă invitația',
        success: 'Invitație revocată'
      },
      resetPassword: {
        title: 'Trimiteți resetarea parolei?',
        description:
          'Vom trimite lui {{name}} un link securizat pentru a alege o parolă nouă. Parola actuală rămâne valabilă până la utilizarea linkului.',
        submit: 'Trimite linkul',
        success: 'E-mail de resetare a parolei trimis'
      },
      requireMfa: {
        title: 'Solicitați autentificarea în doi pași?',
        description:
          'Autentificarea în doi pași va fi activată pentru {{name}}. La următoarea conectare i se va cere verificarea prin e-mail sau aplicație de autentificare.',
        submit: 'Solicită MFA',
        success: 'MFA este acum obligatoriu pentru acest membru'
      },
      disableMfa: {
        title: 'Nu mai solicitați autentificarea în doi pași?',
        description:
          'MFA nu va mai fi obligatorie pentru {{name}} în acest spațiu de lucru. Configurarea sa actuală în doi pași rămâne activă — aceasta doar ridică cerința spațiului de lucru, nu îi elimină înrolarea. Pentru a ajuta un membru care și-a pierdut autentificatorul, folosiți Resetează MFA.',
        submit: 'Nu mai solicita',
        success: 'MFA nu mai este obligatorie pentru acest membru'
      },
      resetMfa: {
        title: 'Resetați autentificarea în doi pași?',
        description:
          'Codurile de recuperare, dispozitivele de încredere și blocările lui {{name}} vor fi șterse pentru a se înrola din nou. MFA rămâne activă (codurile pe e-mail funcționează, deci nu este blocat). Nu vedeți niciodată codurile sale de recuperare — își generează altele noi din propriile setări de securitate.',
        submit: 'Resetează MFA',
        success: 'MFA resetat pentru acest membru'
      },
      impersonate: {
        title: 'Preluați identitatea acestui membru?',
        description:
          'Veți începe o sesiune ca {{name}}. Sesiunea dvs. de administrator este restabilită când ieșiți.',
        warning:
          'Fiecare acțiune va fi efectuată ca acest membru și înregistrată în jurnalul de audit.',
        submit: 'Începe preluarea',
        success: 'Sesiune de preluare a identității începută',
        banner: 'Preluați identitatea lui {{name}}',
        exit: 'Ieși din preluare'
      },
      sessions: {
        title: 'Sesiuni active',
        subtitle: 'Dispozitive conectate în prezent ca acest membru',
        empty: 'Nicio sesiune activă.',
        current: 'Curentă',
        revoke: 'Revocă',
        revokeAll: 'Revocă toate',
        revokeConfirm:
          'Revocați această sesiune? Dispozitivul va fi deconectat.',
        revokeAllConfirm:
          'Revocați toate sesiunile acestui membru? Va fi deconectat de pe toate dispozitivele.',
        revoked: 'Sesiune revocată',
        revokedAll_one: '{{count}} sesiune revocată',
        revokedAll_other: '{{count}} sesiuni revocate',
        failed: 'Sesiunea nu a putut fi revocată',
        unknownDevice: 'Dispozitiv necunoscut',
        columns: {
          device: 'Dispozitiv',
          location: 'Locație',
          ip: 'Adresă IP',
          lastActive: 'Ultima activitate',
          created: 'Început'
        }
      }
    },
    modals: {
      cancel: 'Anulează',
      changeRole: {
        title: 'Schimbă rolul',
        description:
          'Alege un nou rol pentru {{name}}. Nivelul de acces se actualizează imediat.',
        fieldLabel: 'Rol nou',
        submit: 'Salvează modificările',
        cancel: 'Anulează',
        success: 'Rol actualizat'
      },
      suspend: {
        title: 'Suspendă utilizatorul?',
        description:
          'Suspendarea {{name}} va deconecta utilizatorul și va bloca autentificarea până la reactivare.',
        warning:
          'Sesiunile active sunt revocate, iar sarcinile în lucru pot fi reatribuite.',
        submit: 'Suspendă utilizatorul',
        success: 'Utilizator suspendat'
      },
      reactivate: {
        title: 'Reactivează utilizatorul?',
        description:
          '{{name}} va putea să se autentifice din nou cu credențialele existente.',
        submit: 'Reactivează utilizatorul',
        success: 'Utilizator reactivat'
      },
      delete: {
        title: 'Șterge utilizatorul din workspace',
        description:
          'Aceasta elimină {{name}} din workspace. Contul global nu este șters.',
        warning:
          'Acțiunea nu poate fi anulată. Datele și accesul specifice workspace-ului se pierd.',
        confirmLabel: 'Pentru confirmare, tastează emailul:',
        submit: 'Șterge utilizatorul',
        success: 'Utilizator eliminat din workspace'
      },
      resendInvite: {
        title: 'Retrimite invitația',
        description:
          'Vom trimite din nou un email de invitație pentru ca utilizatorul să își finalizeze contul.',
        recipient: 'Trimitem către:',
        submit: 'Retrimite invitația',
        success: 'Invitație retrimisă'
      },
      archive: {
        title: 'Arhivează utilizatorul',
        description:
          'Arhivarea lui {{name}} îi blochează autentificarea și transferă înregistrările pe care încă le deține în acest workspace.',
        checking: 'Verificăm ce deține utilizatorul…',
        checkFailed:
          'Nu am putut încărca înregistrările utilizatorului. Încearcă din nou.',
        noBlockers:
          'Acest utilizator nu are înregistrări active care să blocheze arhivarea. Poate fi arhivat direct.',
        hasBlockers:
          'Acest utilizator încă deține înregistrări active. Alege un coleg care să le preia — înregistrările sunt reasignate, apoi utilizatorul este arhivat.',
        depsTitle: 'Înregistrări active',
        services: { crm: 'CRM', hrm: 'HRM' },
        entityCount_one: '{{count}} activ',
        entityCount_other: '{{count}} active',
        replaceLabel: 'Reasignează înregistrările către',
        replacePlaceholder: 'Alege un coleg…',
        replaceRequired:
          'Alege un utilizator către care să reasignezi înregistrările.',
        manualHint:
          'Preferi să te ocupi manual? Poți deschide aplicația relevantă și să reasignezi aceste înregistrări pe cont propriu, apoi arhivezi utilizatorul de aici după ce nu mai rămâne nimic.',
        submit: 'Arhivează utilizatorul',
        submitReplace: 'Reasignează și arhivează',
        success: 'Utilizator arhivat',
        job: {
          pending: 'În așteptare…',
          processing: 'Reasignăm înregistrările și arhivăm…',
          succeeded: 'Utilizator arhivat',
          failed: 'Arhivarea a eșuat'
        },
        jobError:
          'Unele înregistrări nu au putut fi reasignate. Nicio modificare nu a fost aplicată.'
      },
      unarchive: {
        title: 'Dezarhivează utilizatorul',
        description:
          'Dezarhivarea lui {{name}} îi restabilește autentificarea și dreptul de proprietate asupra înregistrărilor în acest workspace.',
        submit: 'Dezarhivează utilizatorul',
        success: 'Utilizator dezarhivat'
      },
      bulk: {
        note: 'Fiecare utilizator este procesat individual — eșecurile parțiale sunt raportate.',
        suspend: {
          title_one: 'Suspendă {{count}} utilizator?',
          title_other: 'Suspendă {{count}} utilizatori?',
          description_one:
            'Suspendarea unui utilizator îi anulează sesiunile și îl blochează la conectare.',
          description_other:
            'Suspendarea a {{count}} utilizatori le anulează sesiunile și îi blochează la conectare.',
          warning: 'Sesiunile active sunt revocate.',
          submit: 'Suspendă',
          success_one: '{{count}} utilizator suspendat',
          success_other: '{{count}} utilizatori suspendați',
          partial_one: '{{count}} utilizator nu a putut fi suspendat',
          partial_other: '{{count}} utilizatori nu au putut fi suspendați'
        },
        reactivate: {
          title_one: 'Reactivează {{count}} utilizator?',
          title_other: 'Reactivează {{count}} utilizatori?',
          description_one:
            '{{count}} utilizator va putea să se conecteze din nou.',
          description_other:
            '{{count}} utilizatori vor putea să se conecteze din nou.',
          submit: 'Reactivează',
          success_one: '{{count}} utilizator reactivat',
          success_other: '{{count}} utilizatori reactivați',
          partial_one: '{{count}} utilizator nu a putut fi reactivat',
          partial_other: '{{count}} utilizatori nu au putut fi reactivați'
        },
        delete: {
          title_one: 'Elimini {{count}} utilizator din workspace?',
          title_other: 'Elimini {{count}} utilizatori din workspace?',
          description_one:
            'Acest lucru elimină {{count}} utilizator din workspace.',
          description_other:
            'Acest lucru elimină {{count}} utilizatori din workspace.',
          warning:
            'Datele și accesul specific workspace-ului vor fi pierdute — ireversibil.',
          submit: 'Elimină',
          success_one: '{{count}} utilizator eliminat',
          success_other: '{{count}} utilizatori eliminați',
          partial_one: '{{count}} utilizator nu a putut fi eliminat',
          partial_other: '{{count}} utilizatori nu au putut fi eliminați'
        }
      }
    },
    hero: {
      lastSignIn: 'Ultima conectare',
      mfaUnknown: 'MFA · status indisponibil',
      mfaOn: '2FA · înrolat',
      mfaOff: '2FA · neînrolat',
      statusHint: 'Starea curentă a contului — activ, invitat sau suspendat.',
      roleHint: 'Rolul în spațiul de lucru — determină accesul contului.',
      mfaHint:
        'Dacă autentificarea în doi factori este activată pentru acest cont.',
      ssoHint:
        'Modul de autentificare — single sign-on (SSO) sau credențiale manuale.',
      userId: 'ID utilizator',
      via: 'prin',
      source: {
        sso: 'SSO',
        manual: 'Manual'
      },
      alerts: {
        neverSignedIn:
          'Utilizatorul nu s-a conectat încă. Posibil să fie în proces de onboarding.',
        apiPendingFields:
          'MFA, sursa autentificării și accesul per aplicație nu sunt încă expuse de API — sunt afișate doar pentru paritate vizuală.'
      }
    },
    detail: {
      tabs: {
        overview: 'Sumar',
        access: 'Acces aplicații',
        sessions: 'Sesiuni',
        audit: 'Audit'
      },
      tabsPlaceholders: {
        access:
          'Accesul per aplicație și rolurile vor apărea aici după conectarea endpoint-ului API.',
        sessions:
          'Sesiunile active vor apărea aici după conectarea endpoint-ului de sesiuni.',
        audit:
          'Evenimentele de audit vor apărea aici după conectarea endpoint-ului de audit.'
      },
      identity: {
        title: 'Identitate',
        subtitle: 'Informații personale înregistrate',
        firstName: 'Prenume',
        lastName: 'Nume',
        email: 'Email',
        phone: 'Telefon',
        birthDate: 'Data nașterii',
        jobTitle: 'Funcție',
        position: 'Poziție',
        language: 'Limbă',
        userId: 'ID utilizator',
        externalId: 'ID extern',
        verified: 'Verificat',
        phoneNotVerifiedTooltip:
          'Statusul verificării telefonului nu este încă salvat în API.'
      },
      workspaceAccess: {
        title: 'Acces spațiu de lucru',
        groups: 'Grupuri',
        noGroups: 'Nu face parte din niciun grup',
        subtitle: 'Un utilizator are un singur rol în spațiu',
        role: 'Rol în spațiu',
        joined: 'Membru din',
        headUser: 'Raportează la',
        teams: 'Echipe',
        noTeams: 'Nu face parte din nicio echipă',
        roleUpdated: 'Rol actualizat',
        roleFailed: 'Actualizarea rolului a eșuat',
        headUserUpdated: 'Manager actualizat',
        headUserPlaceholder: 'Caută un membru'
      },
      workspaceRoles: {
        title: 'Roluri spațiu de lucru',
        subtitle:
          'Aici sunt afișate doar rolurile personalizate ale spațiului de lucru. Rolul de bază al membrului este afișat în cardul Acces în spațiul de lucru.',
        placeholder: 'Selectează roluri',
        empty:
          'Nu există roluri personalizate definite în acest spațiu de lucru încă',
        save: 'Salvează',
        cancel: 'Anulează',
        saveSuccess: 'Roluri actualizate',
        saveFailed: 'Actualizarea rolurilor a eșuat'
      },
      access: {
        tabTitle: 'Acces aplicații',
        tabSubtitle: 'Un rând per aplicație · comută accesul și alege un rol',
        emptyAllApps: 'Acest spațiu de lucru nu are aplicații înregistrate.',
        rolePlaceholder: 'Selectează rol',
        noRoleAvailable: 'Niciun rol disponibil',
        pickRolePrompt: 'Alege un rol',
        saveSuccess: 'Accesul la aplicații a fost actualizat',
        saveFailed: 'Actualizarea accesului la aplicații a eșuat'
      },
      authentication: {
        title: 'Autentificare',
        password: 'Parolă',
        passwordMeta:
          'Data ultimei modificări a parolei nu este salvată în API.',
        managedBySso: 'Gestionată prin SSO',
        mfa: 'Autentificare cu doi factori',
        mfaUnknown: 'Status înrolare indisponibil',
        mfaEnabled: 'Înrolat',
        mfaRequiredTag: 'Obligatoriu',
        mfaRequiredMeta: 'Autentificarea cu mai mulți factori este obligatorie',
        mfaDisabledMeta: 'Neînrolat în autentificarea cu mai mulți factori',
        mfaMethod: 'Metodă cu doi factori',
        mfaMethodEnrolledMeta:
          'Autentificator sau coduri pe e-mail configurate',
        mfaMethodNotEnrolledMeta: 'Niciun al doilea factor configurat',
        mfaNotEnrolled: 'Neconfigurat',
        mfaRequire: 'Solicită doi factori',
        mfaRequireOnMeta: 'Trebuie să verifice la următoarea conectare',
        mfaRequireOffMeta: 'Se poate conecta fără al doilea factor',
        reset: 'Resetează',
        emailVerified: 'Email verificat',
        ssoProvider: 'Furnizor SSO',
        ssoLinkedMeta: 'Conectat · {{id}}',
        ssoNotLinked: 'Neconectat',
        sso: 'SSO',
        link: 'Conectează',
        linked: 'Conectat',
        enforce: 'Solicită',
        disable: 'Nu mai solicita',
        apiPending: {
          enforceMfa: 'Impunerea MFA — endpoint API neconectat.',
          linkSso: 'Conectare SSO — endpoint API neconectat.'
        }
      },
      quickStats: {
        signIns30d: 'Conectări · 30z',
        appsUsed: 'Aplicații folosite',
        sessions: 'Sesiuni'
      },
      recentActivity: {
        title: 'Activitate recentă',
        seeAll: 'Vezi tot →',
        empty: 'Nicio activitate recentă încă.',
        error: 'Activitatea recentă nu a putut fi încărcată.'
      },
      audit: {
        searchPlaceholder: 'Caută evenimente',
        dateRangeLabel: 'Interval de date',
        empty: 'Niciun eveniment de audit înregistrat pentru acest utilizator.',
        noMatches: 'Niciun eveniment nu corespunde filtrelor curente.',
        filters: {
          allApplications: 'Aplicație',
          allEventTypes: 'Tip eveniment',
          allSeverities: 'Severitate',
          clear: 'Șterge'
        },
        toolbar: {
          events_one: '{{count}} eveniment',
          events_few: '{{count}} evenimente',
          events_other: '{{count}} de evenimente'
        },
        columns: {
          time: 'Timp',
          event: 'Eveniment',
          application: 'Aplicație',
          description: 'Descriere',
          severity: 'Severitate',
          ip: 'IP'
        }
      }
    },
    notApiBacked: {
      mfa: 'Statusul înrolării MFA nu este încă salvat în API.'
    },
    breadcrumb: {
      users: 'Utilizatori',
      notFound: 'Utilizator inexistent'
    },
    notFound: {
      title: 'Utilizator inexistent',
      subtitle:
        'Acest utilizator nu este membru al acestui workspace sau linkul este învechit.',
      back: 'Înapoi la membri'
    },
    editForm: {
      title: 'Editează utilizatorul',
      cancel: 'Anulează',
      save: 'Salvează',
      saveSuccess: 'Utilizator actualizat',
      saveFailed: 'Actualizarea a eșuat',
      aboutMe: 'Despre',
      birthDatePlaceholder: 'Selectează data',
      manager: 'Manager',
      managerPlaceholder: 'Caută un coleg',
      managerHint: 'Persoana care gestionează acest utilizator.',
      required: {
        firstName: 'Prenumele este obligatoriu',
        lastName: 'Numele este obligatoriu'
      }
    },
    addToGroup: {
      action: 'Adaugă în grup',
      title: 'Adaugă într-un grup',
      groupLabel: 'Grup',
      groupPlaceholder: 'Selectează un grup',
      groupRequired: 'Alege un grup',
      submit: 'Adaugă',
      cancel: 'Anulează',
      success: 'Adăugat în grup',
      noGroups:
        'Niciun grup disponibil — creează unul mai întâi în tab-ul Grupuri.'
    },
    addToTeam: {
      action: 'Adaugă în echipă',
      title: 'Adaugă într-o echipă',
      teamLabel: 'Echipă',
      teamPlaceholder: 'Selectează o echipă',
      teamRequired: 'Alege o echipă',
      submit: 'Adaugă',
      cancel: 'Anulează',
      noTeams:
        'Nicio echipă disponibilă — creează una mai întâi în Organizație.'
    }
  },
  workspaceHome: {
    chatPlaceholder:
      'Întreabă Skalx AI despre utilizatori, securitate, aplicații sau audit…',
    welcome: {
      title: 'Ce ai vrea să faci?',
      subtitle:
        'Skalx AI poate investiga utilizatori, audita accesul, genera rapoarte de securitate și configura spațiul tău. Acționează doar pe ce poți vedea deja.'
    },
    greeting: {
      morning: 'Bună dimineața',
      afternoon: 'Bună ziua',
      evening: 'Bună seara',
      late: 'Treaz până târziu',
      fallbackName: 'prieten'
    },
    suggestions: {
      owner: {
        admins: 'Cine are drepturi de administrator?',
        securityReview: 'Verifică securitatea spațiului',
        accessChanges: 'Cine a schimbat accesul recent?',
        orgChart: 'Arată organigrama'
      },
      admin: {
        members: 'Arată membrii și rolurile lor',
        inviteMember: 'Invită un membru nou',
        signInMethods: 'Ce metode de autentificare sunt active?',
        accessChanges: 'Cine a schimbat accesul recent?'
      },
      employee: {
        myTeam: 'Cine este în echipa mea?',
        orgChart: 'Cine cui se subordonează?',
        myApps: 'Ce aplicații pot deschide?',
        myAccess: 'Ce acces am?'
      }
    },
    composer: {
      send: 'Trimite',
      stop: 'Oprește'
    },
    streaming: {
      thinking: 'Skalx AI gândește…',
      cycle: {
        thinking: 'Mă gândesc',
        reasoning: 'Raționez',
        searching: 'Caut',
        analyzing: 'Analizez',
        crunching: 'Procesez',
        looking_up: 'Verific',
        connecting: 'Pun cap la cap',
        almost_ready: 'Aproape gata'
      }
    },
    feedback: {
      helpful: 'Util',
      notHelpful: 'Inutil',
      failed: 'Nu am putut salva evaluarea'
    },
    copy: {
      copy: 'Copiază',
      copied: 'Copiat',
      failed: 'Nu am putut copia'
    },
    timeline: {
      thinking: 'Se gândește…',
      thoughts: 'Raționament',
      working: 'Pași de lucru',
      request: 'Cerere',
      response: 'Răspuns'
    },
    approval: {
      title: 'Această acțiune are nevoie de aprobarea ta',
      actionRequest: 'Necesită aprobare',
      toolLabel: 'Acțiune solicitată:',
      destructive: 'Distructiv',
      noDetails: 'Fără alte detalii.',
      approve: 'Aprobă',
      always: 'Aprobă mereu',
      alwaysHint:
        'Rulează mereu {{tool}} pentru acest agent, fără a mai întreba.',
      reject: 'Respinge',
      approved: 'Aprobat',
      rejected: 'Respins',
      severityHint: 'Evaluarea agentului privind riscul acestei acțiuni.',
      severity: {
        none: 'Fără risc',
        low: 'Risc scăzut',
        medium: 'Risc mediu',
        high: 'Risc ridicat',
        critical: 'Risc critic'
      },
      confidenceLabel: 'Încredere',
      confidenceHint:
        'Cât de sigur este agentul că aceasta este acțiunea potrivită.',
      whatWillHappen: 'Ce se va întâmpla'
    },
    question: {
      clarification: 'Necesită o clarificare',
      questionLabel: 'Întrebare',
      selected: 'Răspuns',
      otherButton: 'Altceva',
      otherPlaceholder: 'Sau scrie propriul răspuns…',
      submit: 'Trimite',
      answered: 'Răspuns trimis'
    },
    scrollToBottom: 'La cel mai recent mesaj',
    attachments: {
      attach: 'Atașează fișiere',
      remove: 'Elimină fișierul',
      retry: 'Reîncearcă încărcarea',
      uploadFailed: 'Încărcarea a eșuat. Încearcă din nou.',
      uploading: 'Se încarcă {{name}}',
      open: 'Deschide',
      download: 'Descarcă',
      fromYou: 'Tu',
      fromAgent: 'Agent',
      empty: 'Încă nu sunt fișiere în acest chat',
      loadError: 'Fișierele nu au putut fi încărcate.',
      retryLoad: 'Reîncearcă',
      unavailable: 'Fișierul nu este încă disponibil',
      sendRefused:
        'Aceste fișiere nu pot fi trimise cu acest mesaj. Elimină-le și atașează-le din nou.',
      problems: {
        unsupported: 'Acest tip de fișier nu este acceptat',
        too_large: 'Imagini de până la 5 MB, alte fișiere de până la 20 MB',
        too_many: 'Cel mult 10 fișiere într-un mesaj'
      }
    },
    files: {
      open: 'Fișiere',
      title: 'Fișierele chatului'
    },
    history: {
      title: 'Istoric conversații',
      back: 'Înapoi la început',
      newChat: 'Conversație nouă',
      hide: 'Ascunde istoricul',
      searchPlaceholder: 'Caută conversații…',
      today: 'Astăzi',
      yesterday: 'Ieri',
      older: 'Mai vechi',
      empty: 'Nicio conversație încă',
      noResults: 'Nicio conversație găsită',
      delete: 'Șterge conversația',
      deleteConfirm: 'Ștergi această conversație?',
      processing: 'Agentul lucrează la această conversație',
      awaitingInput: 'Această conversație așteaptă răspunsul tău'
    },
    errors: {
      notConfiguredTitle: 'Asistentul AI nu este configurat',
      notConfigured:
        'Setează VITE_APP_SQUAD_AGENT_ID (și VITE_APP_SQUAD_API) în mediul tău pentru a activa asistentul. Build-ul curent nu are un agent Squad configurat.',
      stopped: 'Oprit.',
      empty: 'Agentul nu a returnat niciun răspuns.',
      approvalRequired:
        'Această acțiune necesită aprobarea ta pentru a continua.',
      generic: 'Nu am putut ajunge la asistentul AI. Încearcă din nou.',
      questionPending:
        'Răspunde mai întâi la întrebarea agentului, apoi trimite fișierele.'
    }
  },
  workspaceOverview: {
    title: 'Bun venit în {{workspace}}',
    subtitle:
      'Aceasta este casa echipei tale. Alege o secțiune pentru a începe.',
    fallbackWorkspace: 'spațiul tău',
    inviteCta: 'Invită colegi',
    primaryCta: 'Invită colegi',
    greeting: {
      morning: 'Bună dimineața',
      afternoon: 'Bună ziua',
      evening: 'Bună seara',
      late: 'Treaz până târziu',
      fallbackName: 'prieten'
    },
    demo: {
      label: 'Demo',
      expired: 'expirat',
      daysLeft_one: '{{count}} zi rămasă',
      daysLeft_other: '{{count}} zile rămase',
      endsOn: 'Accesul demo expiră la {{date}}',
      noExpiry: 'Data expirării nu este setată',
      noExpiryTooltip: 'Data expirării nu este setată'
    },
    sections: {
      stats: 'Statistici spațiu',
      shortcuts: 'Scurtături',
      activity: 'Activitate recentă'
    },
    companyGraph: {
      title: 'Graficul companiei',
      preview: 'Previzualizare',
      subtitle: '{{count}} resurse conectate · vizualizare live',
      pageDescription:
        'O hartă vie a spațiului tău — resurse, conexiuni și activitate live.',
      details: 'Detalii',
      recentActivity: 'Activitate recentă',
      connections: 'Conexiuni',
      liveActivity: 'Activitate live',
      noActivity: 'Nicio activitate recentă',
      sample: 'Date demonstrative',
      close: 'Închide',
      active: 'Activ',
      lastActive: 'Activ ultima dată',
      needsAttention: 'Necesită atenție',
      allClear: 'Totul în regulă — nimic nu necesită atenție',
      viewDetails: 'Vezi detalii',
      highlights: 'Repere',
      liveEvents: 'Evenimente live',
      noEdgeEvents: 'Încă niciun eveniment pe această conexiune',
      tabs: {
        graph: 'Grafic',
        activity: 'Activitate',
        aiInsights: 'Perspective AI'
      },
      filters: {
        allActors: 'Autor',
        allEntities: 'Tip',
        search: 'Caută activitate…'
      },
      feedEmpty: 'Nicio activitate nu corespunde filtrelor',
      insights: {
        latestChanges: 'Schimbări recente',
        suggested: 'Încearcă să întrebi',
        greeting:
          'Întreabă-mă despre activitatea companiei — tranzacții, lead-uri, e-mail sau concedii.',
        askPlaceholder: 'Întreabă despre lead-uri, tranzacții, e-mail…',
        send: 'Trimite',
        thinking: 'Se gândește…',
        period: {
          today: 'Azi',
          '7d': '7 zile',
          '30d': '30 zile'
        }
      },
      legend: {
        company: 'Companie',
        database: 'Baze de date',
        email: 'E-mail',
        app: 'Aplicații',
        user: 'Utilizatori',
        agent: 'Agenți AI'
      },
      kpi: {
        activeSessions: 'Sesiuni active',
        eventsPerMin: 'Evenimente / min',
        agentsRunning: 'Agenți activi',
        openAlerts: 'Alerte deschise'
      },
      events: {
        backupDone: 'Backup automat finalizat',
        slowQuery: 'Interogare lentă > 2s înregistrată',
        failoverPassed: 'Test de failover reușit',
        emailsSent: 'Lot de e-mailuri trimis',
        emailBounced: 'E-mail respins (adresă invalidă)',
        mailboxSynced: 'Căsuțe poștale sincronizate',
        ticketsResolved: 'Tichete de suport rezolvate',
        agentRetry: 'Reîncercare după API 429',
        recordsSynced: 'Înregistrări sincronizate',
        memberInvited: 'A invitat un membru nou',
        appDeploy: 'Implementare reușită',
        appSession: 'Sesiuni noi inițiate',
        userSignin: 'Autentificat',
        userToken: 'Token de acces rotit',
        agentCalledApp: 'a apelat {{target}}',
        agentSyncedData: 'a sincronizat date către {{target}}',
        appQueriedDb: 'a interogat {{target}}',
        appSentEmail: 'a trimis e-mail prin {{target}}',
        sentData: 'a trimis date către {{target}}'
      }
    },
    hero: {
      domain: 'Domeniu principal',
      created: 'Creat',
      role: 'Rolul tău',
      manage: 'Gestionează setările',
      openWorkspace: 'Deschide spațiul',
      noDomain: 'Niciun domeniu setat'
    },
    signInActivity: {
      title: 'Activitate autentificări',
      subtitle: 'Ultimele 30 de zile · UTC',
      signIns: 'Autentificări · 30z',
      avgPerDay: 'Medie pe zi',
      failed: 'Eșuate',
      uniqueUsers: 'Utilizatori unici',
      legendSignIns: 'Autentificări',
      legendFailures: 'Eșecuri'
    },
    securitySignals: {
      title: 'Semnale de securitate',
      viewAll: 'Vezi toate'
    },
    appsHealth: {
      title: 'Sănătate aplicații',
      subtitle: 'Disponibilitate și volum de cereri în timp real per aplicație',
      manage: 'Gestionează aplicațiile',
      sessions: 'Sesiuni',
      errorRate: 'Rata de erori',
      p95: 'P95'
    },
    planUsage: {
      title: 'Plan & utilizare',
      upgrade: 'Upgrade'
    },
    details: {
      title: 'Detalii spațiu',
      manage: 'Gestionează setările',
      name: 'Nume',
      domain: 'Domeniu principal',
      created: 'Creat',
      role: 'Rolul tău',
      stats: {
        members: 'Membri',
        apps: 'Aplicații',
        roles: 'Roluri',
        authMethods: 'Metode auth active',
        mfaCoverage: 'Acoperire MFA'
      }
    },
    tiles: {
      users: 'Membri și echipe în acest spațiu',
      roles: 'Permisiuni și atribuiri de roluri',
      apps: 'Aplicații conectate',
      security: 'SSO, SAML și politica de autentificare',
      apiKeys: 'Chei API ale spațiului',
      audit: 'Activitate administrativă recentă'
    },
    activity: {
      title: 'Activitate recentă',
      viewAll: 'Deschide jurnalul de audit',
      systemActor: 'Sistem',
      emptyTitle: 'Încă nu există activitate',
      emptyDescription:
        'Activitatea echipei va apărea aici imediat ce oamenii încep să lucreze.'
    }
  },
  home: {
    greeting: 'Salut {{name}}, ce vrei să construiești?',
    chatPlaceholder:
      'Descrie ideea ta, iar Agentul o va transforma în realitate...',
    chatHint: 'Asistent AI pentru auth și setup de workspace',
    send: 'Plan',
    suggestionsTitle: 'Sugestii rapide',
    suggestions: {
      sso: {
        title: 'Configurează SSO pentru workspace',
        description:
          'Activează autentificarea cu Google și Entra ID pentru membrii workspace-ului.'
      },
      invite: {
        title: 'Creează workspace de onboarding',
        description:
          'Pornește un workspace curat sau cu aplicații built-in și preseturi.'
      },
      security: {
        title: 'Îmbunătățește securitatea contului',
        description:
          'Revizuiește metodele personale de autentificare și aplică politici mai stricte.'
      }
    }
  },
  credentials: {
    optional: 'opțional',
    reasonLabel: 'Motiv',
    reasonPlaceholder: 'De ce este revocată această credențială?',
    newExpiryLabel: 'Expirare nouă',
    newExpiryPlaceholder: 'Fără expirare',
    revokeOldLabel: 'Revocă tokenul anterior'
  },
  workspace: {
    credentials: {
      status: {
        active: 'Activă',
        revoked: 'Revocată',
        expired: 'Expirată'
      },
      columns: {
        status: 'Status',
        expires: 'Expiră',
        lastUsed: 'Ultima utilizare',
        created: 'Creat',
        createdBy: 'Creat de',
        id: 'ID credențială'
      },
      noExpiry: 'Niciodată',
      neverUsed: 'Niciodată folosit',
      revokedReason: 'Motiv: {{reason}}',
      revokedAt: 'Revocat {{at}}',
      noPermissions: 'Nu există permisiuni pentru această aplicație.',
      appSummary: '{{permissions}} permisiuni pe {{resources}} resurse',
      tokenReveal: {
        title: 'Copiază cheia acum',
        body: 'Aceasta este singura dată când cheia va fi afișată. Păstreaz-o într-un loc sigur — după ce părăsești sau reîncarci pagina, nu mai poate fi recuperată.',
        done: 'Am salvat cheia'
      },
      quickStart: {
        title: 'Start rapid',
        intro:
          'Trimite cheia în antetul Authorization al oricărei cereri. Fiecare aplicație asociată își definește propriile endpoints, corpul cererii și răspunsul — vezi documentația aplicației pentru detalii.',
        copy: 'Copiază exemplul',
        docs: 'Documentație API',
        endpointHint:
          'Înlocuiește <APP_ENDPOINT> cu ruta reală din documentația aplicației tale. Fiecare aplicație are propriile rute și structuri de payload.',
        tokenHint:
          'Tokenul este afișat o singură dată, la creare. Înlocuiește <YOUR_API_TOKEN> cu valoarea salvată atunci.',
        tips: {
          storage:
            'Păstrează cheia într-un manager de secrete sau o variabilă de mediu server-side — nu o urca niciodată în controlul versiunilor.',
          transport: 'Trimite cheia doar prin HTTPS.',
          rotate:
            'Rotește cheia periodic — sau imediat dacă ar putea fi expusă.',
          scope:
            'Acordă doar setul minim de permisiuni și aplicații asociate de care apelantul are nevoie.'
        }
      }
    },
    aiConnectors: {
      sectionTitle: 'Conectori AI',
      sectionDescription:
        'Conectați Claude, ChatGPT, Gemini, Cursor și alți clienți AI la acest spațiu de lucru. Fiecare conexiune acționează în numele dvs. și nu primește niciodată mai mult decât permisiunile dvs.',
      services: {
        core: {
          name: 'Core',
          description: 'Membri, echipe, roluri și setările spațiului de lucru.'
        },
        crm: {
          name: 'CRM',
          description: 'Contacte, companii, lead-uri, oportunități și sarcini.'
        },
        notification: {
          name: 'Notificări',
          description: 'Notificările dvs. și starea lor de citire.'
        },
        squad: {
          name: 'Squad',
          description: 'Agenți AI, rulările, aprobările și memoria lor.'
        }
      },
      clients: {
        claude: 'Claude (web / desktop)',
        claudeCode: 'Claude Code',
        chatgpt: 'ChatGPT',
        geminiCli: 'Gemini CLI',
        cursor: 'Cursor',
        vscode: 'VS Code',
        other: 'Altul (token)'
      },
      connect: {
        serviceStep: 'Serviciu',
        clientStep: 'Client AI',
        instructionsStep: 'Conectare',
        chooseService: 'La ce serviciu trebuie să ajungă clientul AI?',
        scopesHint:
          'Bifați un serviciu ca să alegeți ce poate face clientul acolo; toate scope-urile sunt active implicit. Pagina de consimțământ se deschide cu aceeași alegere.',
        scopesCount: '{{count}} din {{total}} scope-uri',
        scopesEmpty: 'Alegeți cel puțin un scope pentru {{service}}.',
        clientHints: {
          claude: 'claude.ai sau aplicația desktop, din Settings → Connectors',
          claudeCode: 'O singură comandă în terminal',
          chatgpt: 'Un conector în modul dezvoltator',
          geminiCli: 'Un server în ~/.gemini/settings.json',
          cursor: 'Un server în ~/.cursor/mcp.json',
          vscode: 'Un server în .vscode/mcp.json',
          other: 'Orice client MCP, cu un token personal'
        },
        chooseClient: 'Ce client AI folosiți?',
        noServices:
          'Încă nu aveți niciun serviciu disponibil. Rugați un administrator să activeze unul în Conectori AI.',
        mcpUrl: 'URL-ul serverului MCP',
        mcpUrls: 'URL-urile serverelor MCP',
        repeatPerUrl:
          'Adăugați câte un conector pentru fiecare URL de mai sus.',
        tokenOneService:
          'Un token personal se emite pentru un singur serviciu. Alegeți un singur serviciu ca să-l folosiți.',
        snippetTitle: 'Configurație',
        copy: 'Copiază',
        copied: 'Copiat',
        copyFailed: 'Nu s-a putut copia. Selectați textul și copiați-l manual.',
        tokenLocked:
          'Copiați tokenul înainte de a continua. Închideți-l pentru a alege alt serviciu sau client.',
        oauthHint:
          'La prima utilizare, clientul deschide o pagină Skalx: autentificați-vă, alegeți acest spațiu de lucru și permiteți accesul.',
        steps: {
          claude: {
            s1: 'În Claude, deschideți Settings → Connectors.',
            s2: 'Faceți clic pe „Add custom connector”.',
            s3: 'Lipiți URL-ul serverului MCP, faceți clic pe Add, apoi pe Connect.'
          },
          chatgpt: {
            s1: 'În ChatGPT, deschideți Settings → Apps & Connectors.',
            s2: 'Activați Developer mode în setările avansate.',
            s3: 'Faceți clic pe Create, lipiți URL-ul serverului MCP și alegeți OAuth ca metodă de autentificare.'
          },
          claudeCode: {
            s1: 'Rulați acest lucru în terminal.',
            s2: 'Porniți Claude Code, rulați /mcp și autentificați-vă în {{server}}.'
          },
          geminiCli: {
            s1: 'Adăugați acest fragment în ~/.gemini/settings.json.',
            s2: 'Reporniți Gemini CLI și rulați /mcp auth {{server}} pentru autentificare.'
          },
          cursor: {
            s1: 'Adăugați acest fragment în ~/.cursor/mcp.json (sau în .cursor/mcp.json din proiect).',
            s2: 'Deschideți Cursor Settings → MCP și autentificați-vă în {{server}} când vi se cere.'
          },
          vscode: {
            s1: 'Adăugați acest fragment în .vscode/mcp.json din proiect.',
            s2: 'Porniți {{server}} din acel fișier și autentificați-vă când VS Code vă cere.'
          },
          other: {
            s1: 'Emiteți mai jos un token personal. Este afișat o singură dată.',
            s2: 'Adăugați serverul în client și trimiteți tokenul în antetul Authorization.'
          }
        },
        serviceOffAdmin:
          'Dezactivat în acest spațiu de lucru. Bifați-l ca să-l activați.',
        turnOff: 'Dezactivează',
        serviceOff: 'Dezactivat în acest spațiu de lucru.',
        adminServicesHint:
          'Bifarea unui serviciu dezactivat îl activează pentru spațiul de lucru. „Dezactivează” deconectează toți clienții acelui serviciu.',
        waitingTitle: 'Se așteaptă clientul AI…',
        waitingBody:
          'Parcurgeți pașii de mai sus și permiteți accesul pe fiecare pagină Skalx care se deschide. Pasul se încheie singur când clientul se conectează.',
        connectedTitle: 'Conectat',
        connectedBody:
          '{{name}} poate folosi acum {{services}} în acest spațiu de lucru.',
        done: 'Gata',
        open: 'Conectează',
        title: 'Conectați un client AI',
        closeWithTokenTitle: 'Închideți fără a salva tokenul?',
        closeWithTokenBody:
          'Tokenul personal este afișat o singură dată. Copiați-l înainte de a închide sau emiteți unul nou mai târziu.',
        closeWithTokenOk: 'Închide'
      },
      pat: {
        title: 'Token personal',
        intro:
          'Pentru clienții fără OAuth. Tokenul acționează în numele dvs., este limitat la permisiunile alese și expiră la data stabilită.',
        name: 'Nume',
        namePlaceholder: 'de ex. Script pe laptop',
        nameRequired: 'Introduceți un nume',
        expiresAt: 'Expiră la',
        expiresRequired: 'Alegeți o dată de expirare în cel mult un an',
        issue: 'Emite tokenul',
        placeholderHint:
          'Înlocuiți <YOUR_PERSONAL_TOKEN> cu tokenul emis mai sus.'
      },
      connections: {
        columns: {
          client: 'Client',
          user: 'Utilizator',
          service: 'Serviciu',
          scopes: 'Permisiuni',
          status: 'Stare',
          created: 'Creată',
          lastUsed: 'Ultima utilizare'
        },
        kind: {
          oauth: 'OAuth',
          pat: 'Token personal'
        },
        scopesCount_one: '{{count}} permisiune',
        scopesCount_few: '{{count}} permisiuni',
        scopesCount_other: '{{count}} de permisiuni',
        revokeReasons: {
          user: 'Revocată de utilizator',
          admin: 'Revocată de un administrator',
          policy_disabled: 'Serviciul a fost dezactivat',
          personal_tokens_disabled: 'Tokenurile personale au fost dezactivate',
          client: 'Revocată de clientul AI',
          refresh_reuse: 'Reutilizare token detectată',
          membership_removed: 'Eliminat din spațiul de lucru',
          membership_blocked: 'Suspendat în spațiul de lucru',
          app_access_removed: 'Acces la aplicație eliminat'
        },
        countLabel: 'conexiuni',
        filters: {
          service: 'Toate serviciile',
          user: 'Toți utilizatorii'
        },
        empty:
          'Încă niciun client AI nu este conectat la acest spațiu de lucru. Apăsați „Conectează” pentru a adăuga unul.',
        emptyMine:
          'Încă nu ați conectat niciun client AI. Apăsați „Conectează” pentru a adăuga unul.',
        revoke: 'Revocă',
        revokeTitle: 'Revocați această conexiune?',
        revokeBody:
          'Clientul AI pierde accesul în câteva secunde. Pentru a-l folosi din nou, conectați-l din nou.',
        revoked: 'Conexiune revocată',
        editScopes: 'Permisiuni',
        scopesTitle: 'Permisiunile conexiunii {{name}}',
        scopesHint:
          'Ce poate face această conexiune. Nu primește niciodată mai mult decât permisiunile dvs. în serviciu.',
        scopesSave: 'Salvează',
        scopesSaved: 'Permisiuni actualizate'
      },
      servicesTab: {
        empty:
          'Încă nu există servicii de conectori AI în acest spațiu de lucru.',
        needsInstance:
          'Instalați {{service}} în acest spațiu de lucru pentru a-l activa.',
        notConfigured:
          'Neconfigurat pentru acest mediu. {{service}} nu poate fi activat până nu este configurat.',
        saved: 'Serviciu actualizat',
        disableTitle: 'Dezactivați {{service}} pentru clienții AI?',
        disableBody:
          'Toate conexiunile și tokenurile personale pentru acest serviciu nu mai funcționează în câteva secunde.',
        disable: 'Dezactivează'
      },
      consent: {
        title: '{{client}} solicită acces la datele dvs. Skalx',
        unverified: 'Neverificat',
        unverifiedHint:
          'Skalx nu a verificat acest client. Permiteți doar dacă ați inițiat dvs. această conexiune.',
        redirectsTo: 'Veți reveni la {{host}}.',
        service: 'Serviciu',
        workspace: 'Spațiu de lucru',
        workspacePlaceholder: 'Alegeți un spațiu de lucru',
        scopes: 'Va putea',
        noScopes: 'Doar autentificare, fără acces la date.',
        actsAsYou:
          'Clientul acționează în numele dvs. și nu primește niciodată mai mult decât permisiunile dvs.',
        noWorkspaceTitle: 'Niciun spațiu de lucru nu permite această conexiune',
        noWorkspaceBody:
          '{{service}} nu este activat pentru clienții AI în niciun spațiu de lucru pe care îl puteți folosi. Rugați un administrator să îl activeze în Conectori AI, apoi conectați-vă din nou.',
        expiredTitle: 'Această cerere a expirat',
        expiredBody: 'Reveniți la clientul AI și începeți din nou conectarea.',
        allow: 'Permite',
        deny: 'Refuză'
      }
    },
    publicAccess: {
      sectionTitle: 'Credențiale de acces public',
      sectionDescription:
        'Tokenuri care acordă acces public (neautentificat) la aplicațiile selectate și permisiunile lor. Tokenul este afișat o singură dată, la creare sau rotire — copiază-l atunci și păstrează-l în siguranță.',
      create: 'Creează credențială',
      createDrawerTitle: 'Credențială de acces public nouă',
      editDrawerTitle: 'Editează credențiala de acces public',
      rotate: 'Rotește',
      revoke: 'Revocă',
      namePlaceholder: 'ex. Widget public de rezervări',
      expiresAt: 'Expiră la',
      expiresAtPlaceholder: 'Fără expirare',
      noExpiry: 'Niciodată',
      neverUsed: 'Niciodată folosit',
      empty: 'Nicio credențială de acces public încă.',
      revokedReason: 'Motiv: {{reason}}',
      revokedAt: 'Revocat {{at}}',
      rotateConfirmTitle: 'Rotești credențiala?',
      rotateConfirmBody:
        'Va fi emis un token nou. Cel curent rămâne valabil dacă nu îl revoci mai jos.',
      revokeConfirmTitle: 'Revoci credențiala?',
      revokeConfirmBody:
        'Acest token va înceta să funcționeze pentru toate integrările care îl folosesc. Acțiunea nu poate fi anulată.',
      toolbar: {
        count_one: '{{count}} credențială',
        count_few: '{{count}} credențiale',
        count_other: '{{count}} de credențiale',
        credentialsLabel: 'credențiale'
      },
      status: {
        active: 'Activă',
        revoked: 'Revocată',
        expired: 'Expirată'
      },
      columns: {
        name: 'Nume',
        apps: 'Aplicații',
        appsCount_one: '{{count}} aplicație',
        appsCount_few: '{{count}} aplicații',
        appsCount_other: '{{count}} de aplicații',
        status: 'Status',
        expires: 'Expiră',
        lastUsed: 'Ultima utilizare',
        actions: 'Acțiuni'
      },
      bindings: {
        label: 'Acces la aplicații',
        addApp: 'Adaugă aplicație',
        removeApp: 'Elimină aplicația',
        appPlaceholder: 'Selectează aplicația',
        permissionsPlaceholder: 'Selectează permisiunile',
        permissionCount_one: '{{count}} permisiune',
        permissionCount_few: '{{count}} permisiuni',
        permissionCount_other: '{{count}} de permisiuni',
        required: 'Adaugă cel puțin o aplicație.',
        unbindableApp:
          'O aplicație selectată nu poate fi asociată (identificator lipsă).',
        none: 'Nicio aplicație asociată.'
      },
      messages: {
        updated: 'Credențială actualizată',
        revoked: 'Credențială revocată',
        rotated: 'Credențială rotită'
      },
      detail: {
        back: 'Înapoi la credențialele de acces public',
        tokenReveal: {
          title: 'Copiază cheia acum',
          body: 'Aceasta este singura dată când cheia va fi afișată. Păstreaz-o într-un loc sigur — după ce părăsești sau reîncarci pagina, nu mai poate fi recuperată.',
          done: 'Am salvat cheia'
        },
        overview: {
          title: 'Prezentare',
          id: 'ID credențială',
          created: 'Creat',
          createdBy: 'Creat de',
          noPermissions: 'Nu există permisiuni pentru această aplicație.',
          resourceCount_one: '{{count}} resursă',
          resourceCount_few: '{{count}} resurse',
          resourceCount_other: '{{count}} de resurse',
          appSummary: '{{permissions}} permisiuni pe {{resources}} resurse'
        },
        quickStart: {
          title: 'Start rapid',
          intro:
            'Trimite cheia în antetul Authorization al oricărei cereri. Fiecare aplicație asociată își definește propriile endpoints, corpul cererii și răspunsul — vezi documentația aplicației pentru detalii.',
          copy: 'Copiază exemplul',
          endpointHint:
            'Înlocuiește <APP_ENDPOINT> cu ruta reală din documentația aplicației tale. Fiecare aplicație are propriile rute și structuri de payload.',
          tokenHint:
            'Tokenul este afișat o singură dată, la creare. Înlocuiește <YOUR_API_TOKEN> cu valoarea salvată atunci.',
          tips: {
            storage:
              'Păstrează cheia într-un manager de secrete sau o variabilă de mediu server-side — nu o urca niciodată în controlul versiunilor.',
            transport: 'Trimite cheia doar prin HTTPS.',
            rotate:
              'Rotește cheia periodic — sau imediat dacă ar putea fi expusă.',
            scope:
              'Acordă doar setul minim de permisiuni și aplicații asociate de care apelantul are nevoie.'
          }
        }
      }
    },
    tab: {
      overview: 'Prezentare',
      users: 'Utilizatori',
      members: 'Utilizatori',
      roles: 'Roluri',
      security: 'Securitate',
      ssoScim: 'SSO / SCIM',
      domains: 'Domenii',
      agents: 'Agenți',
      audit: 'Audit',
      billing: 'Facturare și utilizare'
    },
    overviewPage: {
      sectionTitle: 'Prezentare',
      sectionDescription:
        'Rezumat al workspace-ului, statistici rapide și scurtături către setări frecvente.',
      workspaceId: 'ID workspace',
      primaryDomain: 'Domeniu principal',
      created: 'Creat la',
      statMembers: 'Membri',
      statApps: 'Aplicații',
      statRoles: 'Roluri',
      statAuthMethods: 'Metode auth',
      statSsoScim: 'SSO / SCIM',
      statApiKeys: 'Chei API',
      platformModel: 'Model platformă',
      platformModelValue:
        'Acest workspace funcționează ca nucleu de identitate pentru membri, provideri, politici de securitate și accesul în aplicații.',
      appPortfolio: 'Portofoliu aplicații',
      appPortfolioValue:
        '{{builtIn}} aplicații built-in și {{custom}} aplicații custom consumă nucleul workspace-ului în {{count}} aplicații configurate.',
      identityCoverage: 'Acoperire identitate',
      identityCoverageValue:
        '{{authMethods}} metode de sign-in, {{roles}} roluri, {{sso}} conexiuni SSO și {{scim}} puncte SCIM sunt active în acest workspace.',
      apiSurface: 'Suprafață API',
      apiSurfaceValue:
        '{{apiKeys}} chei API de workspace susțin automatizarea în {{apps}} integrări de aplicații.',
      platformHealth: 'Sănătate platformă',
      platformHealthSso: 'SSO',
      platformHealthScim: 'SCIM',
      platformHealthMfa: 'Adoptare MFA',
      platformHealthApiKeysExpiring: 'Chei API expiră',
      platformHealthConnected: '{{count}} conectate',
      platformHealthNotConfigured: 'Neconfigurat',
      platformHealthSyncActive: 'Sincronizare activă',
      platformHealthExpiresSoon: 'Expiră în 30 zile',
      goToMembers: 'Gestionează membrii',
      goToApps: 'Vezi aplicațiile',
      goToSecurity: 'Setări securitate'
    },
    membersPage: {
      sectionDescription:
        'Utilizatorii din spațiul de lucru, invitațiile, accesul la aplicații și rolurile.'
    },
    membersTeams: {
      listTitleWithCount: '{{label}} ({{count}})',
      tabs: {
        members: 'Membri',
        teams: 'Echipe',
        divisions: 'Diviziuni',
        departments: 'Departamente'
      },
      teamsCardTitle: 'Echipe workspace',
      teamsCardDescription:
        'Creează echipe, grupează membrii după funcție și atașează roluri ale organizației acestor apartenențe la echipă.',
      teamMembersTitle: 'Apartenențe la echipă',
      createTeam: 'Creează echipă',
      manageTeam: 'Gestionează echipa',
      assignMember: 'Atribuie membru',
      createRole: 'Creează rol de echipă',
      assignMemberTitle: 'Atribuie membru în echipă',
      editMemberRolesTitle: 'Editează rolurile echipei',
      createRoleTitle: 'Creează rol de echipă',
      editRoleTitle: 'Editează rolul echipei',
      createTeamModalTitle: 'Creează echipă workspace',
      deleteConfirm: 'Ștergi această echipă?',
      deleteRoleConfirm: 'Ștergi acest rol de echipă?',
      removeMemberConfirm: 'Elimini acest membru din echipă?',
      selectTeam:
        'Selectează o echipă pentru a-i gestiona membrii și rolurile.',
      emptyTeams: 'Încă nu există echipe.',
      emptyTeamRoles: 'Încă nu există roluri de echipă.',
      emptyTeamMembers: 'Niciun membru atribuit acestei echipe.',
      childTeam: 'Echipă copil',
      headRole: 'Rol principal',
      membersCount: '{{count}} membri',
      columns: {
        team: 'Echipă',
        type: 'Tip',
        members: 'Membri',
        teams: 'Echipe',
        actions: 'Acțiuni'
      },
      membersColumns: {
        member: 'Membru',
        roles: 'Roluri',
        permissions: 'Permisiuni',
        actions: 'Acțiuni'
      },
      roleColumns: {
        role: 'Rol',
        permissions: 'Permisiuni',
        actions: 'Acțiuni'
      },
      form: {
        teamName: 'Nume echipă',
        teamType: 'Tip echipă',
        abbreviation: 'Abreviere',
        parentTeam: 'Echipă părinte',
        member: 'Membru',
        teamRoles: 'Roluri în echipă',
        roleName: 'Nume rol',
        headRole: 'Rol principal',
        permissionGroup: 'Grup de permisiuni',
        application: 'Aplicație',
        permissions: 'Permisiuni'
      },
      teamRolesTitle: 'Roluri de echipă',
      addPermissionGroup: 'Adaugă grup de permisiuni',
      teamType: {
        branch: 'Ramură',
        department: 'Departament',
        section: 'Secțiune'
      },
      messages: {
        teamCreated: 'Echipa a fost creată cu succes',
        teamDeleted: 'Echipa a fost ștearsă cu succes',
        roleCreated: 'Rolul de echipă a fost creat',
        roleUpdated: 'Rolul de echipă a fost actualizat',
        roleDeleted: 'Rolul de echipă a fost șters',
        memberAssigned: 'Membrul a fost atribuit echipei',
        membershipUpdated: 'Rolurile echipei au fost actualizate',
        memberRemoved: 'Membrul a fost eliminat din echipă'
      }
    },
    orgChart: {
      tabTitle: 'Organigramă',
      types: {
        company: 'Companie',
        division: 'Divizie',
        department: 'Departament',
        team: 'Echipă'
      },
      membersLabel: 'membri',
      memberTable: {
        name: 'Nume',
        role: 'Rol',
        email: 'Email',
        joined: 'Adăugat'
      },
      mockNotice:
        'Date eșantion pentru layout și fluxuri. Se resetează la reîncărcarea paginii și nu este încă sincronizată cu API.',
      organization: 'Organizație',
      backToMembers: 'Înapoi la membri',
      notFound: 'Acest element nu mai este în directorul eșantion.',
      actions: {
        manage: 'Gestionează',
        edit: 'Editează',
        open: 'Acțiuni',
        view: 'Vezi'
      },
      columns: {
        name: 'Nume',
        owner: 'Responsabil',
        roles: 'Roluri',
        division: 'Diviziune',
        department: 'Departament',
        departments: 'Departamente',
        teams: 'Echipe',
        members: 'Membri',
        actions: 'Acțiuni'
      },
      fields: {
        name: 'Nume',
        abbreviation: 'Abreviere',
        abbreviationHelp: 'Doar litere majuscule, 2-10 caractere',
        description: 'Descriere',
        owner: 'Responsabil',
        ownerPlaceholder: 'Selectați persoana responsabilă',
        parent: 'Părinte',
        parentDivision: 'Diviziune',
        department: 'Departament'
      },
      divisions: {
        hint: 'Diviziunile sunt sub workspace. Grupează departamente; workspace-ul este părintele — fără selector de părinte.',
        add: 'Adaugă diviziune',
        drawerTitle: 'Adaugă diviziune',
        editDrawerTitle: 'Editează diviziunea',
        deleteConfirm:
          'Ștergeți această divizie? Departamentele aferente vor rămâne neasignate.'
      },
      division: {
        departmentsTableTitle: 'Departamente în această diviziune',
        departmentsTableHint:
          'Deschide un departament pentru a gestiona echipele sau adaugă unul nou sub această diviziune.',
        addDepartmentDrawerTitle: 'Adaugă departament în această diviziune'
      },
      departments: {
        hint: 'Departamentele pot aparține opțional unei diviziuni. Echipele trebuie să aparțină unui departament.',
        add: 'Adaugă departament',
        drawerTitle: 'Adaugă departament',
        editDrawerTitle: 'Editează departamentul',
        divisionPlaceholder: 'Opțional — atribuie unei diviziuni',
        noDivision: 'Fără diviziune',
        deleteConfirm:
          'Ștergeți acest departament? Echipele aferente vor rămâne neasignate.'
      },
      department: {
        teamsTableTitle: 'Echipe în acest departament',
        teamsTableHint:
          'Echipele sunt mereu sub un departament. Deschide una pentru a gestiona membrii.',
        addTeamDrawerTitle: 'Adaugă echipă în acest departament'
      },
      teams: {
        hint: 'Echipele aparțin mereu unui departament. Alege departamentul la creare.',
        add: 'Adaugă echipă',
        drawerTitle: 'Adaugă echipă',
        editDrawerTitle: 'Editează echipa',
        deleteConfirm: 'Ștergeți această echipă? Membrii vor fi dezasignați.'
      },
      team: {
        membersTableTitle: 'Membrii echipei',
        membersTableHint:
          'Membrii workspace atribuiți acestei echipe. Elimină accesul sau invită din fila Membri.',
        addMember: 'Adaugă membri',
        addMemberDrawerTitle: 'Adaugă membri în echipă',
        selectMember: 'Membru',
        selectMembers: 'Membri workspace',
        selectMembersPlaceholder: 'Selectează unul sau mai mulți membri',
        removeMember: 'Elimină',
        removeMemberConfirm: 'Elimini acest membru din echipă?'
      },
      memberDetail: {
        email: 'Email',
        phone: 'Telefon',
        location: 'Locație',
        joinedAt: 'Înscris în workspace',
        manager: 'Manager',
        sectionAccess: 'Acces workspace',
        permissions: 'Permisiuni',
        permissionsEmpty:
          'Nicio permisiune înregistrată pentru acest membru eșantion.',
        sectionFunctions: 'Rol și funcții',
        jobTitle: 'Titlu post',
        functions: 'Funcții',
        functionsEmpty: 'Nicio funcție atribuită.',
        sectionTeams: 'Echipe',
        teamsEmpty: 'Nu este atribuit niciunei echipe încă.',
        appAccess: {
          sectionTitle: 'Acces la aplicații',
          selectRole: 'Selectează un rol',
          noRoleAvailable: 'Niciun rol disponibil',
          emptyState: 'Nu există aplicații în acest workspace.',
          permissionsUpdated: 'Acces la aplicații actualizat'
        }
      },
      nodeDetail: {
        owner: 'Responsabil',
        members: 'Membri',
        childUnits: 'Unități directe',
        directReports: 'Rapoarte directe'
      },
      invites: {
        title: 'Invitații',
        description:
          'Gestionați invitațiile în așteptare. Utilizatorii invitați vor primi un email pentru a se alătura.',
        empty: 'Nicio invitație în așteptare.',
        inviteButton: 'Invită prin email',
        drawerTitle: 'Invită persoane',
        submit: 'Trimite invitații',
        emailsPlaceholder:
          'Introdu sau lipește emailuri, separate prin virgulă sau spațiu',
        fields: {
          emails: 'Adrese email',
          manager: 'Manager',
          teams: 'Echipe',
          team: 'Echipă'
        },
        teamPlaceholder: 'Opțional — o echipă per invitație',
        columns: {
          emails: 'Emailuri',
          manager: 'Manager',
          teams: 'Echipe',
          status: 'Status',
          invitedAt: 'Invitat',
          actions: 'Acțiuni'
        },
        actions: {
          resend: 'Retrimite invitația',
          revoke: 'Marchează expirată'
        }
      },
      inviteStatus: {
        pending: 'În așteptare',
        expired: 'Expirată',
        accepted: 'Acceptată'
      },
      members: {
        title: 'Membri',
        hint: 'Persoane active în eșantionul workspace. Blochează sau deblochează direct din tabel.',
        addButton: 'Adaugă membru',
        drawerTitle: 'Adaugă membru',
        submit: 'Adaugă membru',
        notFound: 'Niciun rezultat pentru "{{keyword}}"',
        notFoundHint:
          'Această persoană nu este încă în sistem. Trimiteți o invitație pentru a-i crea contul.',
        fields: {
          name: 'Nume complet',
          email: 'Email',
          role: 'Rol workspace',
          manager: 'Manager',
          teams: 'Echipe',
          team: 'Echipă'
        },
        teamPlaceholder: 'Opțional — o echipă per membru',
        columns: {
          name: 'Nume',
          email: 'Email',
          role: 'Rol',
          manager: 'Manager',
          teams: 'Echipe',
          status: 'Status',
          actions: 'Acțiuni'
        },
        actions: {
          block: 'Blochează membru',
          unblock: 'Deblochează membru'
        }
      },
      memberStatus: {
        active: 'Activ',
        inactive: 'Inactiv',
        blocked: 'Blocat',
        invited: 'Invitat'
      },
      workspaceRole: {
        owner: 'Proprietar',
        admin: 'Admin',
        employee: 'Membru'
      },
      validation: {
        emailsRequired: 'Adaugă cel puțin o adresă de email.',
        nameRequired: 'Introdu un nume.',
        departmentRequired: 'Selectează departamentul pentru această echipă.',
        membersRequired: 'Selectează cel puțin un membru.',
        organizationNotReady: 'Workspace-ul încă se încarcă, încearcă din nou.'
      },
      messages: {
        divisionAdded: 'Diviziune adăugată.',
        divisionUpdated: 'Diviziune actualizată.',
        departmentAdded: 'Departament adăugat.',
        departmentUpdated: 'Departament actualizat.',
        teamAdded: 'Echipă adăugată.',
        teamUpdated: 'Echipă actualizată.',
        inviteCreated: 'Invitație înregistrată.',
        inviteResent: 'Invitație retrimisă.',
        inviteRevoked: 'Invitație marcată expirată.',
        memberAdded: 'Membru adăugat.',
        memberBlocked: 'Membru blocat.',
        memberUnblocked: 'Membru deblocat.',
        memberAddedToTeam: 'Membru adăugat în echipă.',
        membersAddedToTeam: 'Membrii au fost adăugați în echipă.',
        memberRemovedFromTeam: 'Membru eliminat din echipă.',
        divisionDeleted: 'Divizie ștearsă.',
        departmentDeleted: 'Departament șters.',
        teamDeleted: 'Echipă ștearsă.',
        memberUpdated: 'Membru actualizat.'
      },
      zoomIn: 'Mărește',
      zoomOut: 'Micșorează',
      resetView: 'Resetează vizualizarea',
      collapseHint: 'Click pentru a restrânge/extinde'
    },
    billingPage: {
      sectionTitle: 'Facturare și utilizare',
      sectionDescription:
        'Previzualizare utilizare la nivel de workspace. Gestionarea abonamentului detaliată poate folosi facturarea contului când este conectată.',
      goToAccountBilling: 'Deschide facturarea contului',
      usageTitle: 'Prezentare utilizare',
      period: {
        current: 'Luna aceasta',
        previous: 'Luna trecută',
        quarter: 'Ultimul trimestru'
      },
      overageWarning:
        'Utilizare ridicată detectată pentru {{period}}. Unele metrici se apropie de limite.'
    },
    users: {
      stub: 'Gestionarea membrilor workspace va fi disponibilă aici.',
      openDirectory: 'Deschide directorul de utilizatori',
      memberTableTitle: 'Membri workspace',
      memberCountSuffix: 'membri',
      columns: {
        member: 'Membru',
        role: 'Rol',
        status: 'Status',
        joinedAt: 'Data aderării',
        actions: 'Acțiuni'
      },
      status: {
        active: 'Activ',
        invited: 'Invitat',
        suspended: 'Suspendat'
      },
      remove: 'Elimină',
      removeConfirm: 'Eliminați acest membru din workspace?',
      invite: {
        nameLabel: 'Nume complet',
        email: 'Email utilizator',
        roleLabel: 'Rol',
        submit: 'Invită utilizator',
        success: 'Invitația a fost trimisă cu succes',
        modalTitle: 'Invită membru',
        openButton: 'Invită membru',
        manager: 'Manager (opțional)',
        role: 'Rol'
      }
    },
    billing: {
      mockNotice:
        'Valorile de mai jos sunt exemple pentru interfață. Se vor conecta la API de facturare când va fi disponibil.',
      period: 'Perioadă de facturare',
      apiRequests: 'Cereri API',
      storageGb: 'Stocare',
      aiTokensUsed: 'Tokeni AI folosiți',
      aiTokensLimit: 'Limită tokeni AI'
    },
    agents: {
      title: 'Agenți',
      description:
        'Înregistrați agenți AI ca identități guvernate, izolate pe tenant. Acordați acces minim necesar la aplicații, brokerați accesul lor la instrumente externe, apoi rotiți, revocați și auditați.',
      mockNotice:
        'Date de previzualizare — agenții, conexiunile și tokenurile sunt stocate în mock-ul local. Emiterea de tokenuri și handshake-urile OAuth externe sunt simulate până la apariția backendului.',
      register: 'Înregistrează agent',
      empty:
        'Niciun agent încă. Înregistrați unul pentru a oferi unui agent AI acces cu domeniu definit la aplicații și instrumente.',
      moreScopes: '+{{count}} în plus',
      kpi: {
        agents: 'Agenți',
        active: 'Activi',
        delegated: 'Delegați',
        expiringSoon: 'Expiră curând',
        pendingApprovals: 'Aprobări în așteptare'
      },
      visibility: {
        private: 'Privat',
        public: 'Public',
        restricted: 'Restricționat'
      },
      tier: {
        system: 'Sistem',
        template: 'Șablon',
        workspace: 'Spațiu de lucru',
        personal: 'Personal'
      },
      restricted: {
        label: 'Restricționat'
      },
      runAs: {
        shareWarning: {
          title: 'Automatizările tale vor rula în continuare ca tine',
          body: 'Acest agent are {{count}} declanșatoare ale tale ({{schedules}} programate, {{channels}} webhook, {{widgets}} widget). Odată deschis spațiului de lucru, colegii pot schimba ce face — iar rulările vor folosi tot permisiunile tale.',
          confirm: 'Partajeaza oricum',
          cancel: 'Pastreaza restricționat'
        }
      },
      toolExecution: {
        ask: 'Cere aprobare înainte de a rula tool-uri',
        auto: 'Rulează tool-urile autonom'
      },
      delete: {
        confirmTitle: 'Ștergeți agentul?',
        confirmBody:
          '„{{name}}” este eliminat definitiv împreună cu permisiunile sale. Această acțiune nu poate fi anulată.',
        success: 'Agent șters'
      },
      toolbar: {
        showing: 'Se afișează {{shown}} din {{total}}'
      },
      intro: {
        lead: 'Agenții sunt identități non-umane pe care organizația le folosește pentru a acționa în platformă — autonom sau în numele unui utilizator. Se autentifică cu tokenuri scurte, izolate pe tenant (niciodată chei statice) și accesează instrumente externe printr-un vault securizat.',
        howTitle: 'Cum funcționează',
        whereTitle: 'Când să îl folosești',
        where:
          'Folosește un agent oricând un software — o automatizare, un bot sau un asistent AI — are nevoie de acces guvernat la aplicațiile tale sau la instrumente externe, cu audit complet și revocare instantanee.',
        hide: 'Ascunde ghidul',
        show: 'Cum funcționează agenții',
        steps: {
          register: {
            title: '1 · Înregistrează',
            desc: 'Creează o identitate de agent — Serviciu (autonom) sau Delegat (acționează pentru un utilizator).'
          },
          scope: {
            title: '2 · Acordă acces',
            desc: 'Oferă acces minim necesar la aplicații și operațiuni specifice.'
          },
          connect: {
            title: '3 · Conectează instrumente',
            desc: 'Opțional, conectează Gmail, Slack și altele prin vault — agentul nu vede niciodată credențialele.'
          },
          authenticate: {
            title: '4 · Autentifică',
            desc: 'Agentul primește tokenuri scurte, izolate pe tenant. Fără chei statice.'
          },
          call: {
            title: '5 · Apelează instrumente',
            desc: 'Capabilitățile sunt expuse ca instrumente MCP pe care agentul le descoperă și le apelează.'
          },
          approve: {
            title: '6 · Aprobă',
            desc: 'Apelurile cu risc ridicat se opresc pentru aprobare umană prin device sau CIBA înainte de execuție.'
          },
          govern: {
            title: '7 · Guvernează',
            desc: 'Rotește, revocă, verifică și auditează orice acțiune oricând.'
          }
        },
        typesTitle: 'Două tipuri de agenți'
      },
      agentType: {
        service: 'Serviciu',
        delegated: 'Delegat'
      },
      agentTypeHint: {
        service:
          'Deținut de organizație, acționează autonom prin grant-ul client-credentials.',
        delegated:
          'Deținut de un utilizator, acționează în numele lui prin authorization-code + schimb de tokenuri.'
      },
      status: {
        active: 'Activ',
        suspended: 'Suspendat',
        revoked: 'Revocat',
        expired: 'Expirat'
      },
      list: {
        search: 'Caută după nume sau client ID',
        openRow: 'Deschide {{name}}',
        filterType: 'Tip',
        filterVerified: 'Verificare',
        all: 'Toate',
        expiringSoon: 'Expiră curând',
        kpiTotal: 'Agenți',
        kpiActive: 'Activi',
        kpiDelegated: 'Delegați',
        kpiExpiring: 'Expiră curând',
        kpiPendingApprovals: 'Aprobări în așteptare'
      },
      verified: {
        yes: 'Verificat',
        no: 'Neverificat'
      },
      verifiedTooltip:
        'Agenții verificați pot primi acces mai larg. Agenții neverificați ar trebui restricționați.',
      columns: {
        name: 'Agent',
        type: 'Tip',
        actingUser: 'Acționează pentru',
        scopes: 'Acces aplicații',
        connections: 'Conexiuni',
        lastActive: 'Ultima activitate',
        created: 'Creat',
        status: 'Stare',
        actions: 'Acțiuni'
      },
      noConnections: 'Niciun instrument',
      noScopes: 'Fără acces la aplicații',
      moreApps: '+{{count}} în plus',
      lastActiveNever: 'Niciodată',
      actions: {
        open: 'Deschide',
        rotate: 'Rotește secretul',
        revoke: 'Revocă',
        delete: 'Șterge',
        configure: 'Configurează',
        viewActivity: 'Activitate',
        suspend: 'Suspendă',
        resume: 'Reia',
        reconnect: 'Reconectează'
      },
      rotate: {
        confirmTitle: 'Rotiți secretul agentului?',
        confirmBody:
          'Secretul curent încetează imediat să funcționeze. Noul secret este afișat o singură dată.',
        success: 'Secret rotit'
      },
      revoke: {
        confirmTitle: 'Revocați agentul?',
        confirmBody:
          '„{{name}}” pierde tot accesul imediat, iar tokenurile sunt invalidate. Acțiunea nu poate fi anulată.',
        success: 'Agent revocat'
      },
      messages: {
        registered: 'Agent înregistrat',
        updated: 'Agent actualizat',
        scopesUpdated: 'Domenii actualizate',
        scopeRevoked: 'Domeniu revocat',
        connected: 'Instrument conectat',
        disconnected: 'Instrument deconectat',
        reconnected: 'Instrument reconectat',
        tokenIssued: 'Token de test emis',
        verifiedSet: 'Verificare actualizată',
        suspended: 'Agent suspendat',
        resumed: 'Agent reluat'
      },
      reveal: {
        title: 'Credențiale agent',
        warning:
          'Copiați secretul de client acum — este afișat o singură dată.',
        clientId: 'Client ID',
        secret: 'Secret de client',
        done: 'Gata'
      },
      form: {
        registerTitle: 'Înregistrează agent',
        editTitle: 'Configurează agent',
        registerNotice:
          'Agentul acționează în numele celui care discută cu el, prin clientul OAuth Core partajat al spațiului de lucru. După înregistrare, conectați instrumente și acordați acces pe pagina agentului.',
        name: 'Nume',
        nameRequired: 'Introduceți un nume',
        nameDuplicate: 'Există deja un agent cu acest nume',
        namePlaceholder: 'ex. Agent cercetare facturare',
        description: 'Descriere',
        descriptionOptional: 'opțional',
        descriptionPlaceholder: 'Ce face agentul și eventuale limite.',
        systemPrompt: 'Prompt de sistem',
        systemPromptHint:
          'Instrucțiuni care modelează modul în care răspunde agentul.',
        systemPromptPlaceholder: 'Ești un asistent util care…',
        visibility: 'Vizibilitate',
        tier: 'Proprietate',
        tierHint:
          'Agenții personali sunt doar ai tăi; agenții de spațiu de lucru sunt partajați cu organizația.',
        restricted: 'Doar utilizatorilor atribuiți',
        restrictedHint:
          'Implicit agentul urmează tipul său (personal = doar tu; spațiu de lucru = toată lumea). Activează pentru a-l limita la utilizatorii atribuiți.',
        toolExecutionMode: 'Execuție tool-uri',
        toolExecutionModeHint:
          'Autonom rulează tool-urile de scriere fără să întrebe. Cere aprobare oprește execuția pentru aprobarea ta înainte de fiecare tool de scriere/distructiv. Tool-urile read-only rulează mereu.',
        autoApprovedTools: 'Tool-uri mereu aprobate',
        autoApprovedToolsHint:
          'Tool-urile pentru care ai ales „Aprobă mereu” în chat — nu mai cer aprobare pentru acest agent. Șterge o etichetă ca să întrebe din nou.',
        autoApprovedToolsEmpty: 'Niciunul încă.',
        type: 'Tip agent',
        typeRequired: 'Alegeți un tip de agent',
        actingUser: 'Acționează în numele',
        actingUserRequired:
          'Selectați utilizatorul pentru care acționează agentul',
        actingUserPlaceholder: 'Selectați un membru',
        actingUserHint:
          'Tokenurile delegate poartă atât utilizatorul, cât și agentul; accesul efectiv este intersecția celor două.',
        scopes: 'Domenii permise',
        scopesHint:
          'Plafonul de capabilități pe care agentul îl poate solicita. Pentru fiecare utilizator, accesul efectiv este intersecția acestor domenii cu permisiunile sale (privilegiu minim).',
        addScope: 'Adaugă aplicație',
        app: 'Aplicație',
        appPlaceholder: 'Selectați o aplicație',
        appAlreadyAdded: 'Deja adăugată',
        permissions: 'Permisiuni',
        permissionsPlaceholder: 'Toate permisiunile din această aplicație',
        noPermissions: 'Această aplicație nu are încă permisiuni granulare.',
        removeScope: 'Elimină',
        ttl: 'Durata tokenului de acces',
        ttlHint: 'Scurtă; este suportat refresh-ul cu rotație.',
        ttlSuffix: 'min',
        expiresAt: 'Expirare agent',
        expiresAtOptional: 'opțional',
        expiresAtPlaceholder: 'Fără expirare',
        cancel: 'Anulează',
        submit: 'Înregistrează agent',
        save: 'Salvează modificările'
      },
      detail: {
        notFound: 'Agentul nu a fost găsit',
        tabs: {
          overview: 'Prezentare',
          mcp: 'MCP',
          access: 'Acces',
          approvals: 'Aprobări',
          connections: 'Conexiuni',
          externalTools: 'Externe',
          activity: 'Activitate'
        },
        hero: {
          clientId: 'Client ID',
          actingUser: 'Acționează pentru',
          owner: 'Proprietar',
          type: 'Tip',
          created: 'Creat',
          expires: 'Expiră',
          noExpiry: 'Fără expirare',
          scopes: 'Domenii permise',
          scopesCount: '{{count}} domeniu',
          scopesCount_other: '{{count}} domenii',
          model: 'Model'
        }
      },
      overview: {
        identityTitle: 'Identitate delegată',
        identityBody:
          'Cererile acționează ca „{{name}}” în numele celui care discută cu agentul, prin clientul OAuth Core partajat al spațiului de lucru. Nu există secret, durată de token sau utilizator fix per agent.',
        identityHint:
          'Accesul efectiv la fiecare cerere este intersecția domeniilor permise ale agentului cu permisiunile Skalx ale acelui utilizator, aplicată de Core.',
        agentId: 'ID agent',
        workspaceClient: 'Client spațiu de lucru (org)',
        scopeCeiling: 'Plafon domenii',
        provider: 'Model',
        toolExecutionMode: 'Execuție tool-uri'
      },
      access: {
        title: 'Domenii permise',
        save: 'Salvează domeniile',
        intersectionTitle: 'Cum se calculează accesul efectiv',
        intersectionBody:
          'Domeniile se acordă per conexiune mai jos — fiecare instrument conectat (și fiecare instanță) are propriile sale. Pentru fiecare utilizator care discută cu acest agent, poate face doar (domeniile acordate) ∩ (ce îi este permis în Skalx). Gestionați cine poate folosi agenți în <rolesLink>Roluri</rolesLink>.',
        emptyBody:
          'Acest agent nu are încă instrumente conectate. Conectați mai întâi un server MCP, apoi acordați domeniile sale aici.',
        emptyCta: 'Conectează un instrument',
        noScopesForApp: 'Această conexiune nu are domenii configurabile.',
        empty: 'Niciun domeniu acordat.'
      },
      mcp: {
        introTitle: 'Conectează instrumente (MCP)',
        introBody:
          'Conectați aplicațiile pe care agentul le poate folosi și acordați-i permisiunile fiecărei conexiuni mai jos. Agentul poate face doar (domeniile acordate) ∩ (ce îi este permis fiecărui utilizator în Skalx).',
        permissions: 'Permisiuni',
        title: 'Conexiuni la instrumente',
        empty: 'Nu există încă integrări de instrumente disponibile.',
        connect: 'Conectează',
        connectedTag: 'Conectat',
        connected: 'Instrument conectat',
        detached: 'Instrument deconectat',
        detach: 'Deconectează',
        detachConfirm: 'Deconectați acest server de la agent?',
        enabledTip:
          'Activat — agentul poate apela instrumentele acestui server.',
        disabledTip:
          'Dezactivat — atașat, dar instrumentele nu pot fi apelate.',
        availableTitle: 'Integrări disponibile',
        activeTitle: 'Instrumente conectate',
        activeIntroTitle: 'Instrumentele pe care le poate folosi acest agent',
        activeIntroBody:
          'Serverele MCP conectate la acest agent. Dezactivați unul pentru a opri apelarea instrumentelor sale fără a-l deconecta. Adăugați instrumente noi din fila Conexiuni.',
        activeEmpty:
          'Niciun instrument conectat încă. Adăugați din fila Conexiuni.',
        noInstance:
          'Nicio aplicație {{app}} nu este instalată în acest spațiu de lucru.'
      },
      builtinTools: {
        introTitle: 'Instrumente integrate',
        introBody:
          'Instrumente-funcție pe care agentul le poate apela direct. Activați unul pentru a-l permite acestui agent.',
        title: 'Instrumente disponibile',
        empty: 'Niciun instrument disponibil.',
        otherCategory: 'Altele',
        enabledTip: 'Activat — agentul poate apela acest instrument.',
        disabledTip:
          'Dezactivat — activați pentru ca agentul să-l poată apela.',
        updated: 'Instrumente actualizate',
        externalIntroTitle: 'Instrumente terțe',
        externalIntroBody:
          'Instrumente oferite de servicii externe precum Firecrawl. Activați unul pentru a-l permite acestui agent.',
        externalTitle: 'Instrumente de la furnizori',
        externalEmpty: 'Niciun instrument terț disponibil.',
        apiKeyLabel: 'Cheie API {{provider}}',
        apiKeyPlaceholder: 'Lipește cheia API',
        apiKeyHelp:
          'Stocată per agent. Obligatorie — runtime-ul nu folosește o cheie de rezervă.',
        apiKeyMissing: 'Nicio cheie încă — adaug-o, altfel tool-ul nu rulează.',
        apiKeySaved: 'Cheie API salvată'
      },
      connections: {
        title: 'Conexiuni la instrumente externe',
        subtitle:
          'Conturi conectate pe care agentul le accesează prin vault-ul de credențiale.',
        brokerNote:
          'Vault-ul stochează și reîmprospătează tokenurile terțe pe server. Agentul și LLM-ul nu văd niciodată credențialele subiacente.',
        connect: 'Conectează instrument',
        connectTitle: 'Conectează instrument extern',
        connectNotice:
          'În producție, aici se deschide consimțământul OAuth al furnizorului. Aici conexiunea este simulată.',
        provider: 'Instrument',
        providerPlaceholder: 'Selectați un instrument',
        account: 'Cont',
        accountPlaceholder: 'ex. agent@company.com',
        accountRequired: 'Introduceți contul de conectat',
        toolScopes: 'Permisiuni instrument',
        toolScopesPlaceholder: 'Operațiunile pe care le poate face agentul',
        empty: 'Niciun instrument conectat.',
        columns: {
          tool: 'Instrument',
          account: 'Cont',
          status: 'Stare',
          scopes: 'Permisiuni',
          lastRefreshed: 'Token reîmprospătat',
          actions: 'Acțiuni'
        },
        status: {
          connected: 'Conectat',
          expired: 'Expirat',
          revoked: 'Revocat'
        },
        neverRefreshed: 'Încă nu',
        reconnect: 'Reconectează',
        disconnect: 'Deconectează',
        disconnectConfirmTitle: 'Deconectați acest instrument?',
        disconnectConfirmBody:
          'Agentul va pierde imediat posibilitatea de a apela {{tool}}.'
      },
      activity: {
        title: 'Activitate',
        subtitle: 'Istoricul rulărilor pentru {{name}}.',
        empty: 'Nicio activitate înregistrată încă.',
        tokens: '{{count}} tokenuri',
        trigger: {
          chat: 'Rulare din chat',
          schedule: 'Rulare programată',
          webhook: 'Rulare webhook',
          api: 'Rulare API'
        },
        status: {
          pending: 'În așteptare',
          running: 'În curs',
          done: 'Finalizat',
          error: 'Eroare',
          paused: 'În pauză'
        },
        columns: {
          action: 'Acțiune',
          when: 'Când'
        }
      },
      tools: {
        introTitle: 'Instrumente pe care agentul le poate apela (MCP)',
        introBody:
          'Capabilitățile sunt expuse ca instrumente MCP și sunt gestionate în Squad. Fiecare apel moștenește domeniile permise ale agentului, intersectate per utilizator cu permisiunile sale Skalx.',
        mcpTitle: 'Descoperire MCP',
        mcpSubtitle:
          'Ce preia un client MCP pentru a afla endpoint-ul și catalogul de instrumente al acestui agent.',
        discoveryUrl: 'Document de descoperire',
        mcpEndpoint: 'Endpoint MCP',
        title: 'Instrumente',
        mcpServers: 'Servere MCP',
        managedInSquad:
          'Instrumentele și serverele MCP ale acestui agent sunt configurate în Squad.',
        subtitle:
          'Capabilități atașate acestui agent. Fiecare corespunde unei permisiuni de aplicație sau unui instrument conectat.',
        add: 'Adaugă instrument',
        addTitle: 'Adaugă un instrument',
        addNotice:
          'Alege o capabilitate din catalog. Îi poți schimba politica de aprobare ulterior.',
        addPlaceholder: 'Selectează o capabilitate',
        empty:
          'Niciun instrument încă. Adaugă unul pentru ca acest agent să poată efectua o acțiune.',
        remove: 'Elimină',
        removeConfirmTitle: 'Eliminați acest instrument?',
        removeConfirmBody: 'Agentul nu va mai putea apela {{tool}}.',
        test: 'Apel de test',
        run: 'Execută apelul',
        testTitle: 'Apel de test · {{tool}}',
        testApprovalNote:
          'Acest instrument necesită aprobare — apelul se va opri ca cerere în așteptare în loc să ruleze imediat.',
        inputLabel: 'Intrare instrument (JSON)',
        requiresApproval: 'Necesită aprobare',
        autoRuns: 'Rulează automat',
        recentCallsTitle: 'Apeluri recente',
        columns: {
          tool: 'Instrument',
          source: 'Sursă',
          risk: 'Risc',
          approval: 'Politică de aprobare',
          enabled: 'Activat'
        },
        callColumns: {
          tool: 'Instrument',
          status: 'Rezultat',
          when: 'Când'
        },
        source: {
          app: 'Aplicație',
          connector: 'Conector'
        },
        risk: {
          low: 'Scăzut',
          medium: 'Mediu',
          high: 'Ridicat'
        },
        callStatus: {
          succeeded: 'Reușit',
          denied: 'Respins',
          pending_approval: 'În așteptarea aprobării',
          failed: 'Eșuat'
        },
        messages: {
          added: 'Instrument adăugat',
          updated: 'Instrument actualizat',
          removed: 'Instrument eliminat'
        },
        result: {
          okTitle: 'Apel finalizat',
          heldTitle: 'Trimis spre aprobare',
          heldBody:
            'Acest apel necesită aprobare umană ({{method}}). Rezolvă-l în fila Aprobări.',
          userCode: 'Cod dispozitiv'
        }
      },
      approvals: {
        introTitle: 'Aprobări cu om în buclă',
        introBody:
          'Apelurile de instrumente care necesită o decizie umană se opresc aici înainte de execuție. Aprobarea reia agentul și permite apelul; respingerea îl blochează.',
        pendingTitle: 'În așteptare ({{count}})',
        pendingEmpty:
          'Nicio aprobare în așteptare. Apelurile restricționate vor apărea aici.',
        historyTitle: 'Istoric decizii',
        filterAll: 'Toate',
        pendingCount: '{{count}} în așteptare',
        scope: {
          agent: 'Acest agent',
          workspace: 'Toți agenții'
        },
        approve: 'Aprobă',
        deny: 'Respinge',
        denyTitle: 'Respingeți această cerere?',
        reasonLabel: 'Motiv',
        reasonPlaceholder: 'Notă opțională înregistrată cu decizia.',
        status: {
          pending: 'În așteptare',
          accepted: 'Aprobat',
          edited: 'Aprobat (editat)',
          rejected: 'Respins',
          answered: 'Răspuns'
        },
        columns: {
          action: 'Acțiune',
          requested: 'Solicitat',
          when: 'Când',
          agent: 'Agent',
          status: 'Stare',
          resolved: 'Rezolvat'
        },
        messages: {
          approved: 'Cerere aprobată — se reia agentul',
          denied: 'Cerere respinsă',
          failed: 'Cererea nu a putut fi rezolvată'
        }
      }
    },
    apps: {
      title: 'Aplicații workspace',
      description:
        'Gestionează catalogul de aplicații, rolurile, credențialele, webhook-urile și evenimentele de audit.',
      routeShellDescription:
        'Configurează această aplicație: roluri, credențiale, webhook-uri și jurnal de audit.',
      create: 'Creează aplicație',
      createModalTitle: 'Creează aplicație pentru workspace',
      browseCatalog: 'Catalog',
      createCustomLocal: 'Aplicație personalizată',
      navLabel: 'Secțiuni aplicație',
      nav: {
        overview: 'Prezentare',
        people: 'Persoane',
        groups: 'Grupuri',
        roles: 'Roluri',
        oidc: 'OIDC',
        scim: 'SCIM',
        credentials: 'Credențiale',
        webhooks: 'Webhook-uri',
        outboundWebhooks: 'Webhook-uri',
        activity: 'Activitate',
        settings: 'Setări'
      },
      groups: {
        columns: {
          name: 'Grup',
          members: 'Membri',
          roles: 'Roluri în această aplicație',
          updated: 'Actualizat',
          otherApps_one: '+{{count}} rol în altă aplicație',
          otherApps_few: '+{{count}} roluri în alte aplicații',
          otherApps_other: '+{{count}} de roluri în alte aplicații',
          otherAppsHint: 'Grupul acordă și: {{roles}}'
        },
        actions: {
          add: 'Adaugă grup',
          create: 'Grup nou',
          editRoles: 'Schimbă rolurile',
          revoke: 'Retrage accesul'
        },
        modal: {
          addTitle: 'Adaugă un grup în această aplicație',
          editTitle: 'Schimbă rolurile',
          accessNotice:
            'Toți membrii grupului primesc aceste roluri și accesul la această aplicație.',
          groupLabel: 'Grup',
          groupPlaceholder: 'Selectează un grup',
          groupRequired: 'Alege un grup',
          noCandidates: 'Toate grupurile au deja acces aici.',
          rolesLabel: 'Roluri în această aplicație',
          rolesPlaceholder: 'Alege rolurile',
          rolesHint:
            'Se modifică doar această aplicație. Rolurile din alte aplicații rămân neschimbate.',
          alsoGrants: 'Grupul acordă acces și în altă parte',
          submit: 'Salvează',
          cancel: 'Anulează'
        },
        create: {
          title: 'Grup nou',
          submit: 'Creează grupul',
          success: 'Grup creat',
          accessNotice:
            'Membrii acestui grup primesc rolurile alese aici — și accesul la această aplicație. Cei care încă nu au acces îl vor primi.',
          membersHint:
            'Poate fi adăugat orice membru al organizației, nu doar persoanele care folosesc deja această aplicație.',
          rolesHint:
            'Aici se oferă doar rolurile acestei aplicații. Altele se pot adăuga ulterior din Utilizatori → Grupuri.'
        },
        revoke: {
          title: 'Retrage accesul',
          content:
            'Elimini toate rolurile pe care această aplicație le acordă prin „{{name}}”? Membrii păstrează accesul pe care îl au personal sau printr-un alt grup.',
          confirm: 'Retrage'
        },
        messages: {
          rolesUpdated: 'Rolurile grupului au fost actualizate',
          revoked: 'Accesul grupului a fost retras'
        }
      },
      navGroups: {
        access: 'Acces',
        connection: 'Conexiune',
        monitor: 'Administrare'
      },
      outboundWebhookDetail: {
        breadcrumb: 'Webhook',
        back: 'Înapoi la {{app}}',
        overviewTitle: 'Prezentare',
        eventsTitle: 'Evenimente abonate',
        noEvents: 'Niciun eveniment selectat, deci nu se livrează nimic.',
        eventSummary: '{{events}} în {{entities}}',
        objectCount_one: '{{count}} obiect',
        objectCount_few: '{{count}} obiecte',
        objectCount_other: '{{count}} de obiecte',
        updated: 'Ultima modificare',
        stateActive: 'Activ',
        stateInactive: 'Inactiv'
      },
      outboundWebhooks: {
        create: 'Adaugă webhook',
        empty:
          'Încă niciun endpoint. Adaugă unul pentru a primi evenimente din CRM.',
        toolbar: { label: 'endpoint-uri configurate' },
        columns: {
          name: 'Nume',
          url: 'Endpoint',
          events: 'Evenimente',
          eventCount_one: '{{count}} eveniment',
          eventCount_few: '{{count}} evenimente',
          eventCount_other: '{{count}} de evenimente',
          active: 'Activ',
          created: 'Creat'
        },
        actions: {
          reveal: 'Arată secretul de semnare',
          test: 'Trimite webhook de test'
        },
        deleteModal: {
          title: 'Ștergi webhook-ul?',
          content:
            'Livrările se opresc imediat, inclusiv încercările deja programate pentru reîncercare.'
        },
        test: {
          title: 'Livrare de test',
          accepted: 'Endpoint-ul a acceptat livrarea ({{status}}).',
          rejected: 'Endpoint-ul a răspuns {{status}}.',
          unreachable: 'Endpoint-ul nu a putut fi contactat.',
          responseBody: 'Răspunsul endpoint-ului',
          hint: 'Cererea este semnată exact ca un eveniment real, cu numele webhook.test. Unele servicii activează URL-ul de test pentru un singur apel — apăsați butonul lor de ascultare și trimiteți din nou.',
          deliveryId: 'Livrare: {{id}}'
        },
        messages: { deleted: 'Webhook șters' },
        managed: {
          tag: 'Squad',
          openInSquad: 'Deschide în Squad',
          editWarning:
            'Acest webhook este gestionat de Squad — schimbarea adresei sau a secretului deconectează agentul.'
        },
        secret: {
          title: 'Secret de semnare',
          hint: 'Transmite-l celui care primește evenimentele — cu el se verifică antetul X-CRM-Signature. Fiecare afișare este înregistrată în jurnalul de activitate.'
        },
        events: {
          placeholder: 'Selectează evenimentele de primit',
          selectAll: 'Selectează tot',
          clear: 'Șterge',
          unavailable:
            'Lista de evenimente nu a putut fi încărcată din această instanță CRM.',
          unavailableHint:
            'Lista este servită de aplicația CRM. Verifică dacă aplicația este accesibilă, apoi redeschide formularul.'
        },
        verify: {
          title: 'Verificarea livrărilor',
          copy: 'Copiază',
          intro:
            'Fiecare livrare vine cu X-CRM-Signature: t=<unix>,v1=<hex> — un HMAC-SHA256 al șirului "<t>.<raw body>" folosind secretul acestui webhook. Recalculându-l, receptorul știe că cererea vine de la noi și nu a fost modificată.',
          secretHint:
            'Ia secretul din „Arată secretul de semnare” și păstrează-l în variabilele de mediu, nu în cod.',
          tips: {
            rawBody:
              'Semnează octeții bruți. Dacă parsezi JSON-ul și îl serializezi din nou, octeții se schimbă și semnătura nu va corespunde niciodată.',
            constantTime:
              'Compară cu o funcție în timp constant. Un === simplu dezvăluie cât din semnătură a fost corect.',
            replay:
              'Respinge o marcă de timp veche. Fiecare reîncercare este semnată din nou, deci un t învechit înseamnă că cineva reia o cerere interceptată.',
            idempotency:
              'Elimină duplicatele după X-CRM-Delivery. O livrare care a expirat la tine este reîncercată, deci același eveniment poate ajunge de două ori.',
            retries:
              'Răspunde 2xx rapid și procesează după. Orice altceva este reîncercat de cinci ori în circa două ore și jumătate, apoi se pierde.'
          },
          n8n: 'În n8n verificarea diferă. Șablonul de mai jos implementează schema GitHub: un singur antet, semnat doar peste corp. La noi: activează Raw Body în nodul Webhook, extrage t și v1 din X-CRM-Signature și semnează "<t>.<raw body>". Nodurile Crypto și IF nu pot adăuga marca de timp înaintea octeților bruți, deci folosește în locul lor un nod Code cu exemplul Node.js de mai sus.',
          n8nLink: 'Șablon de validare HMAC în n8n'
        },
        form: {
          name: 'Nume',
          namePlaceholder: 'De exemplu, Distribuirea lead-urilor',
          createTitle: 'Webhook nou',
          editTitle: 'Editează webhook',
          url: 'URL endpoint',
          urlHttps: 'Sunt permise doar adrese https.',
          events: 'Evenimente',
          eventsRequired: 'Selectează cel puțin un eveniment.',
          secret: 'Secret de semnare',
          secretPlaceholderCreate: 'Lasă gol — generăm noi unul',
          secretPlaceholderEdit: 'Lasă gol pentru a păstra secretul actual',
          secretCreateHint:
            'Completează doar dacă sistemul care primește cere propria valoare.',
          secretEditHint:
            'Înlocuirea lui strică verificarea la cel care primește evenimentele, până îl actualizează și el.',
          secretTooShort:
            'Secretul trebuie să aibă cel puțin {{min}} caractere.',
          active: 'Activ',
          activeHint:
            'Dezactivarea oprește imediat livrările, inclusiv încercările deja programate pentru reluare.'
        }
      },
      board: {
        searchPlaceholder: 'Caută aplicații',
        filterAll: 'Toate',
        filterInstalled: 'Instalate',
        filterAvailable: 'Disponibile',
        createCustom: 'Creează aplicație personalizată',
        installedGroup: 'Instalate',
        installedHint: 'Active în acest spațiu de lucru.',
        availableGroup: 'Disponibile',
        availableHint: 'Încă neinstalate.',
        factType: 'Tip',
        launch: 'Deschide {{name}} într-o filă nouă',
        userCount_one: '{{count}} utilizator',
        userCount_few: '{{count}} utilizatori',
        userCount_other: '{{count}} de utilizatori',
        userCountUnknown: 'Utilizatori —',
        sortLabel: 'Sortează aplicațiile',
        sort: {
          name: 'Nume A–Z',
          '-name': 'Nume Z–A',
          newest: 'Cele mai noi',
          oldest: 'Cele mai vechi'
        },
        factInstalled: 'Instalată',
        openApp: 'Deschide',
        manageAccess: 'Gestionează accesul',
        install: 'Instalează',
        empty: {
          filtered: 'Nicio aplicație nu corespunde căutării.',
          none: 'Nicio aplicație disponibilă încă pentru acest spațiu de lucru.'
        }
      },
      iconField: {
        pick: 'Alege o pictogramă',
        reset: 'Resetează',
        hint: 'O pictogramă sau imaginea ta · PNG, JPG, SVG până la 1 MB',
        hintIconsOnly: 'O pictogramă pentru aplicație'
      },
      createCustom: {
        defaultTitle: 'Aplicație personalizată nouă',
        defaultSubtitle: 'Identitate de workspace pentru orice aplicație',
        cancel: 'Anulează',
        submit: 'Creează aplicația',
        fields: {
          name: 'Nume aplicație',
          nameExtra: 'Apare în Skalx și pe ecranul de consimțământ OAuth.',
          namePlaceholder: 'ex. Edge gateway',
          description: 'Descriere',
          descriptionExtra:
            'Opțional. Ajută echipa să înțeleagă rolul aplicației.',
          descriptionPlaceholder: 'O linie care descrie aplicația.',
          icon: 'Pictograma aplicației'
        },
        connection: {
          domain: 'Domeniul aplicației',
          domainExtra:
            'Opțional. Hostul folosit pentru redirect URIs și CORS. Salvat ca application_domain.',
          appUrl: 'URL aplicație',
          appUrlExtra:
            'Opțional. Unde ajunge utilizatorul când deschide aplicația din Skalx. Salvat ca application_url.'
        }
      },
      customTab: {
        headerTitle: 'Aplicații personalizate',
        headerDescription:
          'Aplicații interne sau terțe care se autentifică prin Skalx. Conectează-le prin OIDC.',
        docs: 'Documentație',
        create: 'Creează aplicație personalizată',
        authType: 'OIDC',
        empty: 'Nicio aplicație personalizată încă.',
        noDeployment: 'Nu există încă un URL de deploy.',
        users: 'Utilizatori',
        created: 'Creată',
        status: {
          ready: 'Gata',
          draft: 'Ciornă'
        },
        menu: {
          open: 'Deschide aplicația',
          manage: 'Administrează',
          rotate: 'Rotește credențiale',
          delete: 'Șterge aplicația'
        },
        howItWorks: {
          title: 'Skalx ca strat de identitate pentru orice aplicație',
          description:
            'Aplicațiile personalizate îți permit să folosești Skalx pentru autentificare, roluri și audit în orice aplicație terță sau internă.',
          steps: {
            defineApp: 'Definește aplicația',
            issueCredentials: 'Emite credențiale',
            connect: 'Conectează cu OIDC',
            grantAccess: 'Acordă acces'
          }
        },
        createDrawerTitle: 'Aplicație personalizată nouă',
        drawerPlaceholder: {
          title: 'Fluxul multi-pas apare la pasul 5',
          description:
            'Acest drawer te va ghida prin identitate, metodă de autentificare, conexiune și roluri în patru pași.',
          note: 'Momentan fluxul este în proiectare. După aprobarea pasului 5, drawer-ul va fi conectat la API-ul de aplicații și va crea aplicația la trimitere.'
        }
      },
      catalogTab: {
        searchPlaceholder: 'Caută în catalog…',
        shown: 'afișate',
        submitApp: 'Propune o aplicație →',
        featured: 'Recomandată',
        featuredFallbackDescription:
          'O aplicație predefinită pe care o instalezi într-un singur clic.',
        addToWorkspace: 'Adaugă în workspace',
        manage: 'Administrează',
        installed: 'Instalată',
        popular: 'Populară',
        docs: 'Documentație',
        noDescription: 'Fără descriere.',
        orderName: 'Nume (A → Z)',
        orderNameDesc: 'Nume (Z → A)',
        orderNewest: 'Cele mai noi',
        orderOldest: 'Cele mai vechi',
        loadingMore: 'Se încarcă mai multe aplicații…',
        statusFilter: {
          all: 'Toate',
          installed: 'Instalate',
          available: 'Disponibile'
        },
        empty: {
          none: 'Catalogul este gol.',
          filtered: 'Nicio aplicație nu corespunde filtrelor.'
        }
      },
      installed: {
        kpi: {
          installed: 'Aplicații instalate',
          activeSessions: 'Sesiuni active',
          totalUsers: 'Utilizatori totali',
          totalUsersFooter: 'în {{count}} aplicații',
          needAttention: 'Necesită atenție'
        },
        filters: {
          searchPlaceholder: 'Caută aplicații…',
          typeAll: 'Toate tipurile',
          typeBuiltin: 'Predefinite',
          typeCustom: 'Personalizate',
          healthAll: 'Toată starea',
          healthSoon:
            'Filtru de stare — disponibil când API-ul va expune starea per aplicație.'
        },
        totalApps_one: '{{count}} aplicație',
        totalApps_other: '{{count}} aplicații',
        totalApps: '{{count}} aplicații',
        columns: {
          app: 'Aplicație',
          type: 'Tip',
          health: 'Stare',
          users: 'Utilizatori',
          sessions: 'Sesiuni · 24h',
          errorRate: 'Rată de erori',
          created: 'Creată'
        },
        type: {
          builtin: 'Predefinită',
          custom: 'Personalizată'
        },
        actions: {
          addFromCatalog: 'Adaugă din catalog',
          newCustom: 'Aplicație personalizată nouă',
          refresh: 'Reîmprospătează',
          density: 'Densitate (în curând)'
        },
        rowMenu: {
          open: 'Deschide aplicația',
          manage: 'Administrează',
          credentials: 'Credențiale',
          roles: 'Roluri',
          uninstall: 'Dezinstalează'
        },
        empty: {
          none: 'Nicio aplicație instalată în acest workspace.',
          filtered: 'Nicio aplicație nu corespunde filtrelor.'
        }
      },
      builtin: {
        installDrawerTitle: 'Instalează aplicație predefinită'
      },
      custom: {
        fields: {
          url: 'URL',
          urlInvalid: 'Introduceți un URL valid (https://...)'
        },
        delete: 'Șterge aplicația',
        deleteConfirm: {
          title: 'Ștergi această aplicație personalizată?',
          description:
            'Această acțiune șterge definitiv aplicația, rolurile și tokenurile ei.'
        }
      },
      catalog: {
        crm: {
          title: 'Workspace CRM',
          description:
            'Pipeline, conturi și vânzări aliniate la rolurile workspace.'
        },
        hrm: {
          title: 'Workspace HRM',
          description: 'Date HR, provisioning SCIM și fluxuri HR.'
        },
        identity: {
          title: 'Identitate și acces',
          description: 'Token-uri, SSO și suprafețe de auth pentru parteneri.'
        },
        finance: {
          title: 'Financiar și facturare',
          description: 'Facturi, abonamente și operațiuni venituri.'
        }
      },
      manage: 'Gestionează',
      status: {
        active: 'Activă',
        archived: 'Arhivată',
        revoked: 'Revocată',
        expired: 'Expirată'
      },
      messages: {
        created: 'Aplicația a fost creată cu succes',
        updated: 'Aplicația a fost actualizată cu succes',
        deleted: 'Aplicația a fost ștearsă',
        deleteTokenMissing:
          'Tokenul aplicației nu este încă disponibil. Reîmprospătează pagina și încearcă din nou.',
        roleUpdated: 'Rolul a fost actualizat cu succes',
        customPermissionCreated: 'Permisiunea personalizată a fost creată',
        customPermissionCreateFailed:
          'Nu s-a putut crea permisiunea personalizată'
      },
      loadError: 'Nu s-au putut încărca aplicațiile pentru acest workspace.',
      retry: 'Reîncearcă',
      empty: 'Încă nu există aplicații.',
      noRepositoryTypes:
        'Nu există șabloane de aplicație disponibile. Contactează un administrator.',
      createForm: {
        instanceType: 'Șablon aplicație',
        instanceTypePlaceholder: 'Selectează un șablon',
        platformConfigHint:
          'Alege cum se încadrează aplicația în platforma workspace-ului pentru ca rolurile, provisioning-ul și accesul API să rămână consistente din prima zi.'
      },
      overview: {
        domain: 'Domeniu',
        appUrl: 'URL aplicație',
        instanceType: 'Șablon',
        createdAt: 'Creat la',
        visibility: 'Vizibilitate',
        appInfoTitle: 'Informații aplicație',
        editHint:
          'Numele și descrierea sunt salvate în înregistrarea aplicației. Pictograma este stocată în acest browser până când API-ul acceptă pictograme. Contextul de produs din secțiunile de mai sus rămâne în UI-ul workspace-ului până la endpoint-uri dedicate.',
        coreWrappingHint:
          'Aplicațiile ar trebui să moștenească autentificarea workspace-ului, controlul accesului și valorile implicite de securitate, cu excepția cazului în care modelezi explicit o limită SSO dedicată.',
        templateConfigTitle: 'Suprafață de configurare a șablonului',
        templateConfigDescription:
          'Acest șablon expune {{count}} chei configurabile care pot fi încadrate în platforma workspace-ului.',
        templateConfigEmpty:
          'Acest șablon nu expune chei suplimentare de configurare prin API-ul curent.',
        appRolesCardTitle: 'Roluri și permisiuni aplicație',
        appRolesCardDescription:
          'Definește cine poate gestiona această aplicație, credențialele și integrările. Tab-ul Roluri oferă aceleași acțiuni într-o vedere dedicată.',
        workspaceRolesAccessHint:
          'Această aplicație folosește rolurile workspace pentru acces. Atribuie membri din secțiunile Membri și Roluri ale workspace-ului; rolurile specifice aplicației sunt ascunse.',
        analyticsTitle: 'Utilizare și fiabilitate',
        analyticsSessions: 'Sesiuni active (24h)',
        analyticsErrors: 'Rată erori',
        analyticsLatency: 'Latenta P95',
        dashboardsTitle: 'Dashboard-uri',
        dashboardsHint:
          'Vederi operaționale fixate pentru această aplicație (mock).',
        agentsTitle: 'Agenți AI',
        agentsHint: 'Asistenți autonomi pentru această aplicație (mock).',
        dangerZoneTitle: 'Zonă periculoasă',
        dangerZoneDescription:
          'Șterge definitiv această aplicație personalizată și toate setările ei.',
        dashboardItem: {
          health: 'Sănătate și uptime',
          usage: 'Utilizare și cote',
          security: 'Postură de securitate'
        },
        agentItem: {
          support: 'Triere suport',
          supportDesc: 'Răspunsuri inițiale din tichete și audit.',
          ops: 'Copilot operațiuni',
          opsDesc: 'Rezumă incidente și sugerează pași din runbook.'
        }
      },
      settings: {
        edit: 'Editează setările',
        save: 'Salvează setările',
        saved: 'Setările șablonului au fost salvate',
        default: 'Implicit',
        placeholder: 'Introdu valoarea'
      },
      productType: {
        built_in: 'Predefinită',
        custom: 'Personalizată'
      },
      solution: {
        crm: 'CRM',
        hrm: 'HRM',
        identity: 'Identitate',
        finance: 'Financiar',
        operations: 'Operațiuni',
        custom: 'Personalizat'
      },
      accessModel: {
        workspace_roles: 'Roluri workspace',
        app_roles: 'Roluri aplicație'
      },
      provisioning: {
        manual: 'Manual',
        jit: 'Just-in-time',
        scim: 'SCIM'
      },
      authMode: {
        workspace_core: 'Nucleu auth workspace',
        dedicated_sso: 'Limită SSO dedicată'
      },
      apiExposure: {
        internal: 'Intern',
        partner: 'Partener',
        public: 'Public'
      },
      configurationStatus: {
        ready: 'Pregătită',
        needsAttention: 'Necesită atenție'
      },
      visibility: {
        public: 'Publică',
        private: 'Privată'
      },
      columns: {
        app: 'Aplicație',
        domain: 'Domeniu',
        url: 'URL',
        instanceType: 'Șablon',
        visibility: 'Vizibilitate',
        createdAt: 'Creată la',
        actions: 'Acțiuni'
      },
      fields: {
        slug: 'Slug',
        goal: 'Scop',
        description: 'Descriere',
        owner: 'Owner',
        productType: 'Tip produs',
        solutionArea: 'Arie soluție',
        accessModel: 'Model acces',
        provisioningMode: 'Provisioning',
        authMode: 'Limită auth',
        apiExposure: 'Expunere API',
        environment: 'Mediu',
        status: 'Status'
      },
      environments: {
        development: 'Dezvoltare',
        staging: 'Staging',
        production: 'Producție'
      },
      tabs: {
        overview: 'Prezentare',
        users: 'Utilizatori',
        roles: 'Roluri',
        credentials: 'Credențiale',
        webhooks: 'Webhook-uri',
        audit: 'Audit',
        settings: 'Setări',
        access: 'Acces',
        connection: 'Conexiune',
        activity: 'Activitate'
      },
      segments: {
        users: 'Utilizatori',
        roles: 'Roluri',
        oidc: 'OIDC',
        scim: 'SCIM',
        credentials: 'Credențiale',
        webhooks: 'Webhook-uri'
      },
      overviewTab: {
        kpi: {
          activeSessions: 'Sesiuni active',
          errorRate: 'Rată de erori',
          p95Latency: 'Latență P95',
          monthlyActive: 'Utilizatori activi lunar',
          noDataYet: 'API-ul nu expune încă aceste metrici.'
        },
        usage: {
          title: 'Volum cereri',
          subtitle: 'Ultimele 24 de ore · per oră.',
          empty:
            'Graficele apar când va fi conectat API-ul de metrici per aplicație.'
        },
        info: {
          title: 'Informații aplicație',
          name: 'Nume',
          template: 'Șablon',
          description: 'Descriere',
          domain: 'Domeniu',
          appUrl: 'URL aplicație',
          visibility: 'Vizibilitate',
          created: 'Creată',
          token: 'Token aplicație',
          version: 'Versiune'
        },
        activity: {
          title: 'Activitate recentă',
          empty:
            'Evenimentele de audit ale aplicației apar când API-ul va fi expus.'
        },
        apiNote:
          'Numele, șablonul, domeniul, vizibilitatea și data creării vin din API real. Metricile, versiunea și activitatea apar pe măsură ce API-urile sunt expuse.'
      },
      autoProvision: {
        title: 'Acces pentru toți membrii',
        enableLabel: 'Oferă acces tuturor în mod implicit',
        description:
          'Toți membrii workspace-ului primesc această aplicație cu rolul selectat — cei care sunt deja aici și toți cei adăugați ulterior. Cei care au deja un rol în această aplicație îl păstrează.',
        roleLabel: 'Rol implicit',
        rolePlaceholder: 'Selectează un rol',
        roleRequired: 'Alege rolul pentru membri sau dezactivează setarea.'
      },
      settingsTab: {
        save: 'Salvează',
        reset: 'Resetează',
        general: {
          title: 'General',
          name: 'Nume',
          domain: 'Domeniu',
          domainReadOnly:
            'Domeniul este setat la instalare și nu poate fi modificat deocamdată.',
          appUrl: 'URL aplicație',
          appUrlExtra:
            'Unde ajung utilizatorii când deschid această aplicație.',
          description: 'Descriere',
          icon: 'Pictograma aplicației'
        },
        danger: {
          title: 'Zonă periculoasă',
          uninstall: {
            title: 'Dezinstalează aplicația',
            description:
              'Elimină aplicația din workspace. Accesul utilizatorilor, rolurile și credențialele sunt șterse.',
            action: 'Dezinstalează'
          }
        }
      },
      auditTab: {
        tabs: {
          events: 'Evenimente',
          exports: 'Exporturi'
        },
        title: 'Jurnal de audit',
        subtitle: 'Restrâns la această aplicație.',
        totalEvents_one: '{{count}} eveniment',
        totalEvents_few: '{{count}} evenimente',
        totalEvents_other: '{{count}} de evenimente',
        refresh: 'Reîmprospătează',
        loadError:
          'Nu s-au putut încărca evenimentele de audit pentru această aplicație.',
        retry: 'Reîncearcă',
        openDetails: 'Deschide detaliile evenimentului {{event}}',
        filters: {
          searchPlaceholder: 'Caută după descriere sau autor…',
          actionPlaceholder: 'Acțiune',
          entityTypePlaceholder: 'Tip entitate',
          dateRangeLabel: 'Interval de date',
          entityIdPlaceholder: 'ID entitate',
          actorTypePlaceholder: 'Tip actor',
          actorIdPlaceholder: 'Autor',
          clear: 'Șterge'
        },
        columns: {
          time: 'Timp',
          application: 'Aplicație',
          event: 'Eveniment',
          actor: 'Autor',
          description: 'Descriere'
        },
        export: 'Exportă',
        noMatches: 'Niciun eveniment nu corespunde filtrelor selectate.',
        empty: 'Nu există încă evenimente de audit pentru această aplicație.'
      },
      auditDetail: {
        breadcrumb: 'Eveniment de audit',
        backToAudit: 'Înapoi la jurnalul de audit',
        loadError: 'Nu s-a putut încărca acest eveniment de audit.',
        sections: {
          actorAndRequest: 'Autor și solicitare',
          additionalData: 'Date suplimentare',
          changes: 'Modificări',
          metadata: 'Metadate',
          localizedDescriptions: 'Descrieri localizate'
        },
        fields: {
          description: 'Descriere',
          timestamp: 'Timp',
          eventId: 'ID eveniment',
          eventType: 'Tip eveniment',
          channel: 'Canal',
          entityType: 'Tip entitate',
          entityId: 'ID entitate',
          category: 'Categorie',
          application: 'Aplicație',
          applicationId: 'ID aplicație',
          organizationId: 'ID organizație',
          service: 'Serviciu',
          actor: 'Autor',
          actorId: 'ID autor',
          method: 'Metodă',
          clientIp: 'IP client',
          url: 'URL solicitare'
        }
      },
      usersTab: {
        searchPlaceholder: 'Caută după nume sau email…',
        totalUsers_one: '{{count}} utilizator',
        totalUsers_other: '{{count}} utilizatori',
        totalUsers: '{{count}} utilizatori',
        refresh: 'Reîmprospătează',
        grantAccess: 'Acordă acces',
        grantAccessTitle: 'Acordă acces la aplicație',
        memberLabel: 'Membru',
        memberPlaceholder: 'Selectează un membru al spațiului de lucru',
        memberRequired: 'Alege un membru.',
        roleLabel: 'Rol',
        rolePlaceholder: 'Selectează un rol (opțional)',
        grantSuccess: 'Acces acordat',
        manageAccessTitle: 'Administrează accesul la aplicație',
        updateSuccess: 'Acces actualizat',
        removeAccess: 'Elimină din aplicație',
        removeConfirmTitle: 'Elimini accesul?',
        removeConfirmBody:
          'Acest membru pierde accesul la această aplicație, inclusiv rolurile ei. Celelalte aplicații rămân neatinse.',
        removeSuccess: 'Acces eliminat',
        noRoles: 'Fără roluri',
        organizationScope: 'Spațiu de lucru',
        columns: {
          user: 'Utilizator',
          roles: 'Roluri',
          source: 'Sursă',
          userId: 'ID utilizator',
          actions: 'Acțiuni'
        },
        empty: {
          none: 'Niciun utilizator nu are acces la această aplicație.',
          filtered: 'Niciun utilizator nu corespunde căutării.'
        }
      },
      roles: {
        workspaceRolesTitle: 'Legături roluri workspace',
        workspaceRolesHelp:
          'Alege roluri workspace care primesc această aplicație la onboarding. Mapează apoi permisiunile în matricea de mai jos.',
        saveLinkedWorkspaceRoles: 'Salvează legăturile',
        linkedSaved: 'Legăturile au fost actualizate',
        workspaceRolesMatrixTitle: 'Roluri workspace × permisiuni aplicație',
        workspaceRolesMatrixHint:
          'Pentru fiecare rol workspace legat, alege capabilitățile la nivel de aplicație (permisiuni platformă și personalizate). Separat de rolurile aplicației.',
        workspaceRolesMatrixNeedLinks:
          'Leagă cel puțin un rol workspace mai sus pentru a mapa permisiunile.',
        saveWorkspaceRolePermissionMap:
          'Salvează harta de permisiuni workspace',
        workspaceRolePermissionMapSaved: 'Harta de permisiuni a fost salvată',
        matrixTitle: 'Matrice permisiuni',
        matrixHint:
          'Rândurile sunt permisiuni (platformă + personalizate). Coloanele sunt roluri aplicație. Rolurile predefinite sunt doar citire.',
        matrix: { permission: 'Permisiune' },
        panelIntro:
          'Rolurile aplicației grupează permisiunile pentru această aplicație. Rolurile personalizate pot fi editate sau șterse; rolurile predefinite sunt fixate de șablonul platformei.',
        add: 'Adaugă rol',
        roleListTitle: 'Roluri aplicație',
        modalTitle: 'Adaugă rol aplicație',
        editModalTitle: 'Editează rol aplicație',
        viewModalTitle: 'Rol aplicație',
        view: 'Vizualizare',
        edit: 'Editează',
        viewDone: 'OK',
        systemBadge: 'Predefinit',
        systemRoleHint:
          'Acesta este un rol predefinit. Numele și permisiunile sunt gestionate de șablonul platformei.',
        descriptionLabel: 'Descriere rol',
        permissionsLabel: 'Permisiuni',
        roleSourceLabel: 'Sursă rol',
        workspaceRoleSelectLabel: 'Rol workspace',
        workspaceRoleSelectPlaceholder: 'Selectează un rol din workspace',
        roleSource: {
          custom: 'Personalizat',
          workspace: 'Workspace'
        },
        removeConfirm: 'Ștergi acest rol?',
        columns: {
          name: 'Nume',
          type: 'Tip',
          permissions: 'Permisiuni',
          actions: 'Acțiuni'
        },
        appCustomPermissionsTitle: 'Permisiuni de capabilitate aplicație',
        appCustomPermissionsHelp:
          'Înregistrează valori `code_name` pe care produsul le verifică la runtime. Fiecare rând are un `id` stabil pentru API-uri și atribuiri pe roluri.',
        appCustomPermissionCodeName: 'Nume cod',
        appCustomPermissionDisplayName: 'Nume afișat',
        appCustomPermissionDescription: 'Descriere',
        appCustomPermissionId: 'Id permisiune',
        addAppCustomPermission: 'Adaugă permisiune personalizată',
        removeAppCustomPermissionConfirm:
          'Ștergi această permisiune? Va fi eliminată din toate rolurile care o folosesc.',
        appCustomPermissionDuplicate:
          'Există deja o permisiune cu acest nume cod.',
        appCustomPermissionCodeInvalid:
          'Folosește litere mici, cifre, puncte, cratime sau underscore (1–64 caractere).',
        customPermissionsPickerLabel: 'Permisiuni personalizate aplicație',
        createCustomPermissionForRole:
          'Creează permisiune personalizată și adaug-o la acest rol',
        customPermissionsSelectPlaceholder:
          'Selectează permisiuni personalizate',
        customPermissionsSelectEmpty:
          'Încă nu există permisiuni personalizate. Folosește linkul de mai jos pentru a crea una.',
        permissionsOrCustomRequired:
          'Alege cel puțin o permisiune platformă sau o permisiune personalizată.',
        module: 'Modul/Resursă',
        admin: 'Admin',
        adminHasFullAccess:
          'Rolul de admin are automat toate permisiunile și nu poate fi editat.',
        selectAll: 'Selectează tot',
        deselectAll: 'Deselectează tot',
        adminAll: 'Toate permisiunile',
        noPermissions: 'Fără permisiuni',
        selectViewFirst: 'Selectează mai întâi permisiunea Vizualizare',
        allPermissionTooltip:
          'Include înregistrările întregii echipe, nu doar pe cele proprii.',
        deleteRoleConfirm: 'Ștergi acest rol?',
        roleNamePlaceholder: 'Nume rol',
        roleDescriptionPlaceholder: 'Descriere (opțional)',
        permissionsUpdated: 'Permisiuni actualizate',
        unsavedChanges_one: '{{count}} modificare nesalvată',
        unsavedChanges_few: '{{count}} modificări nesalvate',
        unsavedChanges_other: '{{count}} de modificări nesalvate',
        resetToDefault: 'Resetează',
        roleCreated: 'Rol creat',
        roleUpdated: 'Rol actualizat',
        roleDeleted: 'Rol șters',
        deleteRoleWarning: 'Această acțiune nu poate fi anulată.',
        deletingRole: 'Se șterge rolul',
        usersWithRole_one: '{{count}} utilizator are acest rol.',
        usersWithRole_few: '{{count}} utilizatori au acest rol.',
        usersWithRole_other: '{{count}} de utilizatori au acest rol.',
        selectReplacementRole: 'Reasignează utilizatorii către',
        replacementRoleDescription:
          'Utilizatorii existenți cu acest rol vor fi mutați la rolul selectat.',
        selectRolePlaceholder: 'Selectează un rol',
        permissionsCatalogTitle: 'Catalog de permisiuni',
        permissionsCatalogDescription:
          'Permisiuni disponibile pentru atribuire rolurilor acestei aplicații.',
        searchPermissions: 'Caută o permisiune…',
        addPermission: 'Adaugă permisiune',
        editPermission: 'Editează permisiunea',
        permissionCode: 'Cod',
        permissionCodePlaceholder: 'ex. invoices.create',
        permissionCodeHelp:
          'Generat automat din etichetă — editează dacă e nevoie. Folosit în API și în jurnalele de audit.',
        permissionCodeImmutable: 'Codul nu poate fi schimbat după creare.',
        permissionCodeRequired: 'Codul este obligatoriu.',
        permissionCodeInvalid:
          'Doar litere mici, cifre și . _ : - sunt permise.',
        permissionLabel: 'Etichetă',
        permissionLabelPlaceholder: 'ex: Aprobă facturile',
        permissionLabelRequired: 'Eticheta este obligatorie.',
        permissionDescription: 'Descriere',
        permissionCreated: 'Permisiune creată',
        permissionUpdated: 'Permisiune actualizată',
        permissionDeleted: 'Permisiune ștearsă',
        deletePermissionTitle: 'Ștergi permisiunea?',
        deletePermissionWarning_one:
          'Un rol va pierde această permisiune. Acțiunea nu poate fi anulată.',
        deletePermissionWarning_few:
          '{{count}} roluri vor pierde această permisiune. Acțiunea nu poate fi anulată.',
        deletePermissionWarning_other:
          '{{count}} de roluri vor pierde această permisiune. Acțiunea nu poate fi anulată.',
        emptyPermissionsCatalog:
          'Nu există permisiuni încă. Adaugă prima pentru a începe atribuirea rolurilor.'
      },
      credentials: {
        intro:
          'Creează token-uri API legate strict de această aplicație. Valoarea token-ului este afișată o singură dată la creare sau rotație — copiaz-o atunci și stoch-o în siguranță.',
        create: 'Creează credențială',
        createDrawerTitle: 'Credențială nouă',
        editDrawerTitle: 'Editează credențiala',
        rotate: 'Rotește',
        revoke: 'Revocă',
        expiresAt: 'Expiră la',
        expiresAtPlaceholder: 'Fără expirare',
        noExpiry: 'Niciodată',
        permissions: 'Permisiuni',
        permissionsHint:
          'Permisiuni pe care le va avea acest token la apelarea acestei aplicații.',
        permissionsPlaceholder: 'Selectează permisiuni',
        selectAll: 'Selectează tot',
        clear: 'Deselectează',
        noPermissions: 'Fără permisiuni',
        noPermissionsHint:
          'Acest token nu are permisiuni; identifică integrarea, dar nu poate accesa endpoint-uri protejate.',
        lastUsed: 'Ultima utilizare',
        neverUsed: 'Niciodată folosit',
        revealTitle: 'Salvează credențiala',
        revealWarning:
          'Aceasta este singura dată când poți vedea acest token. Copiază-l acum și stochează-l în siguranță.',
        revealDone: 'Am salvat',
        rotateConfirmTitle: 'Roteșt credențiala?',
        rotateConfirmBody:
          'Va fi emis un nou token. Această credențială rămâne valabilă dacă nu o revoci mai jos.',
        revokeConfirmTitle: 'Revoci credențiala?',
        revokeConfirmBody:
          'Acest token va înceta să funcționeze pentru toate integrările care îl folosesc. Acțiunea nu poate fi anulată.',
        revokedReason: 'Motiv: {{reason}}',
        revokedAt: 'Revocat {{at}}',
        empty: 'Nu există încă credențiale.',
        toolbar: {
          credentialsLabel: 'credențiale'
        },
        columns: {
          name: 'Nume',
          permissions: 'Permisiuni',
          expires: 'Expiră',
          lastUsed: 'Ultima utilizare',
          status: 'Status',
          actions: 'Acțiuni'
        }
      },
      credentialDetail: {
        breadcrumb: 'Credențială',
        back: 'Înapoi la credențialele {{app}}',
        overviewTitle: 'Prezentare'
      },
      webhooks: {
        soonBadge: 'În curând',
        disabledHint:
          'Webhook-urile pentru aplicațiile workspace nu sunt disponibile încă. Acest tab este doar previzualizare.',
        url: 'URL webhook',
        events: 'Evenimente (separate prin virgulă)',
        create: 'Creează webhook',
        modalTitle: 'Creează webhook',
        removeConfirm: 'Ștergi acest webhook?',
        columns: {
          name: 'Nume',
          url: 'URL',
          events: 'Evenimente',
          actions: 'Acțiuni'
        }
      }
    },
    perm: {
      workspace_settings: 'Setări workspace',
      workspace_members: 'Membri',
      workspace_roles: 'Roluri',
      workspace_security: 'Securitate',
      workspace_audit: 'Jurnal audit',
      apps_manage: 'Aplicații (utilizare)',
      apps_roles: 'Roluri aplicație',
      apps_credentials: 'Credențiale aplicație'
    },
    roles: {
      sectionTitle: 'Funcții/Roluri',
      sectionDescription:
        'Șabloanele de rol definesc permisiunile workspace și aplicație pentru membri.',
      sectionDescriptionApi:
        'Roluri ale organizației din API. Administratorii au acces complet implicit; celelalte roluri au permisiuni explicite.',
      sectionDescriptionManage:
        'Definește funcții de job și roluri workspace. Pachetele de permisiuni pentru aplicații se gestionează în fiecare aplicație; leagă rolurile de funcții pentru o structură clară.',
      manageHint:
        'Numărul pentru funcții = membri al căror titlu de job este egal cu numele funcției (până când API-ul stochează legătura). Pentru roluri se folosesc atribuirile de rol pe membri.',
      tabs: {
        functions: 'Funcții',
        roles: 'Roluri'
      },
      rolesTabIntro:
        'Rolurile workspace sunt atribuite membrilor. Permisiunile pentru aplicații se configurează în fiecare aplicație.',
      drawerClose: 'Închide',
      actions: {
        viewDetails: 'Detalii'
      },
      editRoleTitle: 'Editează rolul',
      form: {
        functionLabel: 'Funcție',
        functionHelp:
          'Legătură opțională la o funcție din fila Funcții (salvată local în browser până există suport API).',
        functionPlaceholder: 'Selectează o funcție'
      },
      details: {
        roleTitle: 'Detalii rol',
        membersWithRole: 'Membri cu acest rol',
        membersWithAssignment: 'Membri cu acest titlu de job',
        noMembers: 'Niciun membru de afișat.',
        moreMembers: '…și încă {{count}}.'
      },
      columns: {
        role: 'Rol',
        description: 'Descriere',
        isAdmin: 'Rol admin',
        permissions: 'Permisiuni',
        customCodes: 'Coduri custom',
        updated: 'Actualizat',
        actions: 'Acțiuni',
        headcount: 'Efectiv',
        linkedFunction: 'Funcție'
      },
      functions: {
        add: 'Adaugă funcție',
        addTitle: 'Funcție nouă',
        editTitle: 'Editează funcția',
        detailsTitle: 'Detalii funcție',
        intro:
          'Funcțiile descriu tipuri de job (ex. Vânzări, Inginerie). Potrivește numele funcției cu titlul de job al membrilor pentru efectiv.',
        nameLabel: 'Nume funcție',
        headcountTooltip:
          'Număr de membri al căror titlu de job coincide cu numele acestei funcții (fără sensibilitate la majuscule).',
        deleteConfirm:
          'Ștergi această funcție? Legăturile din roluri către această funcție sunt eliminate.',
        columns: {
          name: 'Funcție',
          description: 'Descriere',
          codename: 'Cod',
          updated: 'Actualizat'
        },
        messages: {
          created: 'Funcție creată',
          updated: 'Funcție actualizată',
          deleted: 'Funcție ștearsă'
        },
        api: {
          createSuccess: 'Funcție creată',
          updateSuccess: 'Funcție actualizată',
          deleteSuccess: 'Funcție ștearsă'
        }
      },
      addRole: 'Adaugă rol',
      nameLabel: 'Nume rol',
      codenameLabel: 'Nume cod',
      codenamePlaceholder: 'Opțional; generat din nume dacă e gol',
      descriptionLabel: 'Descriere',
      permissionsLabel: 'Permisiuni',
      permissionsPickerLabel: 'Permisiuni',
      permissionsPickerPlaceholder: 'Caută și selectează permisiuni',
      customPermissionsLabel: 'Coduri permisiuni custom',
      customPermissionsHelp:
        'Coduri opționale pentru verificări specifice produsului (ex. feature flags). Sunt salvate cu rolul și apar în matricea de mai jos.',
      customPermissionDuplicate:
        'Codurile custom duplicate nu sunt permise pe același rol.',
      customPermissionCodePlaceholder: 'ex: contacts.read, reports.export',
      customPermissionCodeRequired: 'Codul permisiunii este obligatoriu',
      customPermissionCodeInvalid:
        'Folosește litere mici, cifre, puncte, cratime sau underscore (max 64 caractere)',
      addCustomPermission: 'Adaugă cod permisiune',
      editPermissions: 'Editează permisiuni',
      editPermissionsTitle: 'Editează permisiuni',
      editApiPermissions: 'Editează permisiuni',
      editApiPermissionsTitle: 'Editează permisiunile rolului',
      deleteConfirm:
        'Ștergi acest rol? Membrii afectați trec la rolul implicit.',
      adminProtected: 'Protejat',
      adminBadge: 'Admin',
      system: 'Sistem',
      builtIn: 'Predefinit',
      api: {
        createSuccess: 'Rol creat',
        updateSuccess: 'Rol actualizat',
        deleteSuccess: 'Rol șters'
      },
      rolesTableTitle: 'Roluri',
      matrix: {
        sectionTitle: 'Matrice rol → permisiune',
        description:
          'Permisiuni API la nivel de organizație și coduri custom pe rol. Rolurile de admin includ implicit fiecare rând.',
        permission: 'Permisiune',
        customCodeBadge: 'Custom',
        customCodeHint: 'Nu e permisiune API; aplicată în aplicațiile tale.',
        adminTooltip: 'Rolurile de admin primesc automat toate permisiunile.',
        noRoles: 'Nu există roluri de afișat.',
        noPermissions: 'Nu s-au încărcat permisiuni de organizație.'
      }
    },
    security: {
      sectionTitle: 'Securitate',
      sectionDescription:
        'Politica de autentificare, metode de sign-in și SSO / SCIM enterprise pentru workspace.',
      tabs: {
        policy: 'Politică',
        signIn: 'Metode de sign-in',
        customProviders: 'Provideri personalizați'
      },
      apiPolicyNotice:
        'Acest formular de politică folosește date mock. MFA, regulile de invitație și setările JIT nu sunt încă expuse în acest API. Folosește fila Metode de sign-in pentru configurare live a workspace-ului.',
      saved: 'Politica de securitate a fost salvată',
      missingPolicy: 'Nu există politică de securitate pentru acest workspace.',
      authMethods: 'Metode de sign-in permise',
      mfaPolicy: 'Politica MFA',
      invitePolicy: 'Politica de invitații',
      jitProvisioning: 'Provisioning JIT din SSO',
      method: {
        password: 'Parolă',
        google: 'Google',
        microsoft: 'Microsoft',
        sso: 'SSO enterprise'
      },
      mfa: {
        optional: 'Opțional',
        requiredAdmins: 'Obligatoriu pentru admini',
        requiredAll: 'Obligatoriu pentru toți'
      },
      invite: {
        inviteOnly: 'Doar cu invitație',
        domainRestricted: 'Restricționat pe domeniu',
        open: 'Join deschis (domenii de încredere)'
      },
      policyCardTitle: 'Politică de autentificare',
      savePolicy: 'Salvează politica'
    },
    customProviders: {
      title: 'Provideri personalizați de identitate',
      description:
        'Conectează acest workspace la propriul tău provider OIDC, OAuth 2.0 sau SAML 2.0. Fiecare provider devine o opțiune de sign-in pentru membrii workspace-ului.',
      addProvider: 'Adaugă provider',
      editProvider: 'Editează provider',
      empty: 'Niciun provider personalizat încă.',
      deleteConfirm:
        'Ștergi providerul "{{name}}"? Membrii legați vor pierde această opțiune de sign-in.',
      protocols: {
        oidc: 'OpenID Connect',
        oauth2: 'OAuth 2.0',
        saml2: 'SAML 2.0'
      },
      sections: {
        connection: 'Conexiune',
        claimMapping: 'Mapare claim-uri'
      },
      columns: {
        name: 'Nume',
        slug: 'Slug',
        protocol: 'Protocol',
        enabled: 'Activat',
        actions: 'Acțiuni'
      },
      actions: {
        edit: 'Editează',
        delete: 'Șterge'
      },
      fields: {
        name: 'Nume afișat',
        slug: 'Slug (identificator URL)',
        logo: 'Logo',
        logoNone: 'Fără logo (icon implicit)',
        logoPreset: 'Folosește un preset',
        logoPresetPick: 'Alege presetul',
        logoUrl: 'URL personalizat',
        logoUrlInput: 'URL logo',
        logoUrlHelp:
          'Link direct către un SVG, PNG sau JPG (ex. https://cdn.example.com/logo.svg).',
        logoPreview: 'Previzualizare:',
        slugInvalid:
          'Slug-ul trebuie să înceapă cu o literă și să conțină doar litere mici, cifre, cratime sau underscore.',
        slugHelp:
          'Folosit în URL-urile de callback. Nu poate fi modificat după creare.',
        protocol: 'Protocol',
        enabled: 'Activat pentru sign-in',
        clientId: 'Client ID',
        clientSecret: 'Client secret',
        clientSecretHelp: 'Lasă gol pentru a păstra secretul existent.',
        scope: 'Scope',
        issuerUrl: 'Issuer URL',
        issuerUrlHelp:
          'URL-ul de bază al providerului OIDC cu suport pentru /.well-known/openid-configuration.',
        authorizeUrl: 'Authorize URL',
        authorizeUrlOptional:
          'Authorize URL (opțional, descoperit prin issuer)',
        tokenUrl: 'Token URL',
        tokenUrlOptional: 'Token URL (opțional, descoperit prin issuer)',
        userinfoUrl: 'Userinfo URL',
        userinfoUrlOptional: 'Userinfo URL (opțional, descoperit prin issuer)',
        jwksUrl: 'JWKS URL',
        jwksUrlOptional: 'JWKS URL (opțional, descoperit prin issuer)',
        samlEntityId: 'IdP entity ID',
        samlSsoUrl: 'SSO URL (HTTP-Redirect binding)',
        samlSloUrl: 'URL single logout (opțional)',
        samlX509Cert: 'Certificat de semnare IdP (PEM)',
        samlX509CertHelp:
          'Certificatul public folosit de IdP pentru semnarea assertion-urilor. Lipește întregul bloc PEM.',
        emailClaim: 'Claim pentru email',
        firstNameClaim: 'Claim pentru prenume',
        lastNameClaim: 'Claim pentru nume'
      },
      messages: {
        created: 'Provider creat',
        updated: 'Provider actualizat',
        deleted: 'Provider șters'
      }
    },
    authentication: {
      sectionTitle: 'Autentificare',
      sectionDescription:
        'Controlează cum se conectează membrii la acest workspace — metode de conectare, provideri personalizați și politica de autentificare.',
      previewTag: 'Previzualizare',
      activeUsersTooltip_one:
        '{{count}} utilizator activ folosește această metodă',
      activeUsersTooltip_other:
        '{{count}} utilizatori activi folosesc această metodă',
      tabs: {
        signIn: 'Metode de conectare',
        customProviders: 'Provideri personalizați',
        policy: 'Politică'
      },
      summary: {
        title: 'Metode de autentificare',
        description:
          'Activează metodele integrate de mai jos sau adaugă un provider OIDC, OAuth 2.0 sau SAML 2.0 personalizat.',
        active: 'Activ',
        custom: 'Personalizat',
        ssoUsers: 'Utilizatori SSO'
      },
      providersCard: {
        title: 'Provideri de conectare',
        description:
          'Provideri pe care spațiul de lucru îi rulează cu propriile credențiale. Conectarea Google personală funcționează și fără ei.',
        setupGuide: 'Ghid de configurare →',
        builtInGroup: 'Metode integrate'
      },
      providers: {
        password: 'Parolă',
        passwordSubtitle: 'Email + parolă',
        emailOtp: 'OTP email',
        emailOtpSubtitle: 'Cod unic prin email',
        qrLogin: 'Cod QR',
        qrLoginSubtitle: 'Aprobare fără parolă din mobil',
        google: 'Google',
        googleSubtitle:
          'Propriul client OAuth Google — conectare limitată la organizația dvs.',
        entraid: 'Microsoft Entra ID',
        entraidSubtitle:
          'Propria aplicație Entra ID — conectare limitată la tenantul dvs.',
        apple: 'Apple',
        appleSubtitle: 'Propriul Service ID și cheie Apple',
        passkey: 'Passkey / WebAuthn',
        passkeySubtitle: 'Chei hardware, Touch ID, Windows Hello',
        appleTeamId: 'Team ID',
        apiPendingLabel: 'API în așteptare',
        apiPendingHint:
          'Endpoint-ul backend pentru acest provider nu este încă desfășurat — comutarea nu are efect.',
        needsSetupLabel: 'Necesită configurare',
        needsSetupHint:
          'Activat, dar credențialele lipsesc. Apasă pe roată pentru a finaliza configurarea.',
        mockOnlyLabel: 'Previzualizare',
        mockOnlyHint: 'Acest câmp nu este încă trimis către API.',
        setupGuide: 'Deschide ghidul de configurare',
        credentialsTitle: 'Credențiale',
        noConfigTitle: 'Funcționează fără configurare',
        noConfigGeneric:
          'Acest provider nu are configurare per-workspace. Activează-l sau dezactivează-l din listă.',
        noConfig: {
          password:
            'Conectarea cu parolă este nativă. Dezactiveaz-o doar după ce ai o conexiune SSO verificată.',
          passkey:
            'Passkey / WebAuthn se bazează pe înrolarea de către fiecare utilizator din profil — nu necesită configurare de admin.',
          email_otp:
            'OTP-ul prin email livrează un cod unic prin email. Endpoint-ul backend este în curs de implementare — această opțiune este în previzualizare.',
          qr_login:
            'Autentificarea cu cod QR permite membrilor să aprobe conectarea în browser din aplicația mobilă Skalx.'
        }
      },
      actions: {
        settings: 'Setări provider',
        save: 'Salvează modificările',
        reset: 'Resetează',
        setup: 'Deschide configurarea',
        viewInfo: 'Vezi detalii'
      },
      additionalSettings: {
        title: 'Setări suplimentare de autorizare',
        description:
          'Controale la nivel de workspace stocate în configurația de autentificare.',
        autoProvisionDefaultRole: 'Rol implicit',
        enforceSso: {
          title: 'Forțează SSO pentru toți membrii',
          description:
            'Dezactivează conectarea cu parolă după ce o conexiune SSO este verificată pentru fiecare membru. Parola rămâne disponibilă doar pentru recuperare.'
        },
        selfServiceJoin: {
          title: 'Permite cereri de înscriere autonome',
          description:
            'Utilizatorii cu un domeniu verificat pot cere să se alăture. Adminii aprobă din pagina Membri.'
        },
        autoProvision: {
          title: 'Provisioning automat de la providerii de identitate',
          description:
            'Când un utilizator se conectează prin SSO prima dată, contul este creat automat cu rolul implicit.'
        }
      },
      customProviders: {
        title: 'Provideri de identitate personalizați',
        description:
          'Conectează acest workspace la propriul provider OIDC, OAuth 2.0 sau SAML 2.0. Fiecare provider devine o opțiune de conectare pentru membri.',
        docs: 'Documente',
        add: 'Adaugă provider personalizat',
        addProvider: 'Adaugă provider personalizat',
        editProvider: 'Editează provider personalizat',
        addProviderHint: 'Conectează orice IdP OIDC, OAuth 2.0 sau SAML 2.0',
        createProvider: 'Creează provider',
        setupGuide: 'Ghid configurare OIDC →',
        emptyTitle: 'Niciun provider personalizat încă',
        emptyDescription:
          'Adaugă Auth0, Okta, Keycloak sau orice provider OIDC / SAML pentru ca membrii să se conecteze cu stack-ul tău existent.',
        searchPlaceholder: 'Caută după nume, slug sau issuer',
        noResultsTitle: 'Niciun provider nu corespunde căutării',
        noResultsDescription:
          'Nimic nu corespunde pentru „{{search}}". Șterge căutarea pentru a vedea toți providerii.',
        deleteConfirm:
          'Ștergi providerul "{{name}}"? Membrii asociați vor pierde această opțiune de conectare.',
        lastSyncLabel: 'Ultima actualizare',
        callbacksHint:
          'Copiază aceste URL-uri în lista de redirect-uri permise a providerului.',
        protocols: {
          oidc: 'OpenID Connect',
          oauth2: 'OAuth 2.0',
          saml2: 'SAML 2.0'
        },
        sections: {
          identity: 'Identitate',
          connection: 'Conexiune',
          attributeMapping: 'Mapare atribute',
          provisioning: 'Provisioning',
          callbackUrls: 'URL-uri callback',
          oidcAdvanced: 'Avansat — suprascrie OIDC discovery'
        },
        columns: {
          name: 'Nume',
          slug: 'Slug',
          protocol: 'Protocol',
          enabled: 'Activat'
        },
        actions: {
          edit: 'Editează provider',
          delete: 'Șterge',
          deleteProvider: 'Șterge provider',
          test: 'Testează conexiunea',
          rotate: 'Rotește secretul',
          audit: 'Vezi audit'
        },
        callbacks: {
          redirect: 'URI redirect',
          logout: 'URI logout',
          metadata: 'URL metadata'
        },
        fields: {
          displayName: 'Nume afișat',
          slug: 'Slug (identificator URL)',
          slugHelp:
            'Folosit în URL-urile de callback. Nu poate fi schimbat după creare.',
          slugInvalid:
            'Slug-ul trebuie să înceapă cu o literă și să conțină doar litere mici, cifre, cratime sau underscore-uri.',
          protocol: 'Protocol',
          enabled: 'Activat pentru conectare',
          logo: 'Logo',
          logoNone: 'Fără logo (scut implicit)',
          logoPreset: 'Folosește un preset',
          logoPresetPick: 'Logo preset',
          logoUrl: 'URL personalizat',
          logoUrlInput: 'URL logo',
          logoUrlHelp:
            'Link direct către un SVG, PNG sau JPG (ex: https://cdn.example.com/logo.svg).',
          logoPreview: 'Previzualizare:',
          clientId: 'Client ID',
          clientSecret: 'Client secret',
          clientSecretHelp: 'Lasă gol pentru a păstra secretul existent.',
          scope: 'Scope',
          issuerUrl: 'URL issuer',
          issuerUrlHelp:
            'URL-ul de bază al providerului OIDC cu suport /.well-known/openid-configuration.',
          authorizeUrl: 'URL Authorize',
          authorizeUrlOptional:
            'URL Authorize (opțional, descoperit din issuer)',
          tokenUrl: 'URL Token',
          tokenUrlOptional: 'URL Token (opțional, descoperit din issuer)',
          userinfoUrl: 'URL Userinfo',
          userinfoUrlOptional: 'URL Userinfo (opțional, descoperit din issuer)',
          jwksUrl: 'URL JWKS',
          jwksUrlOptional: 'URL JWKS (opțional, descoperit din issuer)',
          samlEntityId: 'ID entitate IdP',
          samlSsoUrl: 'URL SSO (binding HTTP-Redirect)',
          samlSloUrl: 'URL single logout (opțional)',
          samlX509Cert: 'Certificat de semnare IdP (PEM)',
          samlX509CertHelp:
            'Certificatul public folosit de IdP pentru semnarea aserțiunilor. Lipește blocul PEM complet.',
          emailClaim: 'Claim email',
          firstNameClaim: 'Claim prenume',
          lastNameClaim: 'Claim nume',
          provisioningOnFirstSignIn: 'La prima conectare'
        },
        provisioning: {
          jitTitle: 'Provisioning just-in-time',
          jitDescription: 'Creează utilizatorul automat cu rolul implicit.',
          approvalTitle: 'Cere aprobarea admin-ului',
          approvalDescription:
            'Conectările creează o cerere pe care un admin trebuie să o aprobe.',
          explicitTitle: 'Doar utilizatori pre-provizionați',
          explicitDescription:
            'Respinge conectările pentru utilizatorii care nu sunt deja în workspace.'
        },
        messages: {
          created: 'Provider personalizat creat',
          updated: 'Provider personalizat actualizat',
          deleted: 'Provider personalizat șters'
        }
      },
      policy: {
        shippingSoon: 'Politica de autentificare va fi disponibilă în curând.',
        shippingSoonDescription:
          'Câmpurile de mai jos previzualizează ce vei putea configura când va fi lansată.',
        password: {
          title: 'Politică parolă',
          minLength: 'Lungime minimă',
          reusePrevention: 'Prevenire reutilizare',
          maxAge: 'Vârstă maximă',
          characters_one: '{{count}} caracter',
          characters_other: '{{count}} caractere',
          noRestriction: 'Fără restricții',
          lastN_one: 'Ultima {{count}} parolă',
          lastN_other: 'Ultimele {{count}} parole',
          neverExpires: 'Nu expiră niciodată',
          days_one: '{{count}} zi',
          days_other: '{{count}} zile',
          requireUpper: 'Necesită majuscule',
          requireLower: 'Necesită minuscule',
          requireNumber: 'Necesită cifre',
          requireSymbol: 'Necesită simboluri',
          rejectLeaked: 'Respinge parole compromise (HIBP)'
        },
        mfa: {
          title: 'Politică MFA',
          requireMfaAdmins: 'Necesită MFA pentru proprietari și admini',
          requireMfaAll: 'Necesită MFA pentru toți membrii',
          allowSmsFallback: 'Permite SMS ca metodă de rezervă',
          requireWebAuthnOwners: 'Necesită WebAuthn pentru proprietari'
        },
        session: {
          title: 'Politică sesiune',
          idleTimeout: 'Timeout inactivitate',
          absoluteTimeout: 'Timeout absolut',
          minutes_one: '{{count}} minut',
          minutes_other: '{{count}} minute',
          days_one: '{{count}} zi',
          days_other: '{{count}} zile'
        }
      }
    },
    ssoScim: {
      sectionTitle: 'SSO / SCIM',
      sectionDescription:
        'Conexiuni SSO enterprise și sincronizare SCIM pentru acest workspace.',
      ssoTitle: 'Conexiuni SSO',
      scimTitle: 'Provisioning SCIM',
      ssoEmpty: 'Nicio conexiune SSO încă.',
      scimEmpty: 'Nicio conexiune SCIM configurată.',
      enabled: 'Activat',
      disabled: 'Dezactivat',
      scimProvider: 'Furnizor',
      scimStatus: 'Status',
      scimEndpoint: 'Endpoint',
      scimToken: 'Bearer token (ultimele patru)',
      scimGroupMapping: 'Mapare grup → rol',
      scimLastSync: 'Ultima sincronizare',
      columns: {
        name: 'Nume',
        provider: 'Furnizor',
        protocol: 'Protocol',
        domain: 'Domeniu email',
        status: 'Status',
        certRotated: 'Certificat rotit',
        actions: 'Acțiuni'
      },
      addConnection: 'Adaugă conexiune SSO',
      addScimConnection: 'Adaugă conexiune SCIM',
      addModalTitle: 'Adaugă conexiune SSO',
      providerLabel: 'Furnizor',
      protocolLabel: 'Protocol',
      domainLabel: 'Domeniu email',
      createSuccess: 'Conexiune SSO adăugată',
      protocol: {
        saml: 'SAML 2.0',
        oidc: 'OpenID Connect'
      },
      connectionStatus: {
        active: 'Activă',
        inactive: 'Inactivă'
      },
      actions: {
        activate: 'Activează',
        deactivate: 'Dezactivează',
        rotateCertificate: 'Rotește certificatul',
        remove: 'Elimină',
        syncNow: 'Rulează sincronizarea',
        rotateToken: 'Rotește tokenul',
        disconnect: 'Deconectează',
        enableScim: 'Activează SCIM'
      },
      confirmRemoveSso:
        'Elimini această conexiune SSO? Membrii care o folosesc pot fi afectați.',
      confirmDisconnectScim:
        'Deconectezi SCIM pentru acest workspace? Sincronizarea se oprește până la reactivare.',
      enableScimDrawerTitle: 'Activează SCIM',
      scimEndpointUrlLabel: 'URL de bază SCIM',
      messages: {
        ssoRemoved: 'Conexiune SSO eliminată',
        certificateRotated: 'Rotația certificatului a fost înregistrată',
        scimSynced: 'Sincronizarea directorului a fost finalizată',
        tokenRotated: 'Token SCIM rotit',
        scimDisconnected: 'SCIM deconectat',
        scimEnabled: 'SCIM activat'
      }
    },
    domains: {
      sectionTitle: 'Domenii',
      sectionDescription:
        'Domenii verificate și modul în care pot adera membri noi.',
      empty: 'Nicio regulă de domeniu încă.',
      verified: {
        yes: 'Verificat',
        no: 'În așteptare'
      },
      columns: {
        domain: 'Domeniu',
        mode: 'Politica de join',
        verified: 'Verificare',
        actions: 'Acțiuni'
      },
      mode: {
        allow_invite: 'Invitație cu email de domeniu',
        auto_join: 'Auto-join',
        claim_required: 'Claim / aprobare admin'
      },
      tableTitle: 'Reguli domeniu',
      addDomain: 'Adaugă domeniu',
      addModalTitle: 'Adaugă regulă domeniu',
      domainLabel: 'Domeniu',
      modeLabel: 'Politica de join',
      createSuccess: 'Regulă domeniu adăugată',
      verifyDomain: 'Marchează verificat',
      deleteDomain: 'Elimină',
      confirmDelete: 'Elimini această regulă de domeniu?',
      verifiedSuccess: 'Domeniu marcat ca verificat',
      deletedSuccess: 'Regulă domeniu eliminată'
    },
    auditPage: {
      sectionTitle: 'Jurnal de audit',
      sectionDescription:
        'Toate schimbările din workspace — căutabile, exportabile, păstrate 90 de zile.',
      empty: 'Niciun eveniment de audit pentru acest workspace.',
      noMatches: 'Niciun eveniment nu corespunde filtrelor curente.',
      openDetails: 'Deschide detaliile evenimentului {{event}}',
      actor: 'Actor',
      target: 'Țintă',
      searchPlaceholder: 'Caută evenimente…',
      dateRangeLabel: 'Interval de date',
      tabs: {
        events: 'Evenimente',
        exports: 'Exporturi'
      },
      filters: {
        allActions: 'Acțiune',
        allSeverities: 'Severitate',
        allApplications: 'Aplicație',
        allActors: 'Autor',
        allActorTypes: 'Tip autor',
        entityId: 'ID entitate',
        clear: 'Resetează'
      },
      toolbar: {
        events_one: '{{count}} eveniment',
        events_few: '{{count}} evenimente',
        events_other: '{{count}} de evenimente',
        refresh: 'Reîmprospătează'
      },
      actions: {
        export: 'Exportă'
      },
      exportModal: {
        title: 'Exportă jurnalul de audit',
        description:
          'Generează o arhivă descărcabilă cu evenimente de audit. Arhivele gata apar în lista de exporturi.',
        periodLabel: 'Perioadă',
        formatLabel: 'Format',
        formatCsv: 'CSV',
        formatXlsx: 'Excel (XLSX)',
        formatJsonl: 'JSON Lines',
        filtersLabel: 'Filtre care vor fi aplicate',
        filtersNone: 'Fără filtre — toate evenimentele din perioada selectată',
        filters: {
          service: 'Serviciu',
          search: 'Căutare',
          action: 'Acțiune',
          severity: 'Severitate',
          application_id: 'Aplicație',
          entity_type: 'Tip entitate',
          entity_id: 'ID entitate',
          actor_id: 'Actor'
        },
        submit: 'Solicită exportul',
        cancel: 'Anulează',
        queued: 'Export solicitat — va apărea în listă în curând.',
        viewExports: 'Vezi exporturile',
        failed: 'Nu am putut trimite exportul în coadă. Reîncearcă.'
      },
      exports: {
        empty: 'Niciun export încă — solicită unul din tabul Evenimente.',
        total_one: '{{count}} export',
        total_few: '{{count}} exporturi',
        total_other: '{{count}} de exporturi',
        refresh: 'Actualizează',
        filters: {
          allStatuses: 'Status',
          includeAppScoped: 'Include arhivele aplicațiilor'
        },
        columns: {
          period: 'Perioadă',
          format: 'Format',
          status: 'Status',
          requestedBy: 'Solicitat de',
          fileSize: 'Dimensiune',
          createdAt: 'Creat',
          actions: 'Acțiuni'
        },
        status: {
          pending: 'În așteptare',
          processing: 'Se procesează',
          ready: 'Gata',
          failed: 'Eșuat'
        },
        actions: {
          download: 'Descarcă',
          delete: 'Șterge'
        },
        bulk: {
          selected_one: '{{count}} selectat',
          selected_few: '{{count}} selectate',
          selected_other: '{{count}} de selectate',
          delete: 'Șterge selecția',
          clear: 'Elimină selecția'
        },
        confirmDeleteTitle: 'Ștergi acest export?',
        confirmDeleteContent:
          'Arhiva va fi eliminată și nu poate fi recuperată.',
        confirmBulkDeleteTitle: 'Ștergi exporturile selectate?',
        confirmBulkDeleteContent:
          '{{count}} arhive vor fi eliminate și nu pot fi recuperate.',
        deleteSuccess: 'Export șters.',
        bulkDeleteSuccess: 'Exporturile selectate au fost șterse.',
        deleteFailed: 'Nu am putut șterge exportul. Reîncearcă.',
        downloadFailed: 'Nu am putut descărca exportul. Reîncearcă.'
      },
      columns: {
        time: 'Timp',
        application: 'Aplicație',
        severity: 'Severitate',
        actor: 'Actor',
        action: 'Acțiune',
        description: 'Descriere',
        target: 'Țintă',
        scope: 'Domeniu',
        ip: 'IP'
      },
      pagination: {
        range: '{{from}}–{{to}} din {{total}}'
      }
    },
    orgRoles: {
      sectionTitle: 'Roluri și permisiuni',
      sectionDescription:
        'Definește rolurile organizației și accesul acordat de fiecare rol.',
      addRole: 'Adaugă rol',
      createRole: 'Creează rol',
      editRole: 'Editează rol',
      newRole: 'Rol nou',
      save: 'Salvează',
      saveChanges: 'Salvează modificările',
      cancel: 'Anulează',
      searchRoles: 'Caută roluri…',
      searchPermissions: 'Caută o permisiune…',
      permissionsAll: 'Toate',
      emptyRoles: {
        title: 'Niciun rol încă',
        description:
          'Creează primul tău rol personalizat pentru a controla accesul la spațiul de lucru.'
      },
      kpi: {
        workspaceRoles: 'Roluri în spațiul de lucru',
        customRoles: 'personalizate',
        permissionsCatalog: 'Catalog de permisiuni',
        appScopedRoles: 'Roluri la nivel de aplicație',
        permissionsFooter: '{{count}} resurse'
      },
      tabs: {
        roles: 'Roluri în spațiul de lucru',
        permissions: 'Catalog de permisiuni'
      },
      matrix: {
        title: 'Matrice permisiuni',
        description:
          'Rolurile spațiului de lucru grupează permisiuni. Rolurile owner și admin acordă tot; rolurile predefinite sunt fixate de platformă.',
        moduleColumn: 'Modul/Resursă',
        hint: 'Modificările se aplică tuturor membrilor cu acest rol.',
        reset: 'Resetează modificările',
        adminHasFullAccess:
          'Rolurile admin primesc toate permisiunile spațiului de lucru.',
        grantsEverything: 'Toate permisiunile',
        needsViewFirst:
          'Acordă mai întâi permisiunea Vizualizare din categorie — celelalte se bazează pe ea.',
        noPermissions: 'Nicio permisiune',
        permissionsInMatrixHint: 'Permisiunile se acordă în matrice, nu aici.'
      },
      columns: {
        role: 'Rol',
        type: 'Tip',
        permissions: 'Permisiuni',
        actions: 'Acțiuni'
      },
      types: {
        owner: 'Owner',
        admin: 'Admin',
        custom: 'Personalizat',
        builtin: 'Predefinit',
        workspace: 'Spațiu de lucru',
        app: 'Aplicație'
      },
      groups: {
        builtin: 'Predefinite · spațiu de lucru',
        custom: 'Personalizate · spațiu de lucru',
        app: 'La nivel de aplicație'
      },
      filters: {
        all: 'Toate',
        granted: 'Acordate',
        denied: 'Refuzate'
      },
      actions: {
        edit: 'Editează',
        duplicate: 'Duplică',
        replaceAndDelete: 'Înlocuiește și șterge',
        delete: 'Șterge',
        assign: 'Atribuie',
        selectAll: 'Selectează tot',
        clear: 'Golește'
      },
      form: {
        name: 'Numele rolului',
        namePlaceholder: 'ex: Revizor de conformitate',
        codename: 'Cod',
        codenameHelp:
          'Identificator opțional folosit de cod (ex: sales_manager).',
        description: 'Descriere',
        descriptionPlaceholder:
          'Acces doar în citire la jurnalele de audit și evenimentele de securitate.',
        permissions: 'Permisiuni',
        permissionsPlaceholder: 'Caută și selectează permisiuni',
        permissionsAdminTooltip:
          'Rolurile admin primesc automat toate permisiunile.',
        permissionsGeneral: 'General'
      },
      messages: {
        created: 'Rol creat',
        updated: 'Rol actualizat',
        deleted: 'Rol șters',
        replaced: 'Membri reasignați și rol eliminat',
        permissionsUpdated: 'Permisiuni actualizate'
      },
      detail: {
        membersWithRole: 'Membri cu acest rol',
        noMembers: 'Niciun membru încă.',
        permissions: 'Permisiuni',
        ownerSubtitle:
          'Rol de owner · acordă toate permisiunile, inclusiv pe cele viitoare',
        permissionsSummary: '{{granted}} din {{total}} permisiuni active',
        roleId: 'ID rol',
        builtinNotice: 'Rolurile predefinite nu pot fi editate.',
        duplicateToCustomize: 'Duplică pentru a personaliza →',
        ownerNotice:
          'Rolul Owner acordă automat toate permisiunile, inclusiv pe cele adăugate ulterior.',
        adminAppNotice:
          'Rolurile admin primesc automat toate permisiunile pentru domeniul lor ({{scope}}).',
        scopeWorkspace: 'spațiul de lucru',
        scopeApp: 'această aplicație',
        emptySelection:
          'Selectează un rol pentru a-i vedea detaliile și permisiunile.',
        permissionsGroupAll: 'Toate {{group}}',
        permissionsGroupCount: '{{granted}}/{{total}}'
      },
      permission: {
        catalogTitle: 'Catalog de permisiuni',
        catalogDescription:
          'Toate permisiunile definite de platformă pentru acest spațiu de lucru. Rolurile le grupează; catalogul în sine este fix.',
        categoryLabel: 'Categorie',
        allCategories: 'Toate categoriile',
        categories: {
          organization: 'Spațiu de lucru',
          users: 'Membri',
          roles: 'Roluri',
          groups: 'Grupuri',
          applications: 'Aplicații',
          attachments: 'Atașamente',
          audit: 'Audit'
        },
        rolesUsing_one: '{{count}} rol',
        rolesUsing_few: '{{count}} roluri',
        rolesUsing_other: '{{count}} de roluri',
        empty: 'Nicio permisiune în acest spațiu de lucru încă.',
        codeLabel: 'Cod',
        labelLabel: 'Etichetă',
        builtinTag: 'Predefinită',
        usedByRoles: 'Folosită de'
      },
      deleteConfirmTitle: 'Șterge „{{name}}"?',
      deleteConfirmDescription:
        'Acest rol va fi eliminat. Membrii care îl au trebuie mutați mai întâi pe alt rol.',
      archiveConfirmTitle: 'Înlocuiește și șterge „{{name}}"?',
      archiveConfirmDescription:
        '{{count}} membri au în prezent acest rol. Alege un rol de înlocuire.',
      selectRole: 'Selectează un rol...',
      archiveAndReassign: 'Reasignează și șterge',
      archiveReassignWarning:
        'Toți {{count}} membri vor fi reasignați rolului „{{role}}".'
    },
    roleDetail: {
      members: 'Membri',
      created: 'Creat',
      edit: 'Editează',
      membersWithRole: 'Membri cu acest rol',
      searchMembers: 'Caută membri...',
      teamsWithRole: 'Echipe care acordă acest rol',
      noTeams: 'Nicio echipă nu acordă acest rol.',
      revokeTeamConfirm:
        'Retragi acest rol de la echipă? Membrii ei îl pierd, cu excepția celor care îl dețin și personal.',
      memberColumns: {
        name: 'Nume',
        email: 'Email',
        team: 'Echipă',
        source: 'Acordat prin',
        assigned: 'Asignat'
      },
      source: {
        personal: 'Personal',
        group: 'Grup',
        viaGroupHint: 'Rol obținut prin apartenența la grupul „{{group}}”.',
        viaGroupHintUnknown: 'Rol obținut prin apartenența la un grup.'
      }
    },
    settings: {
      sectionTitle: 'Setări',
      sectionDescription: 'Gestionează configurația spațiului de lucru',
      general: 'General',
      workspaceName: 'Numele spațiului de lucru',
      domain: 'Domeniu',
      save: 'Salvează modificările',
      saved: 'Setări salvate cu succes',
      savedFields: 'Câmpuri salvate: nume, domeniu, logo',
      auditChanges: 'Audit modificări',
      auditChangesPreview: 'Istoricul modificărilor nu este conectat încă.',
      changeDomain: 'Schimbă domeniul',
      domainLockedHint:
        'Domeniul workspace-ului este blocat. Apasă "Schimbă domeniul" pentru a-l debloca cu o confirmare.',
      domainUnlockedNotice:
        'Editarea domeniului este deblocată. Modificările se aplică la Salvare și vor strica URL-urile de login existente.',
      domainConfirmTitle: 'Schimbi domeniul workspace-ului?',
      domainConfirmDescription:
        'Tastează domeniul curent pentru a debloca editarea pentru "{{name}}".',
      domainConfirmWarning:
        'Schimbarea domeniului strică URL-urile de conectare, magic links și orice integrare externă care îl referențiază. Anunță membrii înainte de a salva.',
      domainConfirmButton: 'Deblochează editarea',
      descriptionLabel: 'Descriere',
      descriptionHelp:
        'Opțional. Afișată în selectorul de spații și pe pagina publică de conectare.',
      descriptionPlaceholder: 'Descriere scurtă a acestui spațiu',
      languages: {
        default: 'Limbă implicită',
        defaultHelp:
          'Membrii noi și cei fără o preferință salvată încep în această limbă.',
        enabled: 'Limbi activate',
        enabledHelp:
          'Doar aceste limbi sunt oferite membrilor în setările profilului.',
        enabledRequired: 'Activați cel puțin o limbă.',
        defaultMustBeEnabled:
          'Limba implicită trebuie să fie una dintre limbile activate.',
        placeholder: 'Selectați limbile'
      },
      branding: {
        title: 'Branding',
        scope: 'Se aplică paginilor de conectare și email-urilor',
        recommended: 'Recomandate',
        primaryColor: 'Culoare primară',
        signInBackground: 'Fundal pagină conectare',
        signInBackgroundHint:
          'PNG sau JPG, până la 2 MB. Imaginea umple panoul de conectare și poate fi decupată.',
        bgSolid: 'Uniform',
        bgGradient: 'Gradient',
        bgImage: 'Imagine',
        dragDrop: 'Trage fișierul aici sau apasă pentru a încărca',
        fileTypes: 'Orice imagine, până la 5 MB · SVG până la {{svgSize}} MB',
        fileTooLarge: 'Imaginea trebuie să fie mai mică de 5 MB',
        pickerHint:
          'Imagine sau gradient · umple panoul de conectare și poate fi decupat.',
        configure: 'Configurează',
        apply: 'Aplică',
        upload: 'Încarcă',
        change: 'Schimbă',
        remove: 'Elimină',
        emailFromName: 'Nume "de la" pentru email',
        poweredByTitle: 'Afișează badge-ul "Powered by Skalx"',
        poweredByDescription:
          'Vizibil pe paginile de conectare. Disponibil pe Business și mai sus; ascuns pe Enterprise.'
      },
      danger: {
        deleteTitle: 'Șterge acest spațiu',
        deleteDescription: 'Șterge permanent acest spațiu și toate datele.',
        deleteWarning: 'Nu poate fi anulată.',
        deleteWarningBlock:
          'Fiecare utilizator, rol, aplicație, eveniment audit și cheie API va fi șters definitiv.',
        deleteButton: 'Șterge workspace',
        deleteConfirmTitle: 'Șterge workspace',
        deleteConfirmDescription:
          'Tastează numele spațiului "{{name}}" pentru a confirma ștergerea permanentă.',
        transferTitle: 'Transferă proprietatea',
        transferDescription:
          'Predă acest spațiu de lucru altui membru. Tu rămâi administrator.',
        transferButton: 'Transferă proprietatea',
        transferMemberLabel: 'Noul proprietar',
        transferMemberPlaceholder: 'Alege un membru',
        transferConfirmDescription:
          'Va primi control complet asupra spațiului de lucru, inclusiv facturare și ștergere. Tu păstrezi accesul de administrator, dar nu poți anula singur această acțiune.',
        transferSuccess: '{{name}} este acum proprietarul spațiului de lucru',
        acting: 'Acțiune asupra:'
      },
      footer: {
        created: 'Creat {{date}}'
      },
      dangerZone: 'Zonă periculoasă',
      deleteSuccess: 'Spațiu de lucru șters cu succes',
      typeToConfirm: 'Tastează „{{name}}" pentru a confirma',
      demoDataSection: 'Date demo',
      demoDataDescription:
        'Gestionează datele demonstrative din acest workspace',
      recreateDemoDataTitle: 'Recreează datele demo',
      recreateDemoDataDescription:
        'Generează date demonstrative folosind presetul de industrie selectat. Înregistrările existente pot fi suprascrise.',
      recreateDemoData: 'Recreează',
      recreateDemoDataConfirmTitle: 'Recreează datele demo',
      recreateDemoDataConfirmDescription:
        'Alege ce tip de date demo vrei să creezi pentru acest workspace.',
      clearDemoDataTitle: 'Șterge datele demo',
      clearDemoDataDescription:
        'Elimină înregistrările demo din toate serviciile conectate (CRM, HRM etc.). Structura workspace-ului, membrii și setările rămân intacte.',
      clearDemoData: 'Șterge',
      clearDemoDataConfirmTitle: 'Ștergi datele demo?',
      clearDemoDataConfirmDescription:
        'Înregistrările demo (candidați, oportunități, contacte și alte entități exemplu) vor fi eliminate definitiv din fiecare serviciu conectat.',
      clearDemoDataWarning: 'Înregistrările demo vor fi șterse definitiv',
      demoDataBuildStarted: 'Construirea datelor demo a început',
      demoDataNothingToCreate:
        'Nu este nimic de creat pentru acest tip de date demo în acest spațiu de lucru',
      demoDataNothingToClear:
        'Nu există date demo de șters în acest spațiu de lucru',
      demoDataIndustryLabel: 'Tip date demo',
      demoDataIndustryRequired: 'Te rugăm să alegi un tip de date demo',
      demoDataInstallMissingAppsLabel: 'Adaugă mai întâi aplicațiile lipsă',
      demoDataInstallMissingAppsHint:
        'Activează această opțiune dacă datele demo alese au nevoie de aplicații care nu există încă în acest workspace. În caz contrar, datele demo pentru aplicațiile lipsă vor fi omise.'
    }
  },
  workspaces: {
    membersCount_one: '{{count}} membru',
    membersCount_few: '{{count}} membri',
    membersCount_other: '{{count}} de membri',
    onboarding: {
      documentTitle: 'Configurează spațiul de lucru',
      creating: 'Creăm spațiul…',
      createWorkspace: 'Creează spațiul',
      backToWorkspace: 'Înapoi în spațiu',
      steps: {
        details: 'Detalii',
        template: 'Șablon',
        attribution: 'Cum ai aflat',
        invite: 'Invită membri',
        done: 'Gata'
      },
      details: {
        title: 'Configurează spațiul de lucru',
        iconLabel: 'Pictograma spațiului',
        iconUpload: 'Încarcă',
        iconChange: 'Înlocuiește',
        addressShort: 'Minimum {{min}}',
        iconPreview: 'Previzualizează imaginea',
        iconRemove: 'Elimină imaginea',
        iconHint:
          'PNG sau JPG până la {{max}}×{{max}} px, ori SVG. Ideal pătrate.',
        iconError: {
          format: 'Sunt acceptate doar imagini PNG, JPG și SVG.',
          dimensions:
            'Imaginea depășește {{max}}×{{max}} px. Redimensioneaz-o și încearcă din nou.',
          unreadable: 'Fișierul nu a putut fi citit ca imagine.'
        },
        nameLabel: 'Numele companiei',
        namePlaceholder: 'Introdu numele companiei…',
        addressLabel: 'Adresa companiei',
        addressPlaceholder: 'compania-ta',
        addressFree: 'Disponibilă',
        addressTaken: 'Ocupată',
        sizeLabel: 'Dimensiunea companiei'
      },
      join: {
        title: 'Compania ta este deja pe Skalx',
        subtitle:
          'Domeniul tău de e-mail aparține unui spațiu de lucru care există deja. Cere să fii primit, în loc să creezi un al doilea lângă el.',
        existingWorkspace: 'Spațiu de lucru existent',
        request: 'Cere acces',
        requested: 'Cerere trimisă',
        createInstead: 'Creează totuși un spațiu separat',
        pendingTitle: 'Așteptăm un administrator',
        pendingBody:
          'Un administrator al spațiului a fost notificat. Primești un e-mail imediat ce ia o decizie.',
        rejectedTitle: 'Refuzată'
      },
      companySize: {
        '1-10': '1–10',
        '11-50': '10+',
        '51-200': '50+',
        '201-1000': '200+'
      },
      template: {
        title: 'Vrei să adaugi date demo ca să explorezi platforma?',
        subtitle:
          'Alege industria ta pentru exemple relevante sau selectează „Generic”.',
        industryEyebrow: 'Industrie',
        priorityEyebrow: 'Prioritatea principală',
        clean: 'Spațiu curat'
      },
      priority: {
        deal_pipeline: 'Gestionez un pipeline de vânzări',
        stop_losing_deals: 'Nu mai pierd oportunități',
        automate_routine: 'Automatizez revenirile',
        forecast_revenue: 'Prognozez veniturile',
        customer_support: 'Răspund mai repede clienților',
        off_spreadsheets: 'Renunț la fișiere Excel',
        other: 'Altceva'
      },
      attribution: {
        title: 'Cum ai aflat de noi?',
        options: {
          google: 'Google',
          youtube: 'YouTube',
          linkedin: 'LinkedIn',
          reviews: 'Site-uri de recenzii',
          referral: 'Recomandare',
          ai_assistant: 'Asistent AI',
          event: 'Eveniment',
          press: 'Presă',
          other: 'Altceva'
        }
      },
      invite: {
        title: 'Invită echipa',
        emailPlaceholder: 'coleg@companie.com',
        addAnother: 'Adaugă altul',
        removeRow: 'Șterge rândul',
        skip: 'Sar peste',
        send: 'Trimite invitațiile',
        roles: {
          member: 'Membru',
          admin: 'Administrator',
          viewer: 'Vizitator — încă indisponibil'
        }
      },
      errors: {
        nameRequired: 'Numele spațiului este obligatoriu.',
        handleTooShort: 'Adresa companiei are nevoie de minim 3 caractere.',
        sizeRequired: 'Alege dimensiunea companiei.',
        industryRequired:
          'Alege o industrie sau un spațiu curat — asta decide ce se încarcă mai departe.',
        priorityRequired: 'Alege prioritatea principală.',
        authRequired: 'Lasă activă cel puțin o metodă de conectare.',
        googleClientIdRequired:
          'Google SSO are nevoie de un client ID, altfel nimeni nu se poate conecta prin el.',
        inviteInvalid: 'Una dintre adresele de email nu este validă.'
      },
      done: {
        titleWorking: 'Se pregătește spațiul „{{name}}”',
        title: 'Spațiul „{{name}}” este gata',
        open: 'Deschide spațiul',
        setupRunning: 'Se pregătește mediul (se încarcă datele demo)',
        setupFinished: 'Mediul este gata',
        setupView: 'Detalii',
        copyLink: 'Copiază linkul',
        linkCopied: 'Link copiat',
        copyFailed: 'Linkul nu a putut fi copiat.',
        profileFailed:
          'Spațiul există, dar răspunsurile tale nu au putut fi salvate, așa că nimic nu a fost configurat pe baza lor. Poți genera datele demo din setările spațiului.',
        invitesFailed: 'Unele invitații nu au putut fi trimise.',
        photoFailed:
          'Imaginea spațiului nu a putut fi atașată. O poți încărca din nou în setările spațiului.',
        authFailed:
          'Metodele de conectare nu au fost aplicate complet. Finalizează în Autentificare.',
        build: {
          members: 'Membri',
          steps: 'Ce se configurează',
          activity: 'Activitate recentă',
          starting: 'Se pune în coadă',
          ready: 'Gata — poți deschide',
          failed: 'Unii pași nu s-au finalizat',
          preparing: 'Pregătim spațiul',
          writing: 'se scrie…',
          status: {
            queued: 'în coadă',
            running: 'în curs',
            done: 'gata',
            failed: 'eșuat',
            skipped: 'omis'
          },
          stepNames: {
            roles: 'Roluri și permisiuni',
            signIn: 'Metode de conectare',
            apps: 'Aplicații',
            members: 'Membri și acces',
            demoData: 'Date demo'
          },
          industry: 'Domeniu',
          priority: 'Obiectiv principal',
          demoSkipped: 'Datele demo au fost omise — spațiul este gol',
          byYourChoice: 'alegerea ta',
          emptyTitle: 'Spațiul este gol — începe cu prima înregistrare',
          emptyBody:
            'Importă-ți datele sau adaugă o tranzacție manual · datele demo pot fi generate mai târziu',
          emptyAction: 'Importă'
        },
        checks: {
          created: 'Spațiul {{name}} a fost creat',
          owner: 'Ești proprietarul acestui spațiu',
          authMethods: 'Metode de conectare active: {{count}}',
          template: 'Aplicații activate, date generate din șablonul {{preset}}',
          cleanWorkspace: 'Spațiu curat — nu s-au încărcat date demo',
          invites: 'Invitații trimise: {{count}}',
          noInvites: 'Nicio invitație trimisă'
        },
        cards: {
          steps: '{{count}} pași',
          crm: {
            title: 'Configurează CRM',
            badge: 'Recomandat',
            body: 'Adu pipeline-ul real și conectează canalele pe care clienții le folosesc deja.',
            items: {
              import: 'Importă datele existente',
              pipeline: 'Definește pipeline-ul de oportunități',
              messengers: 'Conectează mesageriile',
              email: 'Conectează emailul și calendarul'
            }
          },
          workspace: {
            title: 'Configurează spațiul',
            body: 'Adu echipa, stabilește cine ce poate face și activează SSO și MFA.',
            items: {
              invite: 'Invită echipa',
              roles: 'Roluri și permisiuni',
              auth: 'Autentificare și securitate',
              settings: 'Setările spațiului'
            }
          }
        }
      },
      preview: {
        activity: 'Activitate recentă',
        nav: {
          workspace: 'Spațiu',
          home: 'Acasă',
          overview: 'Prezentare',
          identity: 'Identitate',
          users: 'Utilizatori',
          organization: 'Organizație',
          roles: 'Roluri',
          authentication: 'Autentificare',
          applications: 'Aplicații',
          apps: 'Aplicații',
          agents: 'Agenți',
          compliance: 'Conformitate',
          audit: 'Jurnal de audit',
          graph: 'Graficul companiei',
          settings: 'Setări',
          workspaceSettings: 'Setările spațiului'
        },
        meta: {
          primaryDomain: 'Domeniu principal',
          created: 'Creat',
          today: 'Astăzi',
          yourRole: 'Rolul tău',
          owner: 'proprietar'
        },
        stats: {
          title: 'Statistici spațiu',
          members: 'Membri',
          apps: 'Aplicații',
          roles: 'Roluri',
          authMethods: 'Metode de conectare'
        },
        greeting: {
          morning: 'Bună dimineața, {{name}}.',
          afternoon: 'Bună ziua, {{name}}.',
          evening: 'Bună seara, {{name}}.'
        }
      },
      spotlight: {
        name: {
          label: 'Numele companiei',
          why: 'titlul pe care îl vede toată echipa'
        },
        logo: {
          label: 'Pictograma spațiului',
          why: 'plăcuța din meniul lateral și din lista de aplicații'
        },
        handle: {
          label: 'Adresa companiei',
          why: 'adresa la care se conectează echipa'
        },
        domain: {
          label: 'Domeniu principal',
          why: 'identifică spațiul oriunde'
        },
        template: {
          label: 'Aplicații',
          why: 'industria decide ce intră în datele demo'
        },
        security: {
          label: 'Metode de conectare',
          why: 'se pot modifica ulterior în Autentificare'
        },
        members: { label: 'Membri', why: 'persoanele invitate apar aici' },
        role: { label: 'Rolul tău', why: 'proprietar — control complet' }
      }
    },
    pageTitle: 'Spații de lucru',
    backToList: 'Înapoi la listă',
    accessDenied: {
      noAccess: {
        title: 'Cont greșit',
        description:
          'Contul cu care ești conectat nu are acces la acest workspace. Conectează-te cu un alt cont pentru a continua.',
        switchAccount: 'Conectează-te cu un alt cont',
        backToWorkspaces: 'Mergi la workspace-urile tale'
      },
      insufficientRole: {
        title: 'Nu ai acces la această secțiune',
        description:
          'Nu ai permisiunea cerută de această secțiune. Cere unui administrator al spațiului de lucru să ți-o acorde.',
        goToSection: 'Mergi la {{section}}'
      }
    },
    create: {
      title: 'Creează workspace',
      description:
        'Adaugă nume, domeniu și un preset demo opțional. Folosește aceeași configurare ca la adăugarea unei organizații din panou.',
      submit: 'Creează workspace',
      backToDetails: 'Înapoi la detalii',
      auth: {
        applyFailed:
          'Workspace-ul a fost creat, dar metodele de autorizare nu au putut fi aplicate complet. Poți finaliza setarea din Workspace Settings.'
      },
      demoDataFailed:
        'Workspace-ul a fost creat, dar datele demo nu au putut fi importate. Poți folosi workspace-ul oricum.',
      submitFailedSwitchedStep:
        'Workspace-ul nu a putut fi creat. Verifică câmpul evidențiat de la pasul anterior.',
      steps: {
        details: 'Detalii workspace',
        authorization: 'Autorizare'
      },
      template: {
        label: 'Șablon workspace',
        withBuiltIn: 'Workspace cu aplicații built-in și setup demo',
        clean: 'Workspace curat (fără aplicații built-in)',
        builtInPreset: 'Preset aplicații built-in'
      },
      authorization: {
        methodsLabel: 'Metode de autorizare',
        methodsHint:
          'Activați cel puțin o opțiune de autentificare pentru acest workspace.',
        customTitle: 'Provideri custom de autorizare',
        customEmpty:
          'Încă nu există provideri custom. Adăugați unul dacă acest workspace are nevoie de o configurare enterprise dedicată.',
        atLeastOneMethod:
          'Cel puțin o metodă de autentificare trebuie să rămână activă pentru acest workspace.',
        password: 'Login + parolă'
      },
      invite: {
        stepTitle: 'Invită membri',
        title: 'Invită-ți echipa',
        description:
          'Adaugă membri pentru a începe. Poți invita și mai târziu.',
        byEmail: 'Invită prin email',
        emailPlaceholder: 'Introdu adresa de email',
        selectRole: 'Selectează rolul',
        defaultRole: 'Rol implicit',
        chipPlaceholder: 'Introdu email…',
        chipPlaceholderMore: 'Adaugă alt email…',
        chipHint:
          'Apasă Enter, virgulă sau Tab pentru a adăuga. Lipește o listă pentru a adăuga mai multe deodată.',
        invalidEmails: 'Email-uri invalide ignorate: {{emails}}',
        add: 'Adaugă',
        pending: 'Invitații în așteptare ({{count}})',
        orgRole: {
          admin: 'Administrator',
          employee: 'Angajat'
        },
        appRoles: 'Roluri pe aplicații',
        appRolesHint:
          'Atribuie un rol pentru fiecare aplicație pe care o va folosi membrul.',
        noApplications: 'Nu există aplicații disponibile în acest workspace.',
        skipForNow: 'Omite deocamdată',
        sendAndFinish: 'Trimite invitații și finalizează',
        sent: 'Trimise {{count}} invitații',
        sendFailed:
          'Workspace-ul a fost creat, dar unele invitații nu au putut fi trimise.'
      }
    }
  },
  workspaceSwitcher: {
    placeholder: 'Schimbă workspace-ul',
    ariaLabel: 'Workspace activ'
  },
  workspaceAuth: {
    personalMethodsTitle:
      'Metode personale de autentificare în acest workspace',
    personalMethodsDescription:
      'Conectează sau deconectează metodele contului personal pentru workspace-ul "{{workspace}}".'
  },
  account: {
    settings: {
      pageTitle: 'Setări cont',
      pageSubtitle:
        'Gestionați profilul, metodele de autentificare și preferințele. Creați sau alăturați-vă workspace-uri din secțiunea Spații de lucru când sunteți gata.',
      navAriaLabel: 'Secțiuni setări cont'
    },
    menu: {
      basic: 'Profil de bază',
      authentication: 'Autentificare',
      audit: 'Audit',
      security: 'Securitate',
      connectedAccounts: 'Conturi conectate',
      notifications: 'Notificări',
      sessions: 'Sesiuni și dispozitive'
    },
    section: {
      personal: 'Profil de bază',
      personalDescription:
        'Vizualizați și actualizați datele de contact și informațiile personale.',
      authentication: 'Autentificare',
      authenticationDescription:
        'Gestionați metodele de autentificare conectate și politicile de securitate.',
      audit: 'Audit',
      auditDescription:
        'Revizuiți activitatea recentă și evenimentele de securitate ale contului.',
      security: 'Securitate',
      notifications: 'Notificări',
      notificationsDescription:
        'Controlați ce notificări primiți și revizuiți activitatea recentă.',
      connectedAccounts: 'Conturi conectate',
      sessions: 'Sesiuni și dispozitive',
      sessionsDescription:
        'Vizualizați sesiunile active pe dispozitivele dvs. și revocați accesul când este necesar.'
    },
    authentication: {
      mfa: {
        title: 'Autentificare multi-factor',
        description:
          'Solicită un pas suplimentar de verificare la autentificare pentru a-ți proteja mai bine contul.',
        toggle: 'Activează MFA',
        regenerateBackupCodes: 'Regenerează codurile backup',
        downloadBackupCodes: 'Descarcă codurile backup'
      },
      providers: {
        password: 'Parolă',
        google: 'Google',
        apple: 'Apple'
      },
      connectedAccounts: {
        title: 'Metode de autentificare conectate',
        disconnect: 'Deconectează',
        required: 'Necesar',
        link: 'Conectează',
        linkProvider: 'Conectează {{provider}}',
        setPassword: 'Setează parola',
        notLinked: 'Neconectat'
      },
      setPassword: {
        title: 'Setează parola',
        description:
          'Creează o parolă pentru a te putea autentifica și cu email și parolă.',
        newPassword: 'Parolă nouă',
        confirmPassword: 'Confirmă parola',
        submit: 'Setează parola',
        passwordRequired: 'Parola este obligatorie',
        confirmRequired: 'Vă rugăm confirmați parola',
        passwordsMustMatch: 'Parolele nu coincid'
      },
      security: {
        title: 'Politică de autentificare',
        allowPassword: 'Permite autentificarea cu parolă',
        allowSocial: 'Permite autentificarea socială',
        refreshTokenLifetimeDays: 'Durată token refresh (zile)',
        trustedDeviceDays: 'Valabilitate dispozitiv de încredere (zile)'
      }
    },
    messages: {
      settingsSaved: 'Setările de securitate au fost actualizate',
      passwordSet: 'Parola a fost setată cu succes',
      providerLinked: 'Provider conectat cu succes',
      providerUnlinked: 'Provider deconectat cu succes',
      outlookConnected: 'Outlook a fost conectat cu succes',
      outlookDisconnected: 'Outlook a fost deconectat cu succes',
      gmailConnected: 'Gmail a fost conectat cu succes',
      gmailDisconnected: 'Gmail a fost deconectat cu succes',
      sessionRevoked: 'Sesiune revocată',
      sessionsRevoked: 'Toate celelalte sesiuni au fost revocate',
      passkeyAdded: 'Passkey înregistrat',
      passkeyRemoved: 'Passkey eliminat',
      passkeyAborted: 'Înregistrarea passkey a fost anulată',
      passkeyAlreadyRegistered:
        'Acest dispozitiv este deja înregistrat ca passkey',
      recoveryRegenerated: 'Coduri de recuperare noi generate',
      trustRevoked: 'Încrederea a fost retrasă de pe dispozitiv'
    },
    securityCenter: {
      pageDescription:
        'Întărește contul cu passkeys, coduri de recuperare și dispozitive de încredere. Schimbarea parolei se aplică autentificării pe email.',
      policyHint:
        'Dispozitivele de încredere rămân recunoscute {{days}} zile (setat și la Autentificare → Politică de autentificare, „Valabilitate dispozitiv de încredere”).',
      passkeys: {
        title: 'Passkeys',
        description:
          'Passkeys îți permit să te autentifici fără parolă, cu biometrie sau cheie de securitate.',
        add: 'Adaugă passkey',
        addTitle: 'Înregistrează un passkey',
        nameLabel: 'Nume afișat',
        namePlaceholder: 'ex. MacBook Touch ID',
        delete: 'Elimină',
        deleteConfirm:
          'Elimini acest passkey? Nu vei mai putea folosi acest passkey la autentificare.',
        empty:
          'Niciun passkey încă. Adaugă unul pentru autentificare mai sigură.',
        columns: {
          name: 'Nume',
          credential: 'Credential',
          platform: 'Platformă',
          added: 'Adăugat',
          lastUsed: 'Ultima utilizare',
          actions: 'Acțiuni'
        },
        platform: {
          web: 'Web',
          mobile: 'Mobil'
        }
      },
      recovery: {
        title: 'Coduri de recuperare',
        description:
          'Dacă pierzi accesul la MFA, folosește un cod de recuperare unic. Păstrează codurile în siguranță; fiecare merge o dată.',
        remaining: '{{count}} coduri rămase',
        none: 'Nu ai generat încă coduri de recuperare.',
        mfaDisabled:
          'Activează autentificarea în doi pași pentru a folosi codurile de recuperare.',
        regenerate: 'Generează coduri noi',
        regenerateWarning:
          'Toate codurile existente devin invalide imediat. Salvează noile coduri înainte de a închide.',
        modalTitle: 'Salvează codurile de recuperare',
        modalDescription:
          'Aceste coduri nu vor mai fi afișate. Copiază-le într-un manager de parole sau tipărește-le.',
        copy: 'Copiază toate',
        download: 'Descarcă',
        copied: 'Copiat în clipboard',
        done: 'Gata'
      },
      trustedDevices: {
        title: 'Dispozitive de încredere',
        description:
          'Dispozitivele marcate ca de încredere pot sări peste unele solicitări MFA până la expirare. Sunt separate de sesiunile active.',
        columns: {
          device: 'Dispozitiv',
          trustedAt: 'Marcat la',
          lastUsed: 'Ultima utilizare',
          actions: 'Acțiuni'
        },
        revoke: 'Retrage încrederea',
        revokeConfirm:
          'Acest dispozitiv va trebui să se verifice complet la următoarea autentificare. Continui?',
        unknownDevice: 'Dispozitiv necunoscut',
        empty: 'Niciun dispozitiv de încredere înregistrat.'
      },
      password: {
        title: 'Parolă',
        description:
          'Actualizează parola pentru autentificarea pe email. Din motive de securitate, verificăm cererea înainte să alegi o parolă nouă.',
        changeDescription: 'Introduceți parola curentă și alegeți una nouă.',
        currentPassword: 'Parola curentă',
        newPassword: 'Parolă nouă',
        confirmPassword: 'Confirmă parola nouă',
        changeButton: 'Schimbă parola',
        currentPasswordRequired: 'Parola curentă este obligatorie',
        passwordRequired: 'Parola este obligatorie',
        confirmRequired: 'Vă rugăm confirmați parola',
        passwordsMustMatch: 'Parolele nu coincid',
        passwordChanged: 'Parola a fost schimbată cu succes',
        forgotPassword: 'Ați uitat parola?',
        requestHint:
          'Îți trimitem un link securizat pe email. Este posibil să fie nevoie să confirmi cu MFA.',
        requestButton: 'Trimite link de resetare pe email',
        requestSent:
          'Verifică emailul pentru linkul care finalizează schimbarea parolei.',
        noPasswordMethod:
          'Nu ai parolă Skalx pe acest cont (de ex. folosești doar social sau SSO). Gestionează credențialele la furnizor sau adaugă email/parolă la Autentificare.'
      }
    },
    avatar: {
      change: 'Schimbă avatarul',
      upload_title: 'Încarcă avatar',
      upload_description: 'Trage și plasează fișierele aici',
      upload_select: 'selectează',
      upload_hint: 'Acceptă încărcarea unui singur fișier',
      save: 'Salvează',
      delete: 'Șterge',
      only_images: 'Sunt permise doar fișiere imagine',
      upload_success: 'Avatar actualizat cu succes',
      delete_success: 'Avatar eliminat cu succes',
      card_title: 'Avatar',
      card_description: 'Încarcă o imagine de profil pentru contul tău.',
      zoom: 'Zoom',
      rotate: 'Rotire',
      svg_no_crop:
        'Fișierele vectoriale sunt încărcate așa cum sunt, fără decupare.'
    },
    notifications: {
      description:
        'Controlează ce evenimente din cont te notifică și cât de des.',
      activityTitle: 'Activitate recentă a contului',
      bell: {
        title: 'Notificări',
        markAllRead: 'Marchează toate ca citite',
        markedAllRead: 'Toate notificările au fost marcate ca citite',
        empty: 'Nu există notificări'
      },
      preferences: {
        title: 'Preferințe',
        categoryColumn: 'Categorie',
        saveSuccess: 'Preferințe salvate',
        rows: {
          roleChanged: 'Rol schimbat',
          roleReplaced: 'Rol înlocuit',
          securityNotification: 'Alerte de securitate',
          workspaceInvite: 'Invitații workspace',
          supportReply: 'Răspunsuri suport',
          auditExport: 'Export jurnal audit',
          crmActivity: 'Activitate CRM',
          hrmActivity: 'Activitate HRM'
        },
        channels: {
          email: 'Email',
          push: 'Push',
          internal: 'În aplicație'
        }
      }
    },
    audit: {
      description:
        'Revizuiește schimbările importante la nivel de cont, cum ar fi providerii conectați, actualizările de securitate și acțiunile asupra sesiunilor.',
      empty: 'Nu există încă evenimente de audit.',
      noMatches: 'Niciun eveniment nu corespunde filtrelor curente.',
      actor: 'Actor',
      target: 'Țintă',
      searchPlaceholder: 'Caută evenimente',
      dateRangeLabel: 'Interval de date',
      filters: {
        allApplications: 'Aplicație',
        allEventTypes: 'Tip eveniment',
        allSeverities: 'Severitate',
        clear: 'Resetează',
        startDate: 'Data de început',
        endDate: 'Data de sfârșit'
      },
      toolbar: {
        events_one: '{{count}} eveniment',
        events_few: '{{count}} evenimente',
        events_other: '{{count}} de evenimente',
        refresh: 'Reîmprospătează'
      },
      columns: {
        time: 'Timp',
        event: 'Eveniment',
        application: 'Aplicație',
        description: 'Descriere',
        severity: 'Severitate',
        ip: 'IP'
      }
    },
    sessions: {
      description:
        'Revizuiește dispozitivele active și revocă sesiunile în care nu mai ai încredere.',
      columns: {
        device: 'Dispozitiv',
        workspace: 'Workspace',
        location: 'Locație',
        lastActive: 'Ultima activitate',
        status: 'Status',
        actions: 'Acțiuni'
      },
      noWorkspace: 'Account',
      current: 'Curentă',
      currentHint:
        'Aceasta este sesiunea curentă. Deconectează-te din meniul din antet.',
      active: 'Activă',
      revoked: 'Revocată',
      revoke: 'Revocă',
      revokeConfirm:
        'Revoci această sesiune? Dispozitivul va fi deconectat imediat.',
      revokeCurrentConfirm:
        'Revoci sesiunea curentă? Vei fi deconectat de pe acest dispozitiv.',
      revokeOidcConfirm:
        'Revoci sesiunea pentru {{name}}? Va trebui să te autentifici din nou din acea aplicație.',
      revokeAllOther: 'Revocă toate celelalte sesiuni',
      revokeAllOtherConfirm:
        'Revoci toate celelalte sesiuni? Toate celelalte dispozitive vor fi deconectate.',
      empty: 'Nicio sesiune activă',
      kind: {
        oidc: 'Aplicație terță'
      },
      authMethod: {
        password: 'Parolă',
        google: 'Google',
        entraid: 'Microsoft',
        apple: 'Apple',
        email_otp: 'Cod email',
        passkey: 'Passkey',
        qr_login: 'Cod QR'
      },
      messages: {
        revoked: 'Sesiunea a fost revocată',
        revokedAll: 'Toate celelalte sesiuni au fost revocate'
      }
    }
  },
  edit: 'Editează',
  personal_details: 'Date personale',
  personal_details_description: 'Informațiile tale personale pentru facturare',
  phone: 'Telefon',
  address_information: 'Informații adresă',
  address_information_description: 'Detaliile adresei tale de facturare',
  address: 'Adresă',
  country_state: 'Țară / Stat',
  town_city: 'Oraș',
  postal_code: 'Cod poștal',
  data_save_success: 'Datele au fost salvate cu succes',
  save: 'Salvează',
  please_input: 'Vă rugăm să completați câmpul',
  cancel: 'Anulare',
  soon: 'În curând',
  invalid_email: 'Email invalid',
  please_select_organization: 'Vă rugăm să selectați o organizație',
  organizations: {
    header: 'Organizații',
    users: 'utilizatori'
  },
  created_on: 'Creat pe',
  roles: {
    admin: 'Administrator',
    employee: 'Angajat',
    owner: 'Proprietar'
  },
  go_to_management_dashboard: 'Mai departe la dashboard',
  no_results: 'Niciun rezultat',
  for_the: 'pentru',
  delete: 'Șterge',
  total: 'Total',
  user: 'Utilizator',
  last_activity: 'Ultima activitate',
  job_title: 'Funcție',
  role: 'Rol',
  teams: 'Echipe',
  all: 'Toate',
  offline: 'Deconectat',
  online: 'Conectat',
  search: 'Căutare',
  filters: 'Filtre',
  more_filters: 'Mai multe filtre',
  reset: 'Reseteaza',
  apply: 'Aplica',
  actions: 'Acțiuni',
  filtering_by: 'Filtre aplicate',
  clear_all: 'Șterge tot',
  entity_selected: '{{count}} {{entity}} selectate',
  count_selected: '{{count}} selectate',
  deselect: 'Deselectează',
  clear_selection: 'Anulează selecția',
  more_actions: 'Mai multe',
  view: 'Vizualizare',
  contact_information: 'Informații de contact',
  contact_information_description: 'Detalii despre contactul persoanei',
  personal_information: 'Informații personale',
  personal_information_description: 'Detalii personale ale persoanei',
  role_information: 'Informații despre rol',
  role_information_description: 'Detalii despre rolul persoanei',
  position: 'Funcție',
  about_me: 'Despre mine',
  linkedin_url: 'LinkedIn',
  role_information_updated: 'Informațiile despre rol au fost actualizate',
  profile: 'Profil',
  change_password: 'Schimbă parola',
  new_password: 'Parolă nouă',
  password_change_success: 'Parola a fost schimbată cu succes',
  current_password: 'Parola actuală',
  information_updated_success: 'Informațiile au fost actualizate cu succes',
  enter_your_initial_email: 'Introduceți emailul inițial',
  add_organization: 'Creează workspace',
  name: 'Nume',
  domain_name: 'Nume de domeniu',
  input_placeholder: 'Introduceți aici...',
  organization_add_success: 'Organizația a fost adăugată cu succes',
  deleted_success: 'Șters cu succes',
  delete_organization_confirmation:
    'Sunteți sigur că doriți să ștergeți organizația?',
  confirm: 'Confirmă',
  settings: 'Setări',
  column_settings_title: 'Coloane',
  column_settings_configure: 'Configurează coloanele',
  column_settings_customize: 'Personalizează coloanele',
  table_settings: 'Setări tabel',
  column_settings_reset: 'Resetează',
  column_settings_search: 'Caută un câmp',
  column_settings_shown: 'Afișate',
  column_settings_hidden: 'Ascunse',
  column_settings_hide_all: 'Ascunde tot',
  column_settings_show_all: 'Afișează tot',
  column_settings_not_found: 'Niciun câmp găsit',
  column_settings_pin_left: 'Fixează la stânga',
  column_settings_pin_right: 'Fixează la dreapta',
  column_settings_unpin: 'Anulează fixarea',
  column_settings_move: 'Mută',
  apps: 'Aplicații',
  workspaceSettingsTabs: {
    general: 'General',
    authorization: 'Autorizare',
    mockNotice:
      'Acest tab este momentan mock, inspirat din pattern-uri de setări din aplicații SaaS exemplu.',
    automation: {
      tab: 'Automatizare',
      title: 'Automatizare și provisioning',
      items: {
        provisioning: 'Provisioning automat utilizatori (SCIM)',
        lifecycle: 'Politică de lifecycle pentru workspace',
        directory: 'Programare sincronizare director'
      }
    },
    audit: {
      tab: 'Audit și conformitate',
      title: 'Controale de audit și conformitate',
      items: {
        retention: 'Politică de retenție pentru audit log-uri',
        alerting: 'Alerte pentru acces suspect',
        exports: 'Exporturi programate pentru conformitate'
      }
    },
    generalDangerZone: {
      title: 'Zonă periculoasă',
      description:
        'Șterge definitiv acest workspace. Această acțiune nu poate fi anulată.',
      deleteAction: 'Șterge workspace'
    }
  },
  organization_info: 'Informații despre organizație',
  organization_info_description:
    'Detalii de bază despre organizație afișate în sistem.',
  authMethods: {
    title: 'Metode de autentificare',
    description:
      'Controlează parola și social sign-in pentru organizație, activează șabloane de federare când ai nevoie și adaugă provideri complet personalizați.',
    existingProvidersTitle: 'Provideri de sign-in',
    existingProvidersDescription:
      'Metodele built-in se sincronizează cu API-ul organizației. Șabloanele de federare și providerii personalizați folosesc stocare locală de previzualizare până la endpoint-uri backend.',
    builtInProvidersSubtitle: 'Metode built-in',
    federationProvidersSubtitle: 'Șabloane de federare',
    federationProvidersDescription:
      'Șabloane IdP precompletate. Activează un șablon doar când îl folosești, apoi completează credențialele și endpoint-urile.',
    customProvidersCardTitle: 'Provideri personalizați',
    customProvidersCardDescription:
      'Adaugă conexiuni OIDC, OAuth2 sau SAML 2.0 proprii. Fiecare provider se deschide în drawer pentru configurare completă.',
    addCustomProviderTitle: 'Adaugă provider personalizat',
    editCustomProviderTitle: 'Editează provider personalizat',
    clientProvidersTitle: 'Provideri client personalizați',
    clientProvidersDescription:
      'Adaugă provideri externi de autorizare utilizați de aplicațiile client.',
    customProvider: 'Provider personalizat',
    addProvider: 'Adaugă provider',
    selectProviderPlaceholder: 'Selectați șablonul de provider',
    addFromCatalog: 'Adaugă providerul selectat',
    addCustomProvider: 'Adaugă provider personalizat',
    catalog: {
      google: 'Google',
      entra: 'Microsoft Entra ID',
      magicLink: 'Magic Link',
      github: 'GitHub',
      apple: 'Apple',
      oktaSaml: 'Okta SAML'
    },
    protocol: 'Protocol',
    scope: 'Scope',
    issuerUrl: 'Issuer URL',
    jwksUrl: 'JWKS URL',
    authorizeUrl: 'Authorize URL',
    tokenUrl: 'Token URL',
    additionalSettings: 'Setări suplimentare de autorizare',
    additionalSettingsDescription:
      'Aceste setări sunt controale la nivel de client și sunt salvate ca configurație de workspace.',
    enforceSso: 'Aplică SSO pentru toți membrii',
    enforceSsoHint:
      'Când este activat, membrii se pot autentifica doar prin furnizorul SSO configurat. Parola și alte metode de autentificare sunt dezactivate pentru toți, cu excepția proprietarilor workspace-ului.',
    allowSelfServiceJoin: 'Permite cereri de alăturare self-service',
    allowSelfServiceJoinHint:
      'Când este activat, utilizatorii cu un email verificat care corespunde domeniului workspace-ului pot solicita alăturarea fără invitație. Administratorii aprobă în continuare fiecare cerere.',
    autoProvisionUsers:
      'Provisioning automat utilizatori din identity providers',
    autoProvisionUsersHint:
      'Când este activat, conturile sunt create automat la prima autentificare a unui utilizator printr-un identity provider configurat, folosind datele de profil din IdP.',
    defaultRole: 'Rol implicit pentru utilizatorii provizionați',
    roles: {
      member: 'Membru',
      admin: 'Administrator',
      viewer: 'Viewer'
    },
    password: 'Parolă',
    emailOtp: 'Email OTP',
    qrLogin: 'Cod QR',
    google: 'Google',
    entraid: 'Entra ID',
    apple: 'Apple',
    passkey: 'Passkey / WebAuthn',
    setupInstructionsTitle: 'Instrucțiuni de configurare',
    docsLabel: 'Documentație de configurare:',
    openDocs: 'Deschide ghidul',
    redirectUrlsTitle: 'URL-uri redirect autorizate',
    accountAppRedirectUrls: 'Account UI',
    platformWebRedirectUrls: 'EBS Platform Web',
    backendApiRedirectUrls:
      'Backend API (același URL funcționează pentru toate organizațiile)',
    mailboxRedirectUrls: 'Conectare cutie poștală — integrare Outlook',
    googleSetupHint:
      'Creați un OAuth 2.0 Client ID (Web application), apoi introduceți mai jos Client ID și Client secret.',
    entraidSetupHint:
      'Creați o înregistrare de aplicație Microsoft Entra, apoi introduceți mai jos Client ID, Client secret și Tenant ID. Adăugați ambele URL-uri de redirect la platforma Web — al doilea este folosit de integrarea cutiei poștale Outlook.',
    clientId: 'Client ID',
    clientSecret: 'Secret client',
    tenantId: 'Tenant ID',
    teamId: 'Team ID',
    keyId: 'Key ID',
    appleServiceId: 'Service ID',
    applePrivateKey: 'Private Key (PEM)',
    appleSetupHint:
      'Creați un Sign in with Apple Service ID în contul Apple Developer, apoi introduceți mai jos Service ID, cheia privată (PEM), Team ID și Key ID.',
    leaveEmptyToKeep: 'Lăsați gol pentru a păstra secretul actual',
    leaveEmptyToKeepKey: 'Lăsați gol pentru a păstra cheia curentă'
  },
  profileAuthMethods: {
    tab: 'Metodele mele de autentificare',
    defaultMethods: 'Metode implicite (sistem)',
    defaultMethodsDescription:
      'Folosite pentru a vă autentifica în cont, independent de organizație.',
    perOrganization: 'Pe organizație',
    perOrganizationDescription:
      'Metode activate pentru fiecare organizație; conectați-vă pentru a le folosi la autentificare.',
    no_organizations: 'Nu aveți organizații.',
    linked: 'Conectat',
    not_linked: 'Neconectat',
    change_password: 'Schimbă parola',
    link: 'Conectează',
    unlink: 'Deconectează',
    unlinkConfirmTitle: 'Deconectați Google?',
    unlinkConfirmContent:
      'Nu veți mai putea să vă autentificați cu Google pentru acest cont.',
    connectSuccess: 'Contul Google a fost conectat cu succes.',
    connectCallbackMissingParams:
      'Răspuns invalid de la Google. Încercați din nou.',
    unlinkConfirmTitleEntraid: 'Deconectați Microsoft?',
    unlinkConfirmContentEntraid:
      'Nu veți mai putea să vă autentificați cu Microsoft pentru acest cont.',
    connectSuccessEntraid: 'Contul Microsoft a fost conectat cu succes.',
    unlinkConfirmTitleApple: 'Deconectați Apple?',
    unlinkConfirmContentApple:
      'Nu veți mai putea să vă autentificați cu Apple pentru acest cont.',
    loadError:
      'Nu s-au putut încărca metodele de autentificare pentru această organizație.',
    retry: 'Reîncearcă',
    noMethodsConfigured:
      'Nu există încă metode de autentificare configurate pentru această organizație.',
    noEnabledMethods:
      'Nu există metode de autentificare active pentru această organizație.',
    enabled: 'Activ',
    disabled: 'Inactiv',
    managedByOrganization: 'Gestionat din setările organizației'
  },
  logo: 'Logo',
  change: 'Schimbă',
  organization_name: 'Numele organizației',
  disable_success: 'Dezactivat cu succes',
  disable_user_confirmation:
    'Sunteți sigur că doriți să dezactivați utilizatorul?',
  disable: 'Dezactivează',

  pagination: {
    total: '{{from}} la {{to}} din {{total}} rezultate',
    range: '{{from}}–{{to}} din {{total}}'
  },
  organization_deleted: 'Organizația a fost ștearsă cu succes',
  no_organization_apps:
    'Nu s-au găsit aplicații pentru organizație, pentru a adăuga o aplicație, vă rugăm să vă conectați la ',
  management_dashboard: 'dashboard-ul de management.',
  only_upload_image: 'Puteți încărca doar fișiere imagine!',
  svgUpload: {
    tooLarge: 'Fișierul SVG trebuie să fie mai mic de {{size}} MB.',
    unreadable: 'Acest SVG nu a putut fi citit ca imagine.'
  },
  industry: 'Industrie',
  select_for_example_data: 'Selectați pentru date exemplu',
  please_select: 'Vă rugăm să selectați...',
  reset_data_in_applications: 'Resetați datele din aplicații',
  do_you_want_to_reset: 'Doriți să resetați?',
  do_you_want_to_reset_description:
    'Toate datele din toate aplicațiile vor fi resetate la starea lor implicită (conform industriei, dacă este cazul). Această operațiune nu poate fi anulată după confirmare.',
  we_are_preparing_your_data:
    'Pregătim tabloul tău de bord prin încărcarea datelor, configurarea și actualizarea informațiilor. Acest proces nu va dura mult, te rugăm să aștepți.',
  information: 'Informații',
  loading_data: 'Se încarcă datele',
  we_are_setting: 'Pregătim totul pentru tine. Nu va dura mult!',
  show_details: 'Arată detaliile',
  hide_details: 'Ascunde detaliile',
  demoPresets_healthcare_title: 'Sănătate',
  demoPresets_healthcare_description:
    'Soluții create pentru clinici, spitale și servicii medicale.',
  demoPresets_noData_title: 'Fără date',
  demoPresets_noData_description: 'Creează aplicație fără date demo.',
  demoPresets_generic_title: 'Generic',
  demoPresets_generic_description:
    'Presetare universală potrivită pentru diverse industrii.',
  demoPresets_education_title: 'Educație',
  demoPresets_education_description:
    'Instrumente și fluxuri pentru școli, universități și centre educaționale.',
  demoPresets_retail_title: 'Retail',
  demoPresets_retail_description:
    'Soluții pentru magazine și operațiuni de retail.',
  demoPresets_finance_title: 'Finanțe',
  demoPresets_finance_description:
    'Fluxuri orientate către servicii bancare și financiare.',
  healthcare: 'Sănătate',
  no_data: 'Fără date',
  generic: 'Generic',
  education: 'Educație',
  retail: 'Retail',
  finance: 'Finanțe',
  go_to_organization: 'Mergi la workspace',
  something_went_wrong: 'Ceva a mers prost',
  please_try_again: 'Vă rugăm să încercați din nou',
  retry: 'Reîncearcă',
  setup_completed: 'Configurare finalizată',
  setup_completed_description:
    'Configurarea organizației dvs. este completă și gata de utilizare.',
  in_progress: 'În progres',
  show_more: 'Afișează mai mult',
  show_less: 'Afișează mai puțin',
  demoPresets_informationTechnology_title: 'Tehnologia informației',
  demoPresets_informationTechnology_description:
    'Soluții și instrumente pentru dezvoltarea software, sisteme și infrastructură digitală.',
  information_technology: 'Tehnologia informației'
}

export default ro
